module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(64);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(65);

	var _index2 = _interopRequireDefault(_index);

	var _radio = __webpack_require__(80);

	var _radio2 = _interopRequireDefault(_radio);

	var _xInput = __webpack_require__(90);

	var _xInput2 = _interopRequireDefault(_xInput);

	var _xNumber = __webpack_require__(112);

	var _xNumber2 = _interopRequireDefault(_xNumber);

	var _cell = __webpack_require__(118);

	var _cell2 = _interopRequireDefault(_cell);

	var _inlineDesc = __webpack_require__(102);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	var _checklist = __webpack_require__(125);

	var _checklist2 = _interopRequireDefault(_checklist);

	var _xSwitch = __webpack_require__(139);

	var _xSwitch2 = _interopRequireDefault(_xSwitch);

	var _xTextarea = __webpack_require__(145);

	var _xTextarea2 = _interopRequireDefault(_xTextarea);

	var _group = __webpack_require__(151);

	var _group2 = _interopRequireDefault(_group);

	var _groupTitle = __webpack_require__(157);

	var _groupTitle2 = _interopRequireDefault(_groupTitle);

	var _box = __webpack_require__(160);

	var _box2 = _interopRequireDefault(_box);

	var _tip = __webpack_require__(131);

	var _tip2 = _interopRequireDefault(_tip);

	var _selector = __webpack_require__(164);

	var _selector2 = _interopRequireDefault(_selector);

	var _xButton = __webpack_require__(171);

	var _xButton2 = _interopRequireDefault(_xButton);

	var _swiper = __webpack_require__(177);

	var _swiper2 = _interopRequireDefault(_swiper);

	var _swiperItem = __webpack_require__(189);

	var _swiperItem2 = _interopRequireDefault(_swiperItem);

	var _sticky = __webpack_require__(195);

	var _sticky2 = _interopRequireDefault(_sticky);

	var _picker = __webpack_require__(202);

	var _picker2 = _interopRequireDefault(_picker);

	var _datetime = __webpack_require__(225);

	var _datetime2 = _interopRequireDefault(_datetime);

	var _popup = __webpack_require__(235);

	var _popup2 = _interopRequireDefault(_popup);

	var _actionsheet = __webpack_require__(242);

	var _actionsheet2 = _interopRequireDefault(_actionsheet);

	var _clocker = __webpack_require__(248);

	var _clocker2 = _interopRequireDefault(_clocker);

	var _popupPicker = __webpack_require__(254);

	var _popupPicker2 = _interopRequireDefault(_popupPicker);

	var _xAddress = __webpack_require__(263);

	var _xAddress2 = _interopRequireDefault(_xAddress);

	var _toast = __webpack_require__(268);

	var _toast2 = _interopRequireDefault(_toast);

	var _loading = __webpack_require__(274);

	var _loading2 = _interopRequireDefault(_loading);

	var _xAlert = __webpack_require__(280);

	var _xAlert2 = _interopRequireDefault(_xAlert);

	var _confirm = __webpack_require__(292);

	var _confirm2 = _interopRequireDefault(_confirm);

	var _xProgress = __webpack_require__(298);

	var _xProgress2 = _interopRequireDefault(_xProgress);

	var _spinner = __webpack_require__(304);

	var _spinner2 = _interopRequireDefault(_spinner);

	var _calendar = __webpack_require__(312);

	var _calendar2 = _interopRequireDefault(_calendar);

	var _icon = __webpack_require__(96);

	var _icon2 = _interopRequireDefault(_icon);

	var _colorPicker = __webpack_require__(324);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	var _divider = __webpack_require__(330);

	var _divider2 = _interopRequireDefault(_divider);

	var _countup = __webpack_require__(335);

	var _countup2 = _interopRequireDefault(_countup);

	var _scroller = __webpack_require__(340);

	var _scroller2 = _interopRequireDefault(_scroller);

	var _shake = __webpack_require__(349);

	var _shake2 = _interopRequireDefault(_shake);

	var _search = __webpack_require__(354);

	var _search2 = _interopRequireDefault(_search);

	var _format = __webpack_require__(232);

	var _format2 = _interopRequireDefault(_format);

	var _masker = __webpack_require__(360);

	var _masker2 = _interopRequireDefault(_masker);

	var _countdown = __webpack_require__(367);

	var _countdown2 = _interopRequireDefault(_countdown);

	var _friendlyTime = __webpack_require__(371);

	var _friendlyTime2 = _interopRequireDefault(_friendlyTime);

	var _xHeader = __webpack_require__(372);

	var _xHeader2 = _interopRequireDefault(_xHeader);

	var _panel = __webpack_require__(378);

	var _panel2 = _interopRequireDefault(_panel);

	var _inlineCalendar = __webpack_require__(315);

	var _inlineCalendar2 = _interopRequireDefault(_inlineCalendar);

	var _badge = __webpack_require__(384);

	var _badge2 = _interopRequireDefault(_badge);

	var _xDialog = __webpack_require__(285);

	var _xDialog2 = _interopRequireDefault(_xDialog);

	var _card = __webpack_require__(390);

	var _card2 = _interopRequireDefault(_card);

	var _previewer = __webpack_require__(396);

	var _previewer2 = _interopRequireDefault(_previewer);

	var _numberRoller = __webpack_require__(410);

	var _numberRoller2 = _interopRequireDefault(_numberRoller);

	var _viewBox = __webpack_require__(415);

	var _viewBox2 = _interopRequireDefault(_viewBox);

	var _verifyCode = __webpack_require__(420);

	var _verifyCode2 = _interopRequireDefault(_verifyCode);

	var _buttonTab = __webpack_require__(426);

	var _buttonTab2 = _interopRequireDefault(_buttonTab);

	var _buttonTabItem = __webpack_require__(433);

	var _buttonTabItem2 = _interopRequireDefault(_buttonTabItem);

	var _checker = __webpack_require__(439);

	var _checker2 = _interopRequireDefault(_checker);

	var _checkerItem = __webpack_require__(445);

	var _checkerItem2 = _interopRequireDefault(_checkerItem);

	var _flexbox = __webpack_require__(210);

	var _flexbox2 = _interopRequireDefault(_flexbox);

	var _flexboxItem = __webpack_require__(216);

	var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

	var _tabbar = __webpack_require__(451);

	var _tabbar2 = _interopRequireDefault(_tabbar);

	var _tabbarItem = __webpack_require__(457);

	var _tabbarItem2 = _interopRequireDefault(_tabbarItem);

	var _tab = __webpack_require__(463);

	var _tab2 = _interopRequireDefault(_tab);

	var _tabItem = __webpack_require__(469);

	var _tabItem2 = _interopRequireDefault(_tabItem);

	var _keyboard = __webpack_require__(475);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	var _selectorList = __webpack_require__(485);

	var _selectorList2 = _interopRequireDefault(_selectorList);

	var _steps = __webpack_require__(492);

	var _steps2 = _interopRequireDefault(_steps);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var cvux = {
	  Radio: _radio2.default,
	  Group: _group2.default,

	  XInput: _xInput2.default,
	  GroupTitle: _groupTitle2.default,
	  XNumber: _xNumber2.default,
	  Checklist: _checklist2.default,

	  XSwitch: _xSwitch2.default,
	  Box: _box2.default,
	  Tip: _tip2.default,
	  Selector: _selector2.default,
	  SelectorList: _selectorList2.default,
	  Steps: _steps2.default,
	  Cell: _cell2.default,
	  InlineDesc: _inlineDesc2.default,
	  XButton: _xButton2.default,
	  XTextarea: _xTextarea2.default,
	  Flexbox: _flexbox2.default,
	  FlexboxItem: _flexboxItem2.default,
	  Tab: _tab2.default,
	  TabItem: _tabItem2.default,
	  Swiper: _swiper2.default,
	  SwiperItem: _swiperItem2.default,
	  Sticky: _sticky2.default,
	  Picker: _picker2.default,
	  Datetime: _datetime2.default,
	  Popup: _popup2.default,

	  Actionsheet: _actionsheet2.default,
	  Clocker: _clocker2.default,

	  PopupPicker: _popupPicker2.default,
	  XAddress: _xAddress2.default,
	  Toast: _toast2.default,
	  Loading: _loading2.default,
	  XAlert: _xAlert2.default,
	  Confirm: _confirm2.default,
	  XProgress: _xProgress2.default,

	  Spinner: _spinner2.default,
	  Calendar: _calendar2.default,
	  Icon: _icon2.default,

	  ColorPicker: _colorPicker2.default,

	  Divider: _divider2.default,

	  Countup: _countup2.default,
	  Scroller: _scroller2.default,
	  Shake: _shake2.default,

	  Search: _search2.default,
	  DateFormatter: _format2.default,
	  Masker: _masker2.default,
	  Countdown: _countdown2.default,
	  FriendlyTime: _friendlyTime2.default,
	  XHeader: _xHeader2.default,
	  Checker: _checker2.default,
	  CheckerItem: _checkerItem2.default,

	  Tabbar: _tabbar2.default,
	  TabbarItem: _tabbarItem2.default,
	  Panel: _panel2.default,
	  ButtonTab: _buttonTab2.default,
	  ButtonTabItem: _buttonTabItem2.default,
	  InlineCalendar: _inlineCalendar2.default,
	  Badge: _badge2.default,
	  XDialog: _xDialog2.default,
	  Card: _card2.default,
	  Previewer: _previewer2.default,
	  NumberRoller: _numberRoller2.default,
	  ViewBox: _viewBox2.default,
	  VerifyCode: _verifyCode2.default,
	  Keyboard: _keyboard2.default
	};

	cvux.install = function (Vue) {
	  for (var component in cvux) {
	    if (component === 'install') return;
	    console.log('component name: ', component);
	    Vue.component('Lx' + component, cvux[component]);
	  }
	};

	module.exports = cvux;

	module.exports.default = module.exports;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(66)

	var Component = __webpack_require__(79)(
	  /* script */
	  null,
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(67);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5a3d452b!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5a3d452b!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports
	exports.i(__webpack_require__(69), "");

	// module
	exports.push([module.id, "\r\n", ""]);

	// exports


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports
	exports.i(__webpack_require__(70), "");
	exports.i(__webpack_require__(71), "");
	exports.i(__webpack_require__(72), "");
	exports.i(__webpack_require__(73), "");
	exports.i(__webpack_require__(74), "");
	exports.i(__webpack_require__(75), "");
	exports.i(__webpack_require__(76), "");
	exports.i(__webpack_require__(77), "");

	// module
	exports.push([module.id, "", ""]);

	// exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "html {\r\n    -ms-text-size-adjust: 100%;\r\n    -webkit-text-size-adjust: 100%;\r\n}\r\n\r\nbody {\r\n    line-height: 1.6;\r\n    font-family: \"Helvetica Neue\",Helvetica,\"microsoft yahei\",Arial,sans-serif;\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\na img {\r\n    border: 0;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n", ""]);

	// exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/** \r\n* https://github.com/frozenui/frozenui/ \r\n* MIT License\r\n*/\r\n\r\n.vux-1px-t {\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n\r\n.vux-1px-b {\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.vux-1px-tb {\r\n  border-top: #e0e0e0 1px solid;\r\n  border-bottom: #e0e0e0 1px solid;\r\n  background-image: none;\r\n}\r\n\r\n.vux-1px-l {\r\n  border-left: 1px solid #e0e0e0;\r\n}\r\n\r\n.vux-1px-r {\r\n  border-right: 1px solid #e0e0e0;\r\n}\r\n\r\n.vux-1px {\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.vux-1px-radius {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 4px;\r\n}\r\n\r\n@media screen and (min-device-pixel-ratio: 2) {\r\n  .vux-1px-radius {\r\n    position: relative;\r\n    border: 0;\r\n  }\r\n\r\n  .vux-1px-radius:before {\r\n    content: \"\";\r\n    width: 200%;\r\n    height: 200%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border: 1px solid #e0e0e0;\r\n    transform: scale(0.5);\r\n    transform-origin: 0 0;\r\n    padding: 1px;\r\n    box-sizing: border-box;\r\n    border-radius: 8px;\r\n    pointer-events: none;\r\n  }\r\n}\r\n\r\n@media screen and (-webkit-min-device-pixel-ratio: 2) {\r\n  .vux-1px {\r\n    position: relative;\r\n    border: 0;\r\n  }\r\n\r\n  .vux-1px-t, .vux-1px-b, .vux-1px-l, .vux-1px-r, .vux-1px-tb {\r\n    border: 0;\r\n  }\r\n\r\n  .vux-1px-t {\r\n    background-position: left top;\r\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)); }\r\n\r\n  .vux-1px-b {\r\n    background-position: left bottom;\r\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)); }\r\n\r\n  .vux-1px-t,\r\n  .vux-1px-b,\r\n  .vux-1px-tb {\r\n    background-repeat: repeat-x;\r\n    -webkit-background-size: 100% 1px;\r\n  }\r\n\r\n  .vux-1px-tb {\r\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)), -webkit-gradient(linear, left top, left bottom, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0));\r\n    background-position: top, bottom;\r\n  }\r\n\r\n  .vux-1px-l {\r\n    background-position: left top;\r\n    background-image: -webkit-gradient(linear, right top, left top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)); }\r\n\r\n  .vux-1px-r {\r\n    background-position: right top;\r\n    background-image: -webkit-gradient(linear, left top, right top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)); }\r\n\r\n  .vux-1px-l,\r\n  .vux-1px-r {\r\n    background-repeat: repeat-y;\r\n    background-size: 1px 100%;\r\n  }\r\n\r\n  .vux-1px:after {\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)), -webkit-gradient(linear, left top, right top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)), -webkit-gradient(linear, left top, left bottom, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0)), -webkit-gradient(linear, right top, left top, color-stop(0.5, transparent), color-stop(0.5, #e0e0e0));\r\n    background-size: 100% 1px,1px 100% ,100% 1px, 1px 100%;\r\n    background-repeat: no-repeat;\r\n    background-position: top, right, bottom, left;\r\n    padding: 1px;\r\n    box-sizing: border-box;\r\n    z-index: 10;\r\n    pointer-events: none;\r\n  }\r\n}", ""]);

	// exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, ".vux-center-v, .vux-center-h, .vux-center {\r\n  display: flex;\r\n}\r\n\r\n.vux-center-v, .vux-center {\r\n  align-items: center;\r\n}\r\n\r\n.vux-center-h, .vux-center {\r\n  justify-content: center;\r\n}", ""]);

	// exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "@w: 37.5rem;\r\n.vux-reddot,.vux-reddot-border,.vux-reddot-s {\r\n  position: relative;\r\n}\r\n\r\n.vux-reddot:after,.vux-reddot-border:after,.vux-reddot-s:after {\r\n  content: '';\r\n  position: absolute;\r\n  display: block;\r\n  width: 8/@w;\r\n  height: 8/@w;\r\n  background-color: #f74c31;\r\n  border-radius: 5px;\r\n  right: -3/@w;\r\n  top: -3/@w;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.vux-reddot-border:before {\r\n  content: '';\r\n  position: absolute;\r\n  display: block;\r\n  width: 8/@w;\r\n  height: 8/@w;\r\n  background-color: #fff;\r\n  border-radius: 5px;\r\n  right: -4/@w;\r\n  top: -4/@w;\r\n  background-clip: padding-box;\r\n  padding: 1px;\r\n}\r\n\r\n.vux-reddot-s:after {\r\n  width: 6/@w;\r\n  height: 6/@w;\r\n  top: -5/@w;\r\n  right: -5/@w;\r\n}\r\n", ""]);

	// exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, ".vux-fade-transition {\r\n  opacity: 1;\r\n  transition: opacity linear 0.2s\r\n}\r\n\r\n.vux-fade-enter, .vux-fade-leave {\r\n  opacity: 0;\r\n}\r\n\r\n.vux-dialog-transition {\r\n  opacity: 1;\r\n  transition-duration: .4s;\r\n  transform: translate(-50%, -50%) scale(1)!important;\r\n  transition-property: transform, opacity!important;\r\n}\r\n\r\n.vux-dialog-enter, .vux-dialog-leave {\r\n  opacity: 0;\r\n}\r\n\r\n.vux-dialog-enter {\r\n  transform: translate(-50%, -50%) scale(1.185)!important;\r\n}\r\n\r\n.vux-dialog-leave {\r\n  transform: translate(-50%, -50%) scale(1)!important;\r\n}", ""]);

	// exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, ".vux-loading {\r\n  animation-duration: 0.6s;\r\n  animation-iteration-count: infinite;\r\n  animation-name: vux-loading;\r\n  animation-timing-function: linear;\r\n  border-radius: 99em;\r\n  border: 3px solid #DDD;\r\n  border-left-color: #666;\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-width: 2px;\r\n  display:table-cell;\r\n  vertical-align:middle;\r\n}\r\n\r\n@keyframes vux-loading {\r\n  from {\r\n    transform: rotate(0deg)\r\n  }\r\n  to {\r\n    transform: rotate(360deg)\r\n  }\r\n}", ""]);

	// exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "@w: 37.5rem;\r\n.vux-close {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 24/@w;\r\n  height: 24/@w;\r\n  overflow: hidden;\r\n  color: #ccc;\r\n  &::before,\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    height: 1px;\r\n    width: 100%;\r\n    top: 50%;\r\n    left: 0;\r\n    background: #98979d;\r\n  }\r\n  &::before {\r\n    transform: rotate(45deg);\r\n  }\r\n  &::after {\r\n    transform: rotate(-45deg);\r\n  }\r\n}\r\n\r\n/**\r\n--------custom line width and color----------\r\n.vux-close-2px{\r\n  &::before,\r\n  &::after {\r\n    height: 2px;\r\n    margin-top: -1px;\r\n    background-color: green;\r\n  }\r\n}\r\n*/\r\n", ""]);

	// exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, ".vux-tap-active {\r\n  tap-highlight-color: rgba(0,0,0,0);\r\n}\r\n.vux-tap-active:active {\r\n  background-color: #ECECEC;\r\n}\r\n\r\n", ""]);

	// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;

		if (media) {
			styleElement.setAttribute("media", media);
		}

		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}

	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }

	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports

	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }

	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }

	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }

	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _radio = __webpack_require__(81);

	var _radio2 = _interopRequireDefault(_radio);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_radio2.default.install = function (Vue) {
	  Vue.component('LxRadio', _radio2.default);
	};

	exports.default = _radio2.default;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(82)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(84),
	  /* template */
	  __webpack_require__(89),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d5d49598!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./radio.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d5d49598!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./radio.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_check_label {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_check {\n  position: absolute;\n  left: -9999em;\n}\n.weui_cells_radio .weui_cell_ft {\n  padding-left: 0.93333333rem;\n}\n.weui_cells_radio .weui_cell:active {\n  background-color: #ECECEC;\n}\n.weui_cells_radio .weui_check:checked + .weui_icon_checked:before {\n  display: block;\n  content: '\\EA08';\n  color: #5890ff;\n  font-size: 0.42666667rem;\n}\n.weui_cells_checkbox .weui_cell_hd {\n  padding-right: 0.4rem;\n}\n.weui_cells_checkbox .weui_icon_checked:before {\n  display: block;\n  width: 0.4rem;\n  height: 0.4rem;\n  content: \"\";\n  border: 1px solid #E9E9EB;\n  box-sizing: border-box;\n}\n.weui_cells_checkbox .weui_check:checked + .weui_icon_checked {\n  display: block;\n  background-color: #409eff;\n  width: 0.4rem;\n  height: 0.4rem;\n  position: relative;\n}\n.weui_cells_checkbox .weui_check:checked + .weui_icon_checked:before {\n  position: absolute;\n  left: 0.08rem;\n  top: 0.06666667rem;\n  content: \"\";\n  border-style: solid;\n  width: 0.26666667rem;\n  height: 0.16rem;\n  border-color: #fff #fff transparent transparent;\n  border-width: 2px;\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n.weui_label {\n  color: #000;\n  display: block;\n  width: 2.4rem;\n  word-wrap: break-word;\n  word-break: break-all;\n  padding-right: 0.13333333rem;\n}\n.weui_input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  -webkit-appearance: none;\n  background-color: transparent;\n  font-size: inherit;\n  color: inherit;\n  line-height: 2.26666667;\n}\n.weui_input::-webkit-outer-spin-button,\n.weui_input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.weui_textarea {\n  display: block;\n  border: 0;\n  resize: none;\n  width: 100%;\n  color: inherit;\n  font-size: 0.34666667rem;\n  line-height: inherit;\n  outline: 0;\n}\n.weui_textarea_counter {\n  color: #999;\n  text-align: right;\n}\n.weui_cell_warn .weui_textarea_counter {\n  color: #E64340;\n}\n.weui_toptips {\n  display: none;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n  width: 100%;\n  top: 0;\n  line-height: 2.3;\n  font-size: 14px;\n  text-align: center;\n  color: #FFF;\n  z-index: 50000;\n}\n.weui_toptips.weui_warn {\n  background-color: #E64340;\n}\n.weui_cells_form .weui_cell_warn {\n  color: #E64340;\n}\n.weui_cells_form .weui_cell_warn .weui_icon_warn {\n  display: inline-block;\n}\n.weui_cells_form .weui_cell_ft {\n  font-size: 0;\n}\n.weui_cells_form .weui_icon_warn {\n  display: none;\n}\n.weui_cells_form input,\n.weui_cells_form textarea,\n.weui_cells_form label[for] {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@font-face {\n  font-weight: normal;\n  font-style: normal;\n  font-family: \"weui\";\n  src: url('data:application/octet-stream;base64,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') format('truetype');\n}\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  font-family: \"weui\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: inherit;\n  width: 1em;\n  margin-right: 0.56rem;\n  text-align: center;\n  /* opacity: .8; */\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1;\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  margin-left: .2rem;\n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n.weui_icon_circle:before {\n  content: \"\\EA01\";\n}\n/* '' */\n.weui_icon_download:before {\n  content: \"\\EA02\";\n}\n/* '' */\n.weui_icon_info:before {\n  content: \"\\EA03\";\n}\n/* '' */\n.weui_icon_safe_success:before {\n  content: \"\\EA04\";\n}\n/* '' */\n.weui_icon_safe_warn:before {\n  content: \"\\EA05\";\n}\n/* '' */\n.weui_icon_success:before {\n  content: \"\\EA06\";\n}\n/* '' */\n.weui_icon_success_circle:before {\n  content: \"\\EA07\";\n}\n/* '' */\n.weui_icon_success_no_circle:before {\n  content: \"\\EA08\";\n}\n/* '' */\n.weui_icon_waiting:before {\n  content: \"\\EA09\";\n}\n/* '' */\n.weui_icon_waiting_circle:before {\n  content: \"\\EA0A\";\n}\n/* '' */\n.weui_icon_warn:before {\n  content: \"\\EA0B\";\n}\n/* '' */\n.weui_icon_info_circle:before {\n  content: \"\\EA0C\";\n}\n/* '' */\n.weui_icon_cancel:before {\n  content: \"\\EA0D\";\n}\n/* '' */\n.weui_icon_search:before {\n  content: \"\\EA0E\";\n}\n/* '' */\n.weui_icon_clear:before {\n  content: \"\\EA0F\";\n}\n/* '' */\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  margin: 0;\n}\n.weui_icon_success:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_waiting:before {\n  font-size: 0.61333333rem;\n  color: #10AEFF;\n}\n.weui_icon_warn:before {\n  font-size: 0.61333333rem;\n  color: #F43530;\n}\n.weui_icon_info:before {\n  font-size: 0.61333333rem;\n  color: #10AEFF;\n}\n.weui_icon_success_circle:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_success_no_circle:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_waiting_circle:before {\n  font-size: 0.48rem;\n  color: #10AEFF;\n}\n.weui_icon_circle:before {\n  font-size: 0.48rem;\n  color: #C9C9C9;\n}\n.weui_icon_download:before {\n  font-size: 0.48rem;\n  color: #09BB07;\n}\n.weui_icon_info_circle:before {\n  font-size: 0.48rem;\n  color: #09BB07;\n}\n.weui_icon_safe_success:before {\n  color: #09BB07;\n}\n.weui_icon_safe_warn:before {\n  color: #FFBE00;\n}\n.weui_icon_cancel:before {\n  color: #F43530;\n  font-size: 0.58666667rem;\n}\n.weui_icon_search:before {\n  color: #B2B2B2;\n  font-size: 0.37333333rem;\n}\n.weui_icon_clear:before {\n  color: #B2B2B2;\n  font-size: 0.37333333rem;\n}\n.weui_icon_msg:before {\n  font-size: 2.77333333rem;\n}\n.weui_icon_warn.weui_icon_msg:before {\n  color: #F76260;\n}\n.weui_icon_safe:before {\n  font-size: 2.77333333rem;\n}\n.weui_cell_radio > * {\n  pointer-events: none;\n}\n", ""]);

	// exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _base = __webpack_require__(85);

	var _base2 = _interopRequireDefault(_base);

	var _objectFilter = __webpack_require__(87);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  mixins: [_base2.default],
	  filters: {
	    getValue: _objectFilter.getValue,
	    getKey: _objectFilter.getKey
	  },
	  props: {
	    options: {
	      type: Array,
	      required: true
	    },
	    value: String,
	    fillMode: {
	      type: Boolean,
	      default: false
	    },
	    fillPlaceholder: {
	      type: String,
	      default: '其他'
	    },
	    fillLabel: {
	      type: String,
	      default: '其他'
	    }
	  },
	  created: function created() {
	    this.handleChangeEvent = true;
	  },

	  methods: {
	    onFocus: function onFocus() {
	      this.currentValue = this.fillValue || '';
	      this.isFocus = true;
	    }
	  },
	  watch: {
	    currentValue: function currentValue(newVal) {
	      var isOption = contains(this.options, newVal);
	      if (newVal !== '' && isOption) {
	        this.fillValue = '';
	      }
	      this.$emit('on-change', newVal);
	      this.$emit('input', newVal);
	    },
	    value: function value(newVal) {
	      this.currentValue = newVal;
	    },
	    fillValue: function fillValue(newVal) {
	      if (this.fillMode && this.isFocus) {
	        this.currentValue = newVal;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      fillValue: '',
	      isFocus: false,
	      currentValue: this.value
	    };
	  }
	};


	function contains(a, obj) {
	  var i = a.length;
	  while (i--) {
	    if (a[i] === obj) {
	      return true;
	    }
	  }
	  return false;
	}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _mixin_uuid = __webpack_require__(86);

	var _mixin_uuid2 = _interopRequireDefault(_mixin_uuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  mixins: [_mixin_uuid2.default],
	  props: {
	    required: {
	      type: Boolean,
	      default: true
	    }
	  },
	  created: function created() {
	    this.handleChangeEvent = false;
	  },

	  computed: {
	    dirty: function dirty() {
	      return !this.prisine;
	    },
	    invalid: function invalid() {
	      return !this.valid;
	    }
	  },
	  methods: {
	    setTouched: function setTouched() {
	      this.touched = true;
	    }
	  },
	  watch: {
	    value: function value(newVal) {
	      if (this.prisine === true) {
	        this.prisine = false;
	      }
	      if (!this.handleChangeEvent) {
	        this.$emit('on-change', newVal);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      errors: {},
	      prisine: true,
	      touched: false,
	      valid: true
	    };
	  }
	};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  created: function created() {
	    this.uuid = Math.random().toString(36).substring(3, 8);
	  }
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLabels = exports.getLabel = exports.getInlineDesc = exports.getKey = exports.getValue = undefined;

	var _typeof2 = __webpack_require__(88);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var getValue = exports.getValue = function getValue(item) {
	  return (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.value : item;
	};

	var getKey = exports.getKey = function getKey(item) {
	  return (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.key : item;
	};

	var getInlineDesc = exports.getInlineDesc = function getInlineDesc(item) {
	  return (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' ? item.inlineDesc : '';
	};

	var getLabel = exports.getLabel = function getLabel() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var value = arguments[1];

	  if (!list.length) {
	    return value;
	  }
	  if (typeof list[0] === 'string') {
	    return value;
	  }
	  var match = list.filter(function (one) {
	    return one.key === value;
	  });
	  if (match.length) {
	    return match[0].value || match[0].label;
	  }
	  return value;
	};

	var getLabels = exports.getLabels = function getLabels() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	  return values.map(function (value) {
	    return getLabel(list, value);
	  });
	};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/typeof");

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cells_radio"
	  }, [_vm._l((_vm.options), function(one, index) {
	    return _c('label', {
	      staticClass: "weui_cell weui_cell_radio weui_check_label",
	      attrs: {
	        "for": 'radio_' + _vm.uuid + '_' + index
	      }
	    }, [_c('div', {
	      staticClass: "weui_cell_bd weui_cell_primary"
	    }, [_c('p', [_vm._v("\n        " + _vm._s(_vm._f("getValue")(one)) + "\n        "), _vm._t("default", null, {
	      one: one
	    })], 2)]), _c('div', {
	      staticClass: "weui_cell_ft"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.currentValue),
	        expression: "currentValue"
	      }],
	      staticClass: "weui_check",
	      attrs: {
	        "type": "radio",
	        "id": 'radio_' + _vm.uuid + '_' + index
	      },
	      domProps: {
	        "value": _vm._f("getKey")(one),
	        "checked": _vm._q(_vm.currentValue, _vm._f("getKey")(one))
	      },
	      on: {
	        "change": function($event) {
	          _vm.currentValue = _vm._f("getKey")(one)
	        }
	      }
	    }), _c('span', {
	      staticClass: "weui_icon_checked"
	    })])])
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.fillMode),
	      expression: "fillMode"
	    }],
	    staticClass: "weui_cell"
	  }, [_c('div', {
	    staticClass: "weui_cell_hd"
	  }, [_c('label', {
	    staticClass: "weui_label",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v(_vm._s(_vm.fillLabel))])]), _c('div', {
	    staticClass: "weui_cell_bd weui_cell_primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fillValue),
	      expression: "fillValue"
	    }],
	    staticClass: "weui_input needsclick",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.fillPlaceholder
	    },
	    domProps: {
	      "value": (_vm.fillValue)
	    },
	    on: {
	      "blur": function($event) {
	        _vm.isFocus = false
	      },
	      "focus": function($event) {
	        _vm.onFocus()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fillValue = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.value === '' && !_vm.isFocus),
	      expression: "value==='' && !isFocus"
	    }],
	    staticClass: "weui_cell_ft"
	  }, [_c('i', {
	    staticClass: "weui_icon_warn"
	  })])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xInput = __webpack_require__(91);

	var _xInput2 = _interopRequireDefault(_xInput);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xInput2.default.install = function (Vue) {
	  Vue.component('LxXInput', _xInput2.default);
	};

	exports.default = _xInput2.default;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(92)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(94),
	  /* template */
	  __webpack_require__(111),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(93);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-116fdfb0!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-input.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-116fdfb0!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-input.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cells_access .weui_cell:not(.no_access) {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_cells_access .weui_cell:not(.no_access):active {\n  background-color: #ECECEC;\n}\n.weui_cells_access a.weui_cell {\n  color: inherit;\n}\n.weui_cells_access .weui_cell_ft:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 6px;\n  width: 6px;\n  border-width: 2px 2px 0 0;\n  border-color: #C8C8CD;\n  border-style: solid;\n  position: relative;\n  top: -2px;\n  top: -1px;\n  margin-left: .3em;\n}\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.weui_label {\n  color: #000;\n  display: block;\n  width: 2.4rem;\n  word-wrap: break-word;\n  word-break: break-all;\n  padding-right: 0.13333333rem;\n}\n.weui_input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  -webkit-appearance: none;\n  background-color: transparent;\n  font-size: inherit;\n  color: inherit;\n  line-height: 2.26666667;\n}\n.weui_input::-webkit-outer-spin-button,\n.weui_input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.weui_textarea {\n  display: block;\n  border: 0;\n  resize: none;\n  width: 100%;\n  color: inherit;\n  font-size: 0.34666667rem;\n  line-height: inherit;\n  outline: 0;\n}\n.weui_textarea_counter {\n  color: #999;\n  text-align: right;\n}\n.weui_cell_warn .weui_textarea_counter {\n  color: #E64340;\n}\n.weui_toptips {\n  display: none;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n  width: 100%;\n  top: 0;\n  line-height: 2.3;\n  font-size: 14px;\n  text-align: center;\n  color: #FFF;\n  z-index: 50000;\n}\n.weui_toptips.weui_warn {\n  background-color: #E64340;\n}\n.weui_cells_form .weui_cell_warn {\n  color: #E64340;\n}\n.weui_cells_form .weui_cell_warn .weui_icon_warn {\n  display: inline-block;\n}\n.weui_cells_form .weui_cell_ft {\n  font-size: 0;\n}\n.weui_cells_form .weui_icon_warn {\n  display: none;\n}\n.weui_cells_form input,\n.weui_cells_form textarea,\n.weui_cells_form label[for] {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_vcode {\n  padding-top: 0!important;\n  padding-right: 0!important;\n  padding-bottom: 0!important;\n}\n.weui_vcode .weui_cell_ft img {\n  margin-left: 5px;\n  height: 1.44rem;\n  vertical-align: middle;\n}\n.weui_vcode .weui_btn {\n  margin-left: 5px;\n  width: auto;\n  display: inline-block;\n  height: 1.44rem;\n}\n.vux-input-icon.vux-input-icon {\n  font-size: 0.48rem;\n}\n.vux-input-icon.weui_icon_warn:before,\n.vux-input-icon.weui_icon_success:before {\n  font-size: 0.48rem;\n}\n.vux-x-input .weui_icon {\n  padding-left: 0.13333333rem;\n}\n.vux-x-input.weui_cell_vcode {\n  padding-top: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n}\n", ""]);

	// exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _keys = __webpack_require__(95);

	var _keys2 = _interopRequireDefault(_keys);

	var _base = __webpack_require__(85);

	var _base2 = _interopRequireDefault(_base);

	var _icon = __webpack_require__(96);

	var _icon2 = _interopRequireDefault(_icon);

	var _inlineDesc = __webpack_require__(102);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	var _isEmail = __webpack_require__(107);

	var _isEmail2 = _interopRequireDefault(_isEmail);

	var _isMobilePhone = __webpack_require__(108);

	var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);

	var _debounce = __webpack_require__(109);

	var _debounce2 = _interopRequireDefault(_debounce);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var validators = {
	  'email': {
	    fn: _isEmail2.default,
	    msg: '邮箱格式'
	  },
	  'china-mobile': {
	    fn: function fn(str) {
	      return (0, _isMobilePhone2.default)(str, 'zh-CN');
	    },

	    msg: '手机号码'
	  },
	  'china-name': {
	    fn: function fn(str) {
	      return str.length >= 2 && str.length <= 6;
	    },

	    msg: '中文姓名'
	  }
	};
	exports.default = {
	  created: function created() {
	    var _this = this;

	    this.currentValue = this.value || '';
	    if (!this.title && !this.placeholder && !this.currentValue) {
	      console.warn('no title and no placeholder?');
	    }
	    if (this.required && !this.currentValue) {
	      this.valid = false;
	      this.validate();
	    }
	    this.handleChangeEvent = true;
	    if (this.debounce) {
	      this._debounce = (0, _debounce2.default)(function () {
	        _this.$emit('on-change', _this.currentValue);
	      }, this.debounce);
	    }
	  },
	  mounted: function mounted() {
	    if (this.$slots && this.$slots['restricted-label']) {
	      this.hasRestrictedLabel = true;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._debounce) {
	      this._debounce.cancel();
	    }
	  },

	  mixins: [_base2.default],
	  components: {
	    Icon: _icon2.default,
	    InlineDesc: _inlineDesc2.default
	  },
	  props: {
	    required: {
	      type: Boolean,
	      default: false
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    type: {
	      type: String,
	      default: 'text'
	    },
	    placeholder: String,
	    value: [String, Number],
	    name: String,
	    readonly: Boolean,
	    disabled: Boolean,
	    isLink: Boolean,
	    keyboard: String,
	    inlineDesc: String,
	    isType: [String, Function],
	    min: Number,
	    max: Number,
	    showClear: {
	      type: Boolean,
	      default: true
	    },
	    equalWith: String,
	    textAlign: String,

	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    autocapitalize: {
	      type: String,
	      default: 'off'
	    },
	    autocorrect: {
	      type: String,
	      default: 'off'
	    },
	    spellcheck: {
	      type: String,
	      default: 'false'
	    },
	    novalidate: {
	      type: Boolean,
	      default: false
	    },
	    iconType: String,
	    debounce: Number
	  },
	  computed: {
	    labelStyles: function labelStyles() {
	      return {
	        width: this.$parent.labelWidth || this.labelWidth + 'em',
	        textAlign: this.$parent.labelAlign,
	        marginRight: this.$parent.labelMarginRight
	      };
	    },
	    pattern: function pattern() {
	      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
	        return '[0-9]*';
	      }
	    },
	    labelWidth: function labelWidth() {
	      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
	    },
	    hasErrors: function hasErrors() {
	      return (0, _keys2.default)(this.errors).length > 0;
	    },
	    inputStyle: function inputStyle() {
	      if (this.textAlign) {
	        return {
	          textAlign: this.textAlign
	        };
	      }
	    }
	  },
	  methods: {
	    clear: function clear() {
	      this.currentValue = '';
	      this.$refs.input.focus();
	      this.$emit('on-click-clear-icon');
	    },
	    focus: function focus() {
	      this.$refs.input.focus();
	    },
	    focusHandler: function focusHandler() {
	      this.isFocus = true;
	      this.$emit('on-focus', this.currentValue);
	    },
	    blur: function blur() {
	      this.isFocus = false;
	      this.setTouched();
	      this.validate();
	      this.$emit('on-blur', this.currentValue);
	    },
	    getError: function getError() {
	      var key = (0, _keys2.default)(this.errors)[0];
	      this.firstError = this.errors[key];
	      this.$emit('on-vali', this.errors, this.valid, this.uuid);
	    },
	    validate: function validate() {
	      if (typeof this.equalWith !== 'undefined') {
	        this.validateEqual();
	        this.getError();
	        return;
	      }
	      this.errors = {};
	      if (!this.currentValue && !this.required) {
	        this.valid = true;
	        this.getError();
	        return;
	      }
	      if (!this.currentValue && this.required) {
	        this.valid = false;
	        this.errors.required = this.title + '必填';
	        this.getError();
	        return;
	      }

	      if (typeof this.isType === 'string') {
	        var validator = validators[this.isType];
	        if (validator) {
	          this.valid = validator['fn'](this.currentValue);
	          if (!this.valid) {
	            this.errors.format = validator['msg'] + '格式不对哦~';
	            this.getError();
	            return;
	          } else {
	            delete this.errors.format;
	            this.getError();
	          }
	        }
	      }
	      if (typeof this.isType === 'function') {
	        var validStatus = this.isType(this.currentValue, this.name);
	        this.valid = validStatus.valid;
	        if (!this.valid) {
	          this.errors.format = validStatus.msg;
	          this.forceShowError = true;
	          this.getError();

	          return;
	        } else {
	          delete this.errors.format;
	          this.getError();
	        }
	      }
	      if (this.min) {
	        if (this.currentValue.length < this.min) {
	          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
	          this.valid = false;
	          this.getError();

	          return;
	        } else {
	          delete this.errors.min;
	          this.getError();
	        }
	      }
	      if (this.max) {
	        if (this.currentValue.length > this.max) {
	          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
	          this.valid = false;
	          this.forceShowError = true;
	          this.getError();
	          return;
	        } else {
	          this.forceShowError = false;
	          delete this.errors.max;
	          this.getError();
	        }
	      }
	      this.valid = true;
	    },
	    validateEqual: function validateEqual() {
	      if (!this.equalWith && this.currentValue) {
	        this.valid = false;
	        this.errors.equal = '输入不一致';
	        return;
	      }
	      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;

	      if (willCheck && this.currentValue !== this.equalWith) {
	        this.valid = false;
	        this.errors.equal = '输入不一致';
	        return;
	      } else {
	        if (!this.currentValue && this.required) {
	          this.valid = false;
	        } else {
	          this.valid = true;
	          delete this.errors.equal;
	        }
	      }
	    }
	  },
	  data: function data() {
	    var data = {
	      hasRestrictedLabel: false,
	      firstError: '',
	      forceShowError: false,
	      hasLengthEqual: false,
	      valid: true,
	      currentValue: '',
	      isFocus: false
	    };
	    return data;
	  },

	  watch: {
	    valid: function valid(val) {},
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    equalWith: function equalWith(newVal) {
	      if (newVal && this.equalWith) {
	        if (newVal.length === this.equalWith.length) {
	          this.hasLengthEqual = true;
	        }
	        this.validateEqual();
	      } else {
	        this.validate();
	      }
	    },
	    currentValue: function currentValue(newVal) {
	      if (!this.equalWith && newVal) {
	        this.validateEqual();
	      }
	      if (newVal && this.equalWith) {
	        if (newVal.length === this.equalWith.length) {
	          this.hasLengthEqual = true;
	        }
	        this.validateEqual();
	      } else {
	        this.validate();
	        this.getError();
	      }
	      this.$emit('input', newVal);
	      if (this._debounce) {
	        this._debounce();
	      } else {
	        this.$emit('on-change', newVal);
	      }
	    }
	  }
	};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/object/keys");

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _icon = __webpack_require__(97);

	var _icon2 = _interopRequireDefault(_icon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_icon2.default.install = function (Vue) {
	  Vue.component('LxIcon', _icon2.default);
	};

	exports.default = _icon2.default;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(98)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(100),
	  /* template */
	  __webpack_require__(101),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3da2f9dc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./icon.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3da2f9dc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./icon.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n@font-face {\n  font-weight: normal;\n  font-style: normal;\n  font-family: \"weui\";\n  src: url('data:application/octet-stream;base64,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') format('truetype');\n}\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  font-family: \"weui\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: inherit;\n  width: 1em;\n  margin-right: .2em;\n  text-align: center;\n  /* opacity: .8; */\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  margin-left: .2em;\n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n.weui_icon_circle:before {\n  content: \"\\EA01\";\n}\n/* '' */\n.weui_icon_download:before {\n  content: \"\\EA02\";\n}\n/* '' */\n.weui_icon_info:before {\n  content: \"\\EA03\";\n}\n/* '' */\n.weui_icon_safe_success:before {\n  content: \"\\EA04\";\n}\n/* '' */\n.weui_icon_safe_warn:before {\n  content: \"\\EA05\";\n}\n/* '' */\n.weui_icon_success:before {\n  content: \"\\EA06\";\n}\n/* '' */\n.weui_icon_success_circle:before {\n  content: \"\\EA07\";\n}\n/* '' */\n.weui_icon_success_no_circle:before {\n  content: \"\\EA08\";\n}\n/* '' */\n.weui_icon_waiting:before {\n  content: \"\\EA09\";\n}\n/* '' */\n.weui_icon_waiting_circle:before {\n  content: \"\\EA0A\";\n}\n/* '' */\n.weui_icon_warn:before {\n  content: \"\\EA0B\";\n}\n/* '' */\n.weui_icon_info_circle:before {\n  content: \"\\EA0C\";\n}\n/* '' */\n.weui_icon_cancel:before {\n  content: \"\\EA0D\";\n}\n/* '' */\n.weui_icon_search:before {\n  content: \"\\EA0E\";\n}\n/* '' */\n.weui_icon_clear:before {\n  content: \"\\EA0F\";\n}\n/* '' */\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  margin: 0;\n}\n.weui_icon_success:before {\n  font-size: 23px;\n  color: #09BB07;\n}\n.weui_icon_waiting:before {\n  font-size: 23px;\n  color: #10AEFF;\n}\n.weui_icon_warn:before {\n  font-size: 23px;\n  color: #F43530;\n}\n.weui_icon_info:before {\n  font-size: 23px;\n  color: #10AEFF;\n}\n.weui_icon_success_circle:before {\n  font-size: 23px;\n  color: #09BB07;\n}\n.weui_icon_success_no_circle:before {\n  font-size: 23px;\n  color: #09BB07;\n}\n.weui_icon_waiting_circle:before {\n  font-size: 23px;\n  color: #10AEFF;\n}\n.weui_icon_circle:before {\n  font-size: 23px;\n  color: #C9C9C9;\n}\n.weui_icon_download:before {\n  font-size: 23px;\n  color: #09BB07;\n}\n.weui_icon_info_circle:before {\n  font-size: 23px;\n  color: #09BB07;\n}\n.weui_icon_safe_success:before {\n  color: #09BB07;\n}\n.weui_icon_safe_warn:before {\n  color: #FFBE00;\n}\n.weui_icon_cancel:before {\n  color: #F43530;\n  font-size: 22px;\n}\n.weui_icon_search:before {\n  color: #B2B2B2;\n  font-size: 14px;\n}\n.weui_icon_clear:before {\n  color: #B2B2B2;\n  font-size: 14px;\n}\n.weui_icon_msg:before {\n  font-size: 104px;\n}\n.weui_icon_warn.weui_icon_msg:before {\n  color: #F76260;\n}\n.weui_icon_safe:before {\n  font-size: 104px;\n}\n.icon_big:before {\n  font-size: 104px;\n}\n.icon_small:before {\n  font-size: 12px;\n}\n", ""]);

	// exports


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    type: String
	  },
	  computed: {
	    className: function className() {
	      return "weui_icon weui_icon_" + this.type;
	    }
	  }
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', {
	    class: _vm.className
	  })
	},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inlineDesc = __webpack_require__(103);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_inlineDesc2.default.install = function (Vue) {
	  Vue.component('LxInlineDesc', _inlineDesc2.default);
	};

	exports.default = _inlineDesc2.default;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(104)

	var Component = __webpack_require__(79)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(106),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(105);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7e3a6648!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./inline-desc.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7e3a6648!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./inline-desc.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-label-desc {\r\n  font-size:14px;\r\n  color:#666;\n}\r\n", ""]);

	// exports


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "vux-label-desc"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports = require("validator/lib/isEmail");

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports = require("validator/lib/isMobilePhone");

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(110);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _lodash2.default;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = require("lodash.debounce");

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-x-input weui_cell",
	    class: {
	      'weui_cell_warn': !_vm.valid
	    }
	  }, [_c('div', {
	    staticClass: "weui_cell_hd"
	  }, [(_vm.hasRestrictedLabel) ? _c('div', {
	    style: (_vm.labelStyles)
	  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._t("label", [(_vm.title) ? _c('label', {
	    staticClass: "weui_label",
	    style: ({
	      textAlign: _vm.$parent.labelAlign,
	      marginRight: _vm.$parent.labelMarginRight
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  }) : _vm._e(), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _c('div', {
	    staticClass: "weui_cell_bd weui_cell_primary"
	  }, [(!_vm.type || _vm.type === 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "weui_input",
	    style: (_vm.inputStyle),
	    attrs: {
	      "maxlength": _vm.max,
	      "autocomplete": _vm.autocomplete,
	      "autocapitalize": _vm.autocapitalize,
	      "autocorrect": _vm.autocorrect,
	      "spellcheck": _vm.spellcheck,
	      "type": "text",
	      "name": _vm.name,
	      "pattern": _vm.pattern,
	      "placeholder": _vm.placeholder,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": _vm.focusHandler,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _vm._e(), (_vm.type === 'number') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "weui_input",
	    style: (_vm.inputStyle),
	    attrs: {
	      "maxlength": _vm.max,
	      "autocomplete": _vm.autocomplete,
	      "autocapitalize": _vm.autocapitalize,
	      "autocorrect": _vm.autocorrect,
	      "spellcheck": _vm.spellcheck,
	      "type": "number",
	      "name": _vm.name,
	      "pattern": _vm.pattern,
	      "placeholder": _vm.placeholder,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": _vm.focusHandler,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _vm._e(), (_vm.type === 'email') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "weui_input",
	    style: (_vm.inputStyle),
	    attrs: {
	      "maxlength": _vm.max,
	      "autocomplete": _vm.autocomplete,
	      "autocapitalize": _vm.autocapitalize,
	      "autocorrect": _vm.autocorrect,
	      "spellcheck": _vm.spellcheck,
	      "type": "email",
	      "name": _vm.name,
	      "pattern": _vm.pattern,
	      "placeholder": _vm.placeholder,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": _vm.focusHandler,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _vm._e(), (_vm.type === 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "weui_input",
	    style: (_vm.inputStyle),
	    attrs: {
	      "maxlength": _vm.max,
	      "autocomplete": _vm.autocomplete,
	      "autocapitalize": _vm.autocapitalize,
	      "autocorrect": _vm.autocorrect,
	      "spellcheck": _vm.spellcheck,
	      "type": "password",
	      "name": _vm.name,
	      "pattern": _vm.pattern,
	      "placeholder": _vm.placeholder,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": _vm.focusHandler,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _vm._e(), (_vm.type === 'tel') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "weui_input",
	    style: (_vm.inputStyle),
	    attrs: {
	      "maxlength": _vm.max,
	      "autocomplete": _vm.autocomplete,
	      "autocapitalize": _vm.autocapitalize,
	      "autocorrect": _vm.autocorrect,
	      "spellcheck": _vm.spellcheck,
	      "type": "tel",
	      "name": _vm.name,
	      "pattern": _vm.pattern,
	      "placeholder": _vm.placeholder,
	      "readonly": _vm.readonly,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": _vm.focusHandler,
	      "blur": _vm.blur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _c('div', {
	    staticClass: "weui_cell_ft",
	    class: {
	      'with_arrow': _vm.isLink
	    }
	  }, [_c('icon', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isFocus && !_vm.equalWith && _vm.showClear && _vm.currentValue && !_vm.readonly && !_vm.disabled),
	      expression: "isFocus && !equalWith && showClear && currentValue && !readonly && !disabled"
	    }],
	    attrs: {
	      "type": "clear"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.clear($event)
	      }
	    }
	  }), _c('icon', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.novalidate && !_vm.equalWith && ((_vm.touched && !_vm.valid && _vm.firstError) || (_vm.forceShowError && !_vm.valid && _vm.firstError))),
	      expression: "!novalidate && !equalWith && ((touched && !valid && firstError) || (forceShowError && !valid && firstError))"
	    }],
	    staticClass: "vux-input-icon",
	    attrs: {
	      "type": "warn",
	      "title": !_vm.valid ? _vm.firstError : ''
	    }
	  }), (!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid) ? _c('icon', {
	    staticClass: "vux-input-icon",
	    attrs: {
	      "type": "warn"
	    }
	  }) : _vm._e(), _c('icon', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),
	      expression: "!novalidate && equalWith && equalWith === currentValue && valid"
	    }],
	    attrs: {
	      "type": "success"
	    }
	  }), _c('icon', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.novalidate && _vm.iconType === 'success'),
	      expression: "novalidate && iconType === 'success'"
	    }],
	    staticClass: "vux-input-icon",
	    attrs: {
	      "type": "success"
	    }
	  }), _c('icon', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.novalidate && _vm.iconType === 'error'),
	      expression: "novalidate && iconType === 'error'"
	    }],
	    staticClass: "vux-input-icon",
	    attrs: {
	      "type": "warn"
	    }
	  }), _vm._t("right")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xNumber = __webpack_require__(113);

	var _xNumber2 = _interopRequireDefault(_xNumber);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xNumber2.default.install = function (Vue) {
	  Vue.component('LxXNumber', _xNumber2.default);
	};

	exports.default = _xNumber2.default;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(114)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(116),
	  /* template */
	  __webpack_require__(117),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(115);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-76e8b77c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-number.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-76e8b77c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-number.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-number-input {\n  float: left;\n  height: 0.53333333rem;\n  font-size: 0.53333333rem;\n  color: #666;\n  appearance: none;\n  border: 1px solid #ececec;\n  padding: 0.08rem 0;\n  text-align: center;\n  border-radius: 1px;\n}\n.vux-number-selector {\n  float: left;\n  height: 0.53333333rem;\n  font-size: 0.66666667rem;\n  line-height: 0.48rem;\n  color: #5890ff;\n  border: 1px solid #ececec;\n}\n.vux-number-selector.vux-number-disabled {\n  color: #ccc;\n}\n.vux-number-selector-sub {\n  border-right: none;\n  padding: 0.08rem 0.26666667rem;\n  border-radius: 2px 0 0 2px;\n}\n.vux-number-selector-plus {\n  border-left: none;\n  margin-right: 0.13333333rem;\n  padding: 0.08rem 0.21333333rem;\n  border-radius: 0 0.05333333rem 0.05333333rem 0;\n}\n", ""]);

	// exports


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    min: Number,
	    max: Number,
	    step: {
	      type: Number,
	      default: 1
	    },
	    value: {
	      type: [Number, String],
	      default: 0
	    },
	    name: String,
	    title: String,
	    fillable: {
	      type: Boolean,
	      default: true
	    },
	    width: {
	      type: Number,
	      default: 50
	    },
	    readonly: {
	      type: Boolean,
	      default: false
	    },
	    shell: {
	      type: Boolean,
	      default: true
	    },
	    inputClasses: {
	      type: String,
	      default: ''
	    },
	    lockMin: {
	      type: Boolean,
	      default: false
	    },
	    lockMax: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    disabledMin: function disabledMin() {
	      return typeof this.min === 'undefined' ? false : +this.currentValue <= this.min;
	    },
	    disabledMax: function disabledMax() {
	      return typeof this.max === 'undefined' ? false : +this.currentValue >= this.max;
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },

	  watch: {
	    value: function value(nVal, oVal) {
	      if (!/^[+-\d]?[\d]*(\.[\d]*)?$/.test(this.value)) {
	        this.value = '0.00';
	      }
	      this.currentValue = this.value;
	    },
	    currentValue: function currentValue(newValue, old) {
	      if (typeof this.currentValue === 'string') {
	        var isSymbol = /[+-.]/.test(this.currentValue.substr(0, 1));
	        if (isSymbol) {
	          this.currentValue = this.currentValue.substr(0, 1) + this.currentValue.substr(1).replace(/[^\d.]/g, '');
	        } else {
	          this.currentValue = this.currentValue.replace(/[^\d.]/g, '');
	        }
	      }
	      if (this.min && +this.currentValue < this.min && !this.lockMin) {
	        this.currentValue = this.min;
	      }
	      if (this.max && +this.currentValue > this.max && !this.lockMax) {
	        this.currentValue = this.max;
	      }
	      this.$emit('on-change', this.currentValue);
	      this.$emit('input', this.currentValue);
	    }
	  },
	  methods: {
	    focus: function focus(e) {
	      this.$emit('on-focus', e);
	    },
	    blur: function blur(e) {
	      this.$emit('on-blur', e);
	    },
	    add: function add() {
	      if (!this.disabledMax) {
	        this.currentValue = +this.currentValue + this.step;
	        this.currentValue = this.currentValue.toFixed(2);
	      }
	    },
	    sub: function sub() {
	      if (!this.disabledMin) {
	        this.currentValue = +this.currentValue - this.step;
	        this.currentValue = this.currentValue.toFixed(2);
	      }
	    }
	  }
	};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.shell) ? _c('div', {
	    staticClass: "weui_cell"
	  }, [_c('div', {
	    staticClass: "weui_cell_bd weui_cell_primary"
	  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), (!_vm.readonly) ? _c('div', {
	    staticClass: "weui_cell_ft",
	    staticStyle: {
	      "font-size": "0"
	    }
	  }, [_c('a', {
	    staticClass: "vux-number-selector vux-number-selector-sub",
	    class: {
	      'vux-number-disabled': _vm.disabledMin
	    },
	    on: {
	      "click": _vm.sub
	    }
	  }, [_vm._v("-")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "vux-number-input",
	    style: ({
	      width: _vm.width + 'px'
	    }),
	    attrs: {
	      "name": _vm.name,
	      "readonly": !_vm.fillable
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.focus($event)
	      },
	      "blur": function($event) {
	        _vm.blur($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }), _c('a', {
	    staticClass: "vux-number-selector vux-number-selector-plus",
	    class: {
	      'vux-number-disabled': _vm.disabledMax
	    },
	    on: {
	      "click": _vm.add
	    }
	  }, [_vm._v("+")])]) : _c('div', {
	    staticClass: "weui_cell_ft"
	  }, [_vm._v("\n      " + _vm._s(_vm.currentValue) + "\n    ")])]) : _c('div', [(!_vm.readonly) ? _c('div', [_c('span', {
	    staticStyle: {
	      "float": "left"
	    },
	    on: {
	      "click": _vm.sub
	    }
	  }, [_vm._t("sub", [_c('a', {
	    staticClass: "vux-number-selector vux-number-selector-sub",
	    class: {
	      'vux-number-disabled': _vm.disabledMin
	    }
	  }, [_vm._v("-")])])], 2), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "vux-number-input",
	    class: _vm.inputClasses,
	    attrs: {
	      "name": _vm.name,
	      "readonly": !_vm.fillable
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.focus($event)
	      },
	      "blur": function($event) {
	        _vm.blur($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }), _c('span', {
	    on: {
	      "click": _vm.add
	    }
	  }, [_vm._t("add", [_c('a', {
	    staticClass: "vux-number-selector vux-number-selector-plus",
	    class: {
	      'vux-number-disabled': _vm.disabledMax
	    }
	  }, [_vm._v("+")])])], 2)]) : _c('div', [_vm._v("\n      " + _vm._s(_vm.currentValue) + "\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _cell = __webpack_require__(119);

	var _cell2 = _interopRequireDefault(_cell);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_cell2.default.install = function (Vue) {
	  Vue.component('LxCell', _cell2.default);
	};

	exports.default = _cell2.default;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(120)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(122),
	  /* template */
	  __webpack_require__(124),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(121);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-03fdd37c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./cell.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-03fdd37c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./cell.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n.vux-tap-active {\n  tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.vux-tap-active:active {\n  background-color: #ECECEC;\n}\n/* mixin */\n/* variable */\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.weui_cell_bd__start {\n  display: flex;\n  align-items: flex-start !important;\n}\n.weui_cell_bd > p {\n  color: #000;\n}\n.with_arrow:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 0.21333333rem;\n  width: 0.21333333rem;\n  border-width: 1px 1px 0 0;\n  border-color: #a0a0a0;\n  border-style: solid;\n  position: relative;\n  top: -1px;\n  margin-left: .3em;\n}\n", ""]);

	// exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inlineDesc = __webpack_require__(102);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	var _router = __webpack_require__(123);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    InlineDesc: _inlineDesc2.default
	  },
	  props: {
	    bdStart: {
	      type: Boolean,
	      default: false
	    },
	    title: String,
	    value: [String, Number],
	    isLink: Boolean,
	    inlineDesc: [String, Number],
	    primary: {
	      type: String,
	      default: 'title'
	    },
	    link: {
	      type: [String, Object]
	    }
	  },
	  methods: {
	    onClick: function onClick() {
	      (0, _router.go)(this.link, this.$router);
	    }
	  },
	  computed: {
	    bdClasses: function bdClasses() {
	      return {
	        'weui_cell_primary': this.primary === 'title'
	      };
	    },
	    classes: function classes() {
	      return {
	        'vux-tap-active': this.isLink || !!this.link,
	        'weui_cell_bd__start': this.bdStart
	      };
	    }
	  }

	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof2 = __webpack_require__(88);

	var _typeof3 = _interopRequireDefault(_typeof2);

	exports.go = go;
	exports.getUrl = getUrl;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function go(url, $router) {
	  if (/^javas/.test(url) || !url) return;
	  var useRouter = (typeof url === 'undefined' ? 'undefined' : (0, _typeof3.default)(url)) === 'object' || $router && typeof url === 'string' && !/http/.test(url);
	  if (useRouter) {
	    $router.push(url);
	  } else {
	    window.location.href = url;
	  }
	}

	function getUrl(url, $router) {
	  if ($router && !$router._history && typeof url === 'string' && !/http/.test(url)) {
	    return '#!' + url;
	  }
	  return url && (typeof url === 'undefined' ? 'undefined' : (0, _typeof3.default)(url)) !== 'object' ? url : 'javascript:void(0);';
	}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cell",
	    class: _vm.classes,
	    on: {
	      "click": _vm.onClick
	    }
	  }, [_c('div', {
	    staticClass: "weui_cell_hd"
	  }, [_vm._t("icon")], 2), _c('div', {
	    staticClass: "weui_cell_bd",
	    class: _vm.bdClasses
	  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _vm._t("after-title")], 2), _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))])], 1), _c('div', {
	    staticClass: "weui_cell_ft",
	    class: {
	      'weui_cell_primary': _vm.primary === 'content'
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n    "), _vm._t("value"), _vm._t("default")], 2), _c('div', {
	    class: {
	      'with_arrow': _vm.isLink || !!_vm.link
	    }
	  }), _vm._t("child")], 2)
	},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _checklist = __webpack_require__(126);

	var _checklist2 = _interopRequireDefault(_checklist);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_checklist2.default.install = function (Vue) {
	  Vue.component('LxChecklist', _checklist2.default);
	};

	exports.default = _checklist2.default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(127)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(129),
	  /* template */
	  __webpack_require__(138),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(128);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f5437e6c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checklist.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f5437e6c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checklist.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.weui_check_label {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_check {\n  position: absolute;\n  left: -9999em;\n}\n.weui_cells_radio .weui_cell_ft {\n  padding-left: 0.93333333rem;\n}\n.weui_cells_radio .weui_cell:active {\n  background-color: #ECECEC;\n}\n.weui_cells_radio .weui_check:checked + .weui_icon_checked:before {\n  display: block;\n  content: '\\EA08';\n  color: #5890ff;\n  font-size: 0.42666667rem;\n}\n.weui_cells_checkbox .weui_cell_hd {\n  padding-right: 0.4rem;\n}\n.weui_cells_checkbox .weui_icon_checked:before {\n  display: block;\n  width: 0.4rem;\n  height: 0.4rem;\n  content: \"\";\n  border: 1px solid #E9E9EB;\n  box-sizing: border-box;\n}\n.weui_cells_checkbox .weui_check:checked + .weui_icon_checked {\n  display: block;\n  background-color: #409eff;\n  width: 0.4rem;\n  height: 0.4rem;\n  position: relative;\n}\n.weui_cells_checkbox .weui_check:checked + .weui_icon_checked:before {\n  position: absolute;\n  left: 0.08rem;\n  top: 0.06666667rem;\n  content: \"\";\n  border-style: solid;\n  width: 0.26666667rem;\n  height: 0.16rem;\n  border-color: #fff #fff transparent transparent;\n  border-width: 2px;\n  -webkit-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n.weui_cells_checkbox > label > * {\n  pointer-events: none;\n}\n.vux-checklist-disabled {\n  opacity: 0.5;\n}\n.vux-checklist-disabled .vux-checklist-icon-checked:before {\n  display: none;\n}\n.weui_cells > a {\n  color: #000;\n}\n.vux-checklist-label-left {\n  flex-direction: row-reverse;\n}\n.vux-checklist-label-left .weui_cell_hd {\n  padding-right: 0;\n}\n", ""]);

	// exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _keys = __webpack_require__(95);

	var _keys2 = _interopRequireDefault(_keys);

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _base = __webpack_require__(85);

	var _base2 = _interopRequireDefault(_base);

	var _tip = __webpack_require__(131);

	var _tip2 = _interopRequireDefault(_tip);

	var _icon = __webpack_require__(96);

	var _icon2 = _interopRequireDefault(_icon);

	var _inlineDesc = __webpack_require__(102);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	var _objectFilter = __webpack_require__(87);

	var _arrayShuffle = __webpack_require__(137);

	var _arrayShuffle2 = _interopRequireDefault(_arrayShuffle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    Tip: _tip2.default,
	    Icon: _icon2.default,
	    InlineDesc: _inlineDesc2.default
	  },
	  filters: {
	    getValue: _objectFilter.getValue,
	    getKey: _objectFilter.getKey
	  },
	  mixins: [_base2.default],
	  props: {
	    title: String,
	    required: {
	      type: Boolean,
	      default: false
	    },
	    options: {
	      type: Array,
	      required: true
	    },
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    max: Number,
	    min: Number,
	    fillMode: Boolean,
	    randomOrder: Boolean,
	    checkDisabled: {
	      type: Boolean,
	      default: true
	    },
	    labelPosition: {
	      type: String,
	      default: 'right'
	    },
	    disabled: Boolean
	  },
	  data: function data() {
	    return {
	      currentValue: [],
	      currentOptions: this.options
	    };
	  },
	  created: function created() {
	    this.handleChangeEvent = true;
	    if (this.value) {
	      this.currentValue = this.value;
	    }
	    if (this.randomOrder) {
	      this.currentOptions = (0, _arrayShuffle2.default)(this.options);
	    } else {
	      this.currentOptions = this.options;
	    }
	  },

	  methods: {
	    getValue: _objectFilter.getValue,
	    getKey: _objectFilter.getKey,
	    getInlineDesc: _objectFilter.getInlineDesc,
	    getFullValue: function getFullValue() {
	      var labels = (0, _objectFilter.getLabels)(this.options, this.value);
	      return this.currentValue.map(function (one, index) {
	        return {
	          value: one,
	          label: labels[index]
	        };
	      });
	    },
	    isDisabled: function isDisabled(key) {
	      if (!this.checkDisabled) {
	        return false;
	      }
	      if (this._max > 1) {
	        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
	      }
	      return false;
	    }
	  },
	  computed: {
	    _total: function _total() {
	      return this.fillMode ? this.options.length + 1 : this.options.length;
	    },
	    _min: function _min() {
	      if (!this.required) {
	        return 0;
	      }
	      if (this.min) {
	        if (this.min < 0) {
	          return 1;
	        }
	        if (this.min >= this._total) {
	          return this._total;
	        }
	        return this.min;
	      } else {
	        return 1;
	      }
	    },
	    _max: function _max() {
	      if (!this.required) {
	        return this._total;
	      }
	      if (this.max) {
	        if (this.max > this._total) {
	          return this._total;
	        }
	        return this.max;
	      } else {
	        return this._total;
	      }
	    },
	    validy: function validy() {
	      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
	    },
	    error: function error() {
	      var err = [];
	      if (this.currentValue.length < this._min) {
	        err.push('\u6700\u5C11\u8981\u9009\u62E9' + this._min + '\u4E2A\u54E6');
	      }
	      if (this.currentValue.length > this._max) {
	        err.push('\u6700\u591A\u53EA\u80FD\u9009\u62E9' + this._max + '\u4E2A\u54E6');
	      }
	      return err;
	    }
	  },
	  watch: {
	    value: function value(newVal) {
	      if ((0, _stringify2.default)(newVal) !== (0, _stringify2.default)(this.currentValue)) {
	        this.currentValue = newVal;
	      }
	    },
	    options: function options(val) {
	      this.currentOptions = val;
	    },
	    currentValue: function currentValue(newVal) {
	      var val = pure(newVal);
	      this.$emit('on-change', val);
	      this.$emit('input', val, (0, _objectFilter.getLabels)(this.options, val));
	      var err = {};
	      if (this._min) {
	        if (this.required) {
	          if (this.currentValue.length < this._min) {
	            err = {
	              min: this._min
	            };
	          }
	        } else {
	          if (this.currentValue.length && this.currentValue.length < this._min) {
	            err = {
	              min: this._min
	            };
	          }
	        }
	      }
	      if (!this.validy && this.dirty && (0, _keys2.default)(err).length) {
	        this.$emit('on-error', err);
	      } else {
	        this.$emit('on-clear-error');
	      }
	    }
	  }
	};


	function pure(obj) {
	  return JSON.parse((0, _stringify2.default)(obj));
	}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/json/stringify");

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _tip = __webpack_require__(132);

	var _tip2 = _interopRequireDefault(_tip);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_tip2.default.install = function (Vue) {
	  Vue.component('LxTip', _tip2.default);
	};

	exports.default = _tip2.default;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(133)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(135),
	  /* template */
	  __webpack_require__(136),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(134);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c4686818!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tip.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c4686818!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tip.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-group-tip, .vux-group-tip p {\r\n  font-size:14px;\r\n  color:#888;\r\n  text-align:center;\r\n  padding-top:0.3em;\r\n  padding-left:10px;\r\n  padding-right:5px;\n}\n.vux-group-tip .weui_icon {\r\n  padding-right: 3px;\n}\r\n", ""]);

	// exports


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    align: {
	      type: String,
	      default: 'left'
	    }
	  }
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-group-tip",
	    style: ({
	      'text-align': _vm.align
	    })
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = require("array-shuffle");

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    class: _vm.disabled ? 'vux-checklist-disabled' : ''
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    staticClass: "weui_cells_title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("after-title"), _c('div', {
	    staticClass: "weui_cells weui_cells_checkbox"
	  }, _vm._l((_vm.currentOptions), function(one, index) {
	    return _c('label', {
	      staticClass: "weui_cell weui_check_label",
	      class: {
	        'vux-checklist-label-left': _vm.labelPosition === 'left'
	      },
	      attrs: {
	        "for": ("checkbox_" + _vm.uuid + "_" + index)
	      }
	    }, [_c('div', {
	      staticClass: "weui_cell_hd"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.currentValue),
	        expression: "currentValue"
	      }],
	      staticClass: "weui_check",
	      attrs: {
	        "type": "checkbox",
	        "name": ("vux-checkbox-" + _vm.uuid),
	        "id": _vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),
	        "disabled": _vm.isDisabled(_vm.getKey(one))
	      },
	      domProps: {
	        "value": _vm.getKey(one),
	        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, _vm.getKey(one)) > -1 : (_vm.currentValue)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.currentValue,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = _vm.getKey(one),
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.currentValue = $$c
	          }
	        }
	      }
	    }), _c('i', {
	      staticClass: "weui_icon_checked"
	    })]), _c('div', {
	      staticClass: "weui_cell_bd weui_cell_primary"
	    }, [_c('p', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.getValue(one))
	      }
	    }), (_vm.getInlineDesc(one)) ? _c('inline-desc', [_vm._v(_vm._s(_vm.getInlineDesc(one)))]) : _vm._e()], 1)])
	  })), _c('tip', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.validy && _vm.dirty),
	      expression: "!validy && dirty"
	    }]
	  }, [_c('icon', {
	    staticClass: "icon_small",
	    attrs: {
	      "type": "warn"
	    }
	  }), _vm._v(_vm._s(_vm.error))], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xSwitch = __webpack_require__(140);

	var _xSwitch2 = _interopRequireDefault(_xSwitch);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xSwitch2.default.install = function (Vue) {
	  Vue.component('LxXSwitch', _xSwitch2.default);
	};

	exports.default = _xSwitch2.default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(141)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(143),
	  /* template */
	  __webpack_require__(144),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1a46bfdc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-switch.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1a46bfdc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-switch.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_label {\n  color: #000;\n  display: block;\n  width: 2.4rem;\n  word-wrap: break-word;\n  word-break: break-all;\n  padding-right: 0.13333333rem;\n}\n.weui_input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  -webkit-appearance: none;\n  background-color: transparent;\n  font-size: inherit;\n  color: inherit;\n  line-height: 2.26666667;\n}\n.weui_input::-webkit-outer-spin-button,\n.weui_input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.weui_textarea {\n  display: block;\n  border: 0;\n  resize: none;\n  width: 100%;\n  color: inherit;\n  font-size: 0.34666667rem;\n  line-height: inherit;\n  outline: 0;\n}\n.weui_textarea_counter {\n  color: #999;\n  text-align: right;\n}\n.weui_cell_warn .weui_textarea_counter {\n  color: #E64340;\n}\n.weui_toptips {\n  display: none;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n  width: 100%;\n  top: 0;\n  line-height: 2.3;\n  font-size: 14px;\n  text-align: center;\n  color: #FFF;\n  z-index: 50000;\n}\n.weui_toptips.weui_warn {\n  background-color: #E64340;\n}\n.weui_cells_form .weui_cell_warn {\n  color: #E64340;\n}\n.weui_cells_form .weui_cell_warn .weui_icon_warn {\n  display: inline-block;\n}\n.weui_cells_form .weui_cell_ft {\n  font-size: 0;\n}\n.weui_cells_form .weui_icon_warn {\n  display: none;\n}\n.weui_cells_form input,\n.weui_cells_form textarea,\n.weui_cells_form label[for] {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_cell.weui_cell_switch {\n  padding-top: 0.29333333rem;\n  padding-bottom: 0.29333333rem;\n}\n.weui_switch {\n  appearance: none;\n  position: relative;\n  width: 1.38666667rem;\n  height: 0.85333333rem;\n  border: 1px solid #DFDFDF;\n  outline: 0;\n  border-radius: 16px;\n  box-sizing: border-box;\n  background: #DFDFDF;\n}\n.weui_switch:before {\n  content: \" \";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1.33333333rem;\n  height: 0.8rem;\n  border-radius: 15px;\n  background-color: #FDFDFD;\n  transition: transform .3s;\n}\n.weui_switch:after {\n  content: \" \";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0.8rem;\n  height: 0.8rem;\n  border-radius: 15px;\n  background-color: #FFFFFF;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n  transition: transform .3s;\n}\n.weui_switch:checked {\n  border-color: #5890ff;\n  background-color: #5890ff;\n}\n.weui_switch:checked:before {\n  transform: scale(0);\n}\n.weui_switch:checked:after {\n  transform: translateX(20px);\n}\n.weui_cell_switch .weui_cell_ft {\n  font-size: 0;\n}\n", ""]);

	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inlineDesc = __webpack_require__(102);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    InlineDesc: _inlineDesc2.default
	  },
	  computed: {
	    labelStyle: function labelStyle() {
	      var isHTML = /<\/?[^>]*>/.test(this.title);
	      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
	      return {
	        width: width
	      };
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },

	  props: {
	    title: {
	      type: String,
	      required: true
	    },
	    disabled: Boolean,
	    value: {
	      type: Boolean,
	      default: false
	    },
	    inlineDesc: String
	  },

	  watch: {
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	      this.$emit('on-change', val);
	    },
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  }
	};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cell weui_cell_switch"
	  }, [_c('div', {
	    staticClass: "weui_cell_hd weui_cell_primary"
	  }, [_c('label', {
	    staticClass: "weui_label",
	    style: (_vm.labelStyle),
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  }), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 1), _c('div', {
	    staticClass: "weui_cell_ft"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "weui_switch",
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.currentValue,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.currentValue = $$c
	        }
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xTextarea = __webpack_require__(146);

	var _xTextarea2 = _interopRequireDefault(_xTextarea);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xTextarea2.default.install = function (Vue) {
	  Vue.component('LxXTextarea', _xTextarea2.default);
	};

	exports.default = _xTextarea2.default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(147)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(150),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-013b141c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-textarea.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-013b141c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-textarea.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.weui_label {\n  color: #000;\n  display: block;\n  width: 2.4rem;\n  word-wrap: break-word;\n  word-break: break-all;\n  padding-right: 0.13333333rem;\n}\n.weui_input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  -webkit-appearance: none;\n  background-color: transparent;\n  font-size: inherit;\n  color: inherit;\n  line-height: 2.26666667;\n}\n.weui_input::-webkit-outer-spin-button,\n.weui_input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.weui_textarea {\n  display: block;\n  border: 0;\n  resize: none;\n  width: 100%;\n  color: inherit;\n  font-size: 0.34666667rem;\n  line-height: inherit;\n  outline: 0;\n}\n.weui_textarea_counter {\n  color: #999;\n  text-align: right;\n}\n.weui_cell_warn .weui_textarea_counter {\n  color: #E64340;\n}\n.weui_toptips {\n  display: none;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n  width: 100%;\n  top: 0;\n  line-height: 2.3;\n  font-size: 14px;\n  text-align: center;\n  color: #FFF;\n  z-index: 50000;\n}\n.weui_toptips.weui_warn {\n  background-color: #E64340;\n}\n.weui_cells_form .weui_cell_warn {\n  color: #E64340;\n}\n.weui_cells_form .weui_cell_warn .weui_icon_warn {\n  display: inline-block;\n}\n.weui_cells_form .weui_cell_ft {\n  font-size: 0;\n}\n.weui_cells_form .weui_icon_warn {\n  display: none;\n}\n.weui_cells_form input,\n.weui_cells_form textarea,\n.weui_cells_form label[for] {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n", ""]);

	// exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _base = __webpack_require__(85);

	var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  minxins: [_base2.default],
	  props: {
	    showCounter: {
	      type: Boolean,
	      default: true
	    },
	    max: Number,
	    value: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    placeholder: String,
	    rows: {
	      type: Number,
	      default: 3
	    },
	    cols: {
	      type: Number,
	      default: 30
	    },
	    height: Number,

	    autocomplete: 'off',
	    autocapitalize: 'off',
	    autocorrect: 'off',
	    spellcheck: 'false'
	  },
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },

	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(newVal) {
	      if (this.max && newVal.length > this.max) {
	        this.currentValue = newVal.slice(0, this.max);
	      }
	      this.$emit('on-change', this.currentValue);
	      this.$emit('input', this.currentValue);
	    }
	  },
	  computed: {
	    count: function count() {
	      var len = 0;
	      if (this.currentValue) {
	        len = this.currentValue.replace(/\n/g, 'aa').length;
	      }
	      return len > this.max ? this.max : len;
	    },
	    textareaStyle: function textareaStyle() {
	      if (this.height) {
	        return {
	          height: this.height + 'px'
	        };
	      }
	    }
	  }
	};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cell"
	  }, [_c('div', {
	    staticClass: "weui_cell_bd weui_cell_primary"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "textarea",
	    staticClass: "weui_textarea",
	    style: (_vm.textareaStyle),
	    attrs: {
	      "autocomplete": _vm.autocomplete,
	      "autocapitalize": _vm.autocapitalize,
	      "autocorrect": _vm.autocorrect,
	      "spellcheck": _vm.spellcheck,
	      "placeholder": _vm.placeholder,
	      "name": _vm.name,
	      "rows": _vm.rows,
	      "cols": _vm.cols,
	      "maxlength": _vm.max
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showCounter && _vm.max),
	      expression: "showCounter && max"
	    }],
	    staticClass: "weui_textarea_counter"
	  }, [_c('span', [_vm._v(_vm._s(_vm.count))]), _vm._v("/" + _vm._s(_vm.max))])])])
	},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _group = __webpack_require__(152);

	var _group2 = _interopRequireDefault(_group);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_group2.default.install = function (Vue) {
	  Vue.component('LxGroup', _group2.default);
	};

	exports.default = _group2.default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(153)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(155),
	  /* template */
	  __webpack_require__(156),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(154);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6aa77988!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./group.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6aa77988!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./group.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cells_access .weui_cell:not(.no_access) {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_cells_access .weui_cell:not(.no_access):active {\n  background-color: #ECECEC;\n}\n.weui_cells_access a.weui_cell {\n  color: inherit;\n}\n.weui_cells_access .weui_cell_ft:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 6px;\n  width: 6px;\n  border-width: 2px 2px 0 0;\n  border-color: #C8C8CD;\n  border-style: solid;\n  position: relative;\n  top: -2px;\n  top: -1px;\n  margin-left: .3em;\n}\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-no-group-title {\n  margin-top: 0.26666667rem;\n}\n.weui_cells > a {\n  color: #000;\n}\n", ""]);

	// exports


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: String,
	    titleColor: String,
	    ABBBBBBBB: String,
	    labelWidth: String,
	    labelAlign: String,
	    labelMarginRight: String,
	    gutter: String
	  }
	};

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.title) ? _c('div', {
	    staticClass: "weui_cells_title",
	    style: ({
	      color: _vm.titleColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "weui_cells",
	    class: {
	      'vux-no-group-title': !_vm.title
	    },
	    style: ({
	      marginTop: _vm.gutter
	    })
	  }, [_vm._t("after-title"), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _groupTitle = __webpack_require__(158);

	var _groupTitle2 = _interopRequireDefault(_groupTitle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_groupTitle2.default.install = function (Vue) {
	  Vue.component('LxGroupTitle', _groupTitle2.default);
	};

	exports.default = _groupTitle2.default;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(159),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cells_title"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _box = __webpack_require__(161);

	var _box2 = _interopRequireDefault(_box);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_box2.default.install = function (Vue) {
	  Vue.component('LxBox', _box2.default);
	};

	exports.default = _box2.default;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(162),
	  /* template */
	  __webpack_require__(163),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    gap: String
	  }
	};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    style: ({
	      margin: _vm.gap
	    })
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _selector = __webpack_require__(165);

	var _selector2 = _interopRequireDefault(_selector);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_selector2.default.install = function (Vue) {
	  Vue.component('LxSelector', _selector2.default);
	};

	exports.default = _selector2.default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(166)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(168),
	  /* template */
	  __webpack_require__(170),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(167);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-303aec9c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./selector.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-303aec9c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./selector.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cells_access .weui_cell:not(.no_access) {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_cells_access .weui_cell:not(.no_access):active {\n  background-color: #ECECEC;\n}\n.weui_cells_access a.weui_cell {\n  color: inherit;\n}\n.weui_cells_access .weui_cell_ft:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 6px;\n  width: 6px;\n  border-width: 2px 2px 0 0;\n  border-color: #C8C8CD;\n  border-style: solid;\n  position: relative;\n  top: -2px;\n  top: -1px;\n  margin-left: .3em;\n}\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.weui_label {\n  color: #000;\n  display: block;\n  width: 2.4rem;\n  word-wrap: break-word;\n  word-break: break-all;\n  padding-right: 0.13333333rem;\n}\n.weui_input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  -webkit-appearance: none;\n  background-color: transparent;\n  font-size: inherit;\n  color: inherit;\n  line-height: 2.26666667;\n}\n.weui_input::-webkit-outer-spin-button,\n.weui_input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.weui_textarea {\n  display: block;\n  border: 0;\n  resize: none;\n  width: 100%;\n  color: inherit;\n  font-size: 0.34666667rem;\n  line-height: inherit;\n  outline: 0;\n}\n.weui_textarea_counter {\n  color: #999;\n  text-align: right;\n}\n.weui_cell_warn .weui_textarea_counter {\n  color: #E64340;\n}\n.weui_toptips {\n  display: none;\n  position: fixed;\n  -webkit-transform: translateZ(0);\n  width: 100%;\n  top: 0;\n  line-height: 2.3;\n  font-size: 14px;\n  text-align: center;\n  color: #FFF;\n  z-index: 50000;\n}\n.weui_toptips.weui_warn {\n  background-color: #E64340;\n}\n.weui_cells_form .weui_cell_warn {\n  color: #E64340;\n}\n.weui_cells_form .weui_cell_warn .weui_icon_warn {\n  display: inline-block;\n}\n.weui_cells_form .weui_cell_ft {\n  font-size: 0;\n}\n.weui_cells_form .weui_icon_warn {\n  display: none;\n}\n.weui_cells_form input,\n.weui_cells_form textarea,\n.weui_cells_form label[for] {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_cell_select {\n  padding-top: 0!important;\n  padding-bottom: 0!important;\n}\n.weui_cell_select .weui_select {\n  padding-right: 0.8rem;\n}\n.weui_cell_select .weui_cell_bd:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 0.21333333rem;\n  width: 0.21333333rem;\n  border-width: 1px 1px 0 0;\n  border-color: #a0a0a0;\n  border-style: solid;\n  position: relative;\n  top: -2px;\n  position: absolute;\n  top: 50%;\n  right: 0.4rem;\n  margin-top: -3px;\n}\n.weui_select {\n  -webkit-appearance: none;\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  width: 100%;\n  font-size: inherit;\n  height: 1.44rem;\n  line-height: 1.44rem;\n  position: relative;\n  z-index: 1;\n  padding-left: 0.4rem;\n}\n.weui_select_after {\n  padding-left: 0.4rem;\n}\n.weui_select_after .weui_select {\n  padding-left: 0;\n}\n.vux-selector-no-padding {\n  padding-left: 0;\n}\n.cvux-selector-placeholder {\n  color: #a0a0a0;\n}\n", ""]);

	// exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _arrayFind = __webpack_require__(169);

	var _arrayFind2 = _interopRequireDefault(_arrayFind);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var findByKey = function findByKey(key, options) {
	  var _rs = (0, _arrayFind2.default)(options, function (item) {
	    return item.key === key;
	  });
	  return _rs ? _rs.value : key;
	};

	exports.default = {
	  computed: {
	    processOptions: function processOptions() {
	      if (this.options.length && {}.hasOwnProperty.call(this.options[0], 'key')) {
	        return this.options;
	      } else {
	        return this.options.map(function (item) {
	          return {
	            key: item,
	            value: item
	          };
	        });
	      }
	    },
	    classes: function classes() {
	      return {
	        'vux-selector-no-padding': !this.title,
	        'cvux-selector-placeholder': this.currentValue === ''
	      };
	    }
	  },
	  filters: {
	    findByKey: findByKey
	  },
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },

	  watch: {
	    value: function value(newValue) {
	      this.currentValue = newValue;
	    },
	    currentValue: function currentValue(newValue) {
	      this.$emit('input', newValue);
	      this.$emit('on-change', newValue);
	    }
	  },
	  props: {
	    title: String,
	    direction: String,
	    options: {
	      type: Array,
	      required: true
	    },
	    name: String,
	    placeholder: String,
	    readonly: Boolean,
	    value: {
	      type: [String, Number, Boolean],
	      default: ''
	    }
	  }
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = require("array-find");

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cell",
	    class: {
	      'weui_select_after': _vm.title, 'weui_cell_select': !_vm.readonly
	    }
	  }, [(_vm.title) ? _c('div', {
	    staticClass: "weui_cell_hd",
	    class: {
	      'weui_cell_primary': _vm.readonly
	    }
	  }, [_c('label', {
	    staticClass: "weui_label",
	    style: ({
	      width: _vm.$parent.labelWidth + 'rem',
	      textAlign: _vm.$parent.labelAlign,
	      marginRight: _vm.$parent.labelMarginRight
	    }),
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), (!_vm.readonly) ? _c('div', {
	    staticClass: "weui_cell_bd weui_cell_primary"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "weui_select",
	    class: _vm.classes,
	    style: ({
	      direction: _vm.direction
	    }),
	    attrs: {
	      "name": _vm.name
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.currentValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [(_vm.placeholder) ? _c('option', {
	    attrs: {
	      "value": ""
	    },
	    domProps: {
	      "selected": _vm.placeholder && !_vm.currentValue
	    }
	  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._l((_vm.processOptions), function(one) {
	    return _c('option', {
	      domProps: {
	        "value": one.key
	      }
	    }, [_vm._v(_vm._s(one.value))])
	  })], 2)]) : _c('div', {
	    staticClass: "weui_cell_ft"
	  }, [_vm._v("\n    " + _vm._s(_vm._f("findByKey")(_vm.currentValue, _vm.processOptions)) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xButton = __webpack_require__(172);

	var _xButton2 = _interopRequireDefault(_xButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xButton2.default.install = function (Vue) {
	  Vue.component('LxXButton', _xButton2.default);
	};

	exports.default = _xButton2.default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(173)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(176),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(174);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0bacfd9c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-button.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0bacfd9c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-button.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_btn.weui_btn_mini {\n  line-height: 1.9;\n  font-size: 0.37333333rem;\n  padding: 0 .75em;\n  display: inline-block;\n}\nbutton.weui_btn,\ninput.weui_btn {\n  width: 100%;\n  border-width: 0;\n  outline: 0;\n  -webkit-appearance: none;\n}\nbutton.weui_btn:focus,\ninput.weui_btn:focus {\n  outline: 0;\n}\nbutton.weui_btn_inline,\ninput.weui_btn_inline,\nbutton.weui_btn_mini,\ninput.weui_btn_mini {\n  width: auto;\n}\n/*gap between btn*/\n.weui_btn.weui_btn_inline + .weui_btn.weui_btn_inline {\n  margin-top: auto;\n  margin-left: 0.4rem;\n}\n.weui_btn_area {\n  margin: 50em 0.4rem 0.3em;\n}\n.weui_btn_area.weui_btn_area_inline {\n  display: flex;\n}\n.weui_btn_area.weui_btn_area_inline .weui_btn {\n  margin-top: auto;\n  margin-right: 0.4rem;\n  width: 100%;\n  flex: 1;\n}\n.weui_btn_area.weui_btn_area_inline .weui_btn:last-child {\n  margin-right: 0;\n}\n.weui_btn {\n  position: relative;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 0.37333333rem;\n  padding-right: 0.37333333rem;\n  box-sizing: border-box;\n  font-size: 0.48rem;\n  text-align: center;\n  text-decoration: none;\n  color: #FFFFFF;\n  line-height: 2.33333333;\n  border-radius: 5px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  overflow: hidden;\n}\n.weui_btn:after {\n  content: \" \";\n  width: 200%;\n  height: 200%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  transform: scale(0.5);\n  transform-origin: 0 0;\n  box-sizing: border-box;\n  border-radius: 10px;\n}\n.weui_btn.weui_btn_inline {\n  display: inline-block;\n}\n.weui_btn_default {\n  background-color: #F7F7F7;\n  color: #454545;\n}\n.weui_btn_default:not(.weui_btn_disabled):visited {\n  color: #454545;\n}\n.weui_btn_default:not(.weui_btn_disabled):active {\n  color: #A1A1A1;\n  background-color: #DEDEDE;\n}\n.weui_btn_primary {\n  background-color: #3b5999;\n}\n.weui_btn_primary:not(.weui_btn_disabled):visited {\n  color: #FFFFFF;\n}\n.weui_btn_primary:not(.weui_btn_disabled):active {\n  color: rgba(255, 255, 255, 0.4);\n  background-color: #283c64;\n}\n.weui_btn_warn {\n  background-color: #EF4F4F;\n}\n.weui_btn_warn:not(.weui_btn_disabled):visited {\n  color: #FFFFFF;\n}\n.weui_btn_warn:not(.weui_btn_disabled):active {\n  color: rgba(255, 255, 255, 0.4);\n  background-color: #C13E3E;\n}\n.weui_btn_disabled {\n  color: rgba(255, 255, 255, 0.6);\n}\n.weui_btn_disabled.weui_btn_default {\n  color: #C9C9C9;\n}\n.weui_btn_plain_primary {\n  color: #3b5999;\n  border: 1px solid #3b5999;\n}\nbutton.weui_btn_plain_primary,\ninput.weui_btn_plain_primary {\n  border-width: 1px;\n  background-color: transparent;\n}\n.weui_btn_plain_primary:active {\n  border-color: #283c64;\n}\n.weui_btn_plain_primary:after {\n  border-width: 0;\n}\n.weui_btn_plain_default {\n  color: #5A5A5A;\n  border: 1px solid #5A5A5A;\n}\nbutton.weui_btn_plain_default,\ninput.weui_btn_plain_default {\n  border-width: 1px;\n  background-color: transparent;\n}\n.weui_btn_plain_default:after {\n  border-width: 0;\n}\n", ""]);

	// exports


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    type: {
	      default: 'default'
	    },
	    disabled: Boolean,
	    mini: Boolean,
	    plain: Boolean,
	    text: String,
	    cssClasses: String
	  },
	  methods: {
	    onClick: function onClick() {
	      this.$emit('click');
	    }
	  },
	  computed: {
	    classes: function classes() {
	      return [{
	        weui_btn_disabled: this.disabled,
	        weui_btn_mini: this.mini
	      }, 'weui_btn_' + this.type, this.plain ? 'weui_btn_plain_' + this.type : '', this.cssClasses];
	    }
	  }
	};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "weui_btn",
	    class: _vm.classes,
	    attrs: {
	      "disabled": _vm.disabled
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _swiper = __webpack_require__(178);

	var _swiper2 = _interopRequireDefault(_swiper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_swiper2.default.install = function (Vue) {
	  Vue.component('LxSwiper', _swiper2.default);
	};

	exports.default = _swiper2.default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(179)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(181),
	  /* template */
	  __webpack_require__(188),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(180);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7994c608!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./swiper.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7994c608!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./swiper.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-slider {\n  overflow: hidden;\n  position: relative;\n}\n.vux-slider > .vux-indicator,\n.vux-slider .vux-indicator-right {\n  position: absolute;\n  right: 0.4rem;\n  bottom: 0.26666667rem;\n}\n.vux-slider > .vux-indicator > a,\n.vux-slider .vux-indicator-right > a {\n  float: left;\n  margin-left: 0.16rem;\n}\n.vux-slider > .vux-indicator > a:first-child,\n.vux-slider .vux-indicator-right > a:first-child {\n  margin-left: 0;\n}\n.vux-slider > .vux-indicator > a > .vux-icon-dot,\n.vux-slider .vux-indicator-right > a > .vux-icon-dot {\n  display: inline-block;\n  vertical-align: middle;\n  width: 0.16rem;\n  height: 0.16rem;\n  border-radius: 50%;\n  background-color: #d0cdd1;\n}\n.vux-slider > .vux-indicator > a > .vux-icon-dot.active,\n.vux-slider .vux-indicator-right > a > .vux-icon-dot.active {\n  background-color: #04BE02;\n}\n.vux-slider > .vux-indicator-center {\n  right: 50%;\n  transform: translateX(50%);\n}\n.vux-slider > .vux-indicator-left {\n  left: 0.4rem;\n  right: auto;\n}\n.vux-slider > .vux-swiper {\n  overflow: hidden;\n  position: relative;\n}\n.vux-slider > .vux-swiper > .vux-swiper-item {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.vux-slider > .vux-swiper > .vux-swiper-item > a {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.vux-slider > .vux-swiper > .vux-swiper-item > a > .vux-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background: center center no-repeat;\n  background-size: cover;\n}\n.vux-slider > .vux-swiper > .vux-swiper-item > a > .vux-swiper-desc {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 0.48rem;\n  font-size: 0.42666667rem;\n  padding: 0.53333333rem 1.33333333rem 0.32rem 0.34666667rem;\n  margin: 0;\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.7) 100%);\n  color: #fff;\n  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n}\n", ""]);

	// exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _swiper = __webpack_require__(182);

	var _swiper2 = _interopRequireDefault(_swiper);

	var _router = __webpack_require__(123);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  mounted: function mounted() {
	    if (!(this.list && this.list.length === 0)) {
	      this.render();
	    }
	    this.xheight = this.getHeight();
	  },

	  methods: {
	    clickListItem: function clickListItem(item) {
	      (0, _router.go)(item[this.urlKey], this.$router);
	      this.$emit('on-click-list-item', JSON.parse((0, _stringify2.default)(item)));
	    },
	    buildBackgroundUrl: function buildBackgroundUrl(url) {
	      return 'url(' + url + ')';
	    },
	    render: function render() {
	      var _this = this;

	      this.swiper && this.swiper.destroy();
	      this.swiper = new _swiper2.default({
	        container: this.$el,
	        direction: this.direction,
	        auto: this.auto,
	        loop: this.loop,
	        interval: this.interval,
	        threshold: this.threshold,
	        duration: this.duration,
	        height: this.height || this._height,
	        minMovingDistance: this.minMovingDistance,
	        imgList: this.imgList
	      }).on('swiped', function (prev, index) {
	        _this.current = index % _this.length;
	      });
	    },
	    rerender: function rerender() {
	      var _this2 = this;

	      if (!this.$el) {
	        return;
	      }
	      this.$nextTick(function () {
	        _this2.current = 0;
	        _this2.length = _this2.list.length || _this2.$children.length;
	        _this2.destroy();
	        _this2.render();
	      });
	    },
	    destroy: function destroy() {
	      this.swiper && this.swiper.destroy();
	    },
	    getHeight: function getHeight() {
	      var hasHeight = parseInt(this.height, 10);
	      if (hasHeight) return this.height;
	      if (!hasHeight) {
	        if (this.aspectRatio) {
	          return this.$el.offsetWidth * this.aspectRatio + 'px';
	        }
	        return '180px';
	      }
	    }
	  },
	  props: {
	    list: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    showDots: {
	      type: Boolean,
	      default: true
	    },
	    showDescMask: {
	      type: Boolean,
	      default: true
	    },
	    dotsPosition: {
	      type: String,
	      default: 'right'
	    },
	    dotsClass: String,
	    auto: {
	      type: Boolean,
	      default: false
	    },
	    loop: Boolean,
	    interval: {
	      type: Number,
	      default: 3000
	    },
	    threshold: {
	      type: Number,
	      default: 50
	    },
	    duration: {
	      type: Number,
	      default: 300
	    },
	    height: {
	      type: String,
	      default: 'auto'
	    },
	    aspectRatio: Number,
	    minMovingDistance: {
	      type: Number,
	      default: 0
	    },

	    value: {
	      type: Number,
	      default: 0
	    },
	    imgKey: {
	      type: String,
	      default: 'img'
	    },
	    urlKey: {
	      type: String,
	      default: 'url'
	    },
	    titleKey: {
	      type: String,
	      default: 'title'
	    },
	    cssClasses: String
	  },
	  data: function data() {
	    return {
	      current: this.value,
	      xheight: 'auto',
	      length: this.list.length
	    };
	  },

	  watch: {
	    list: function list(val) {
	      this.rerender();
	    },
	    current: function current(currentIndex) {
	      this.$emit('on-index-change', currentIndex);
	      this.$emit('input', currentIndex);
	    },
	    value: function value(val) {
	      var _this3 = this;

	      if (val !== this.current) {
	        this.$nextTick(function () {
	          _this3.swiper.go(val);
	        });
	      }
	    }
	  },
	  computed: {
	    classes: function classes() {
	      return this.cssClasses;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.destroy();
	  }
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _getIterator2 = __webpack_require__(183);

	var _getIterator3 = _interopRequireDefault(_getIterator2);

	var _classCallCheck2 = __webpack_require__(184);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(185);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _arrayFrom = __webpack_require__(186);

	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

	var _objectAssign = __webpack_require__(187);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var isServer = typeof window === 'undefined';

	var Swiper = function () {
	  function Swiper(options) {
	    (0, _classCallCheck3.default)(this, Swiper);

	    this._default = {
	      container: '.vux-swiper',
	      item: '.vux-swiper-item',
	      direction: 'vertical',
	      activeClass: 'active',
	      threshold: 50,
	      duration: 300,
	      auto: false,
	      loop: false,
	      interval: 3000,
	      height: 'auto',
	      minMovingDistance: 0
	    };
	    this._options = (0, _objectAssign2.default)(this._default, options);
	    this._options.height = this._options.height.replace('px', '');
	    this._start = {};
	    this._move = {};
	    this._end = {};
	    this._eventHandlers = {};
	    this._prev = this._current = this._goto = 0;
	    this._width = this._height = this._distance = 0;
	    this._offset = [];
	    this.$box = this._options.container;
	    this.$container = this._options.container.querySelector('.vux-swiper');
	    this.$items = this.$container.querySelectorAll(this._options.item);
	    this.count = this.$items.length;
	    this.realCount = this.$items.length;
	    this._position = [];
	    this._firstItemIndex = 0;
	    if (!this.count) {
	      return;
	    }
	    this._init();
	    this._auto();
	    this._bind();
	    this._onResize();
	    return this;
	  }

	  (0, _createClass3.default)(Swiper, [{
	    key: '_auto',
	    value: function _auto() {
	      var me = this;
	      me.stop();
	      if (me._options.auto) {
	        me.timer = setTimeout(function () {
	          me.next();
	        }, me._options.interval);
	      }
	    }
	  }, {
	    key: 'updateItemWidth',
	    value: function updateItemWidth() {
	      this._width = this.$box.offsetWidth;
	      this._distance = this._options.direction === 'horizontal' ? this._width : this._height;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.timer && clearTimeout(this.timer);
	    }
	  }, {
	    key: '_loop',
	    value: function _loop() {
	      return this._options.loop && this.realCount >= 3;
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var me = this;
	      this.resizeHandler = function () {
	        setTimeout(function () {
	          me.updateItemWidth();
	          me._setOffset();
	          me._setTransfrom();
	        }, 100);
	      };
	      window.addEventListener('orientationchange', this.resizeHandler, false);
	    }
	  }, {
	    key: '_init',
	    value: function _init() {
	      if (this._options.loop) {
	        this._loopTwoItems();
	      }
	      this._height = this._options.height === 'auto' ? 'auto' : this._options.height - 0;
	      this.updateItemWidth();
	      this._initPosition();
	      this._activate(this._current);
	      this._setOffset();
	      this._setTransfrom();
	      if (this._loop()) {
	        this._loopRender();
	      }
	    }
	  }, {
	    key: '_initPosition',
	    value: function _initPosition() {
	      for (var i = 0; i < this.realCount; i++) {
	        this._position.push(i);
	      }
	    }
	  }, {
	    key: '_movePosition',
	    value: function _movePosition(position) {
	      var me = this;
	      if (position > 0) {
	        var firstIndex = me._position.splice(0, 1);
	        me._position.push(firstIndex[0]);
	      } else if (position < 0) {
	        var lastIndex = me._position.pop();
	        me._position.unshift(lastIndex);
	      }
	    }
	  }, {
	    key: '_setOffset',
	    value: function _setOffset() {
	      var me = this;
	      var index = me._position.indexOf(me._current);
	      me._offset = [];
	      (0, _arrayFrom2.default)(me.$items).forEach(function ($item, key) {
	        me._offset.push((key - index) * me._distance);
	      });
	    }
	  }, {
	    key: '_setTransition',
	    value: function _setTransition(duration) {
	      duration = duration || this._options.duration || 'none';
	      var transition = duration === 'none' ? 'none' : duration + 'ms';
	      (0, _arrayFrom2.default)(this.$items).forEach(function ($item, key) {
	        $item.style.webkitTransition = transition;
	        $item.style.transition = transition;
	      });
	    }
	  }, {
	    key: '_setTransfrom',
	    value: function _setTransfrom(offset) {
	      var me = this;
	      offset = offset || 0;
	      (0, _arrayFrom2.default)(me.$items).forEach(function ($item, key) {
	        var distance = me._offset[key] + offset;
	        var transform = 'translate3d(' + distance + 'px, 0, 0)';
	        if (me._options.direction === 'vertical') {
	          transform = 'translate3d(0, ' + distance + 'px, 0)';
	        }
	        $item.style.webkitTransform = transform;
	        $item.style.transform = transform;
	      });
	    }
	  }, {
	    key: '_bind',
	    value: function _bind() {
	      var me = this;
	      me.touchstartHandler = function (e) {
	        me.stop();
	        me._start.x = e.changedTouches[0].pageX;
	        me._start.y = e.changedTouches[0].pageY;
	        me._setTransition('none');
	      };
	      me.touchmoveHandler = function (e) {
	        me._move.x = e.changedTouches[0].pageX;
	        me._move.y = e.changedTouches[0].pageY;
	        var distanceX = me._move.x - me._start.x;
	        var distanceY = me._move.y - me._start.y;
	        var distance = distanceY;
	        var noScrollerY = Math.abs(distanceX) > Math.abs(distanceY);
	        if (me._options.direction === 'horizontal' && noScrollerY) {
	          distance = distanceX;
	        }
	        if ((me._options.minMovingDistance && Math.abs(distance) >= me._options.minMovingDistance || !me._options.minMovingDistance) && noScrollerY) {
	          me._setTransfrom(distance);
	        }

	        noScrollerY && e.preventDefault();
	      };

	      me.touchendHandler = function (e) {
	        me._end.x = e.changedTouches[0].pageX;
	        me._end.y = e.changedTouches[0].pageY;

	        var distance = me._end.y - me._start.y;
	        if (me._options.direction === 'horizontal') {
	          distance = me._end.x - me._start.x;
	        }

	        distance = me.getDistance(distance);
	        if (distance !== 0 && me._options.minMovingDistance && Math.abs(distance) < me._options.minMovingDistance) {
	          return;
	        }
	        if (distance > me._options.threshold) {
	          me.move(-1);
	        } else if (distance < -me._options.threshold) {
	          me.move(1);
	        } else {
	          me.move(0);
	        }

	        me._loopRender();
	      };

	      me.transitionEndHandler = function (e) {
	        me._activate(me._current);
	        var cb = me._eventHandlers.swiped;
	        cb && cb.apply(me, [me._prev % me.count, me._current % me.count]);
	        me._auto();
	        me._loopRender();
	        e.preventDefault();
	      };
	      me.$container.addEventListener('touchstart', me.touchstartHandler, false);
	      me.$container.addEventListener('touchmove', me.touchmoveHandler, false);
	      me.$container.addEventListener('touchend', me.touchendHandler, false);
	      me.$items[1] && me.$items[1].addEventListener('webkitTransitionEnd', me.transitionEndHandler, false);
	    }
	  }, {
	    key: '_loopTwoItems',
	    value: function _loopTwoItems() {
	      if (isServer) return;

	      if (this.count === 2) {
	        var div = document.createElement('div');
	        var $item = void 0;
	        for (var i = this.$items.length - 1; i >= 0; i--) {
	          div.innerHTML = this.$items[i].outerHTML;
	          $item = div.querySelector(this._options.item);
	          $item.classList.add(this._options.item.replace('.', '') + '-clone');
	          this.$container.appendChild($item);
	        }
	        this.realCount = 4;
	      }
	    }
	  }, {
	    key: '_loopRender',
	    value: function _loopRender() {
	      var me = this;
	      if (me._loop()) {
	        if (me._offset[me._offset.length - 1] === 0) {
	          me.$container.appendChild(me.$items[0]);
	          me._loopEvent(1);
	        } else if (me._offset[0] === 0) {
	          me.$container.insertBefore(me.$items[me.$items.length - 1], me.$container.firstChild);
	          me._loopEvent(-1);
	        }
	      }
	    }
	  }, {
	    key: '_loopEvent',
	    value: function _loopEvent(num) {
	      var me = this;
	      me._itemDestoy();
	      me.$items = me.$container.querySelectorAll(me._options.item);
	      me.$items[1] && me.$items[1].addEventListener('webkitTransitionEnd', me.transitionEndHandler, false);
	      me._movePosition(num);
	      me._setOffset();
	      me._setTransfrom();
	    }
	  }, {
	    key: 'getDistance',
	    value: function getDistance(distance) {
	      if (this._loop()) {
	        return distance;
	      } else {
	        if (distance > 0 && this._current === 0) {
	          return 0;
	        } else if (distance < 0 && this._current === this.realCount - 1) {
	          return 0;
	        } else {
	          return distance;
	        }
	      }
	    }
	  }, {
	    key: '_moveIndex',
	    value: function _moveIndex(num) {
	      if (num !== 0) {
	        this._prev = this._current;
	        this._current += this.realCount;
	        this._current += num;
	        this._current %= this.realCount;
	      }
	    }
	  }, {
	    key: '_activate',
	    value: function _activate(index) {
	      var clazz = this._options.activeClass;
	      Array.prototype.forEach.call(this.$items, function ($item, key) {
	        $item.classList.remove(clazz);
	        if (index === Number($item.dataset.index)) {
	          $item.classList.add(clazz);
	        }
	      });
	    }
	  }, {
	    key: 'go',
	    value: function go(index) {
	      var me = this;
	      me.stop();

	      index = index || 0;
	      index += this.realCount;
	      index = index % this.realCount;
	      index = this._position.indexOf(index) - this._position.indexOf(this._current);

	      me._moveIndex(index);
	      me._setOffset();
	      me._setTransition();
	      me._setTransfrom();
	      me._auto();
	      return this;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.move(1);
	      return this;
	    }
	  }, {
	    key: 'move',
	    value: function move(num) {
	      this.go(this._current + num);
	      return this;
	    }
	  }, {
	    key: 'on',
	    value: function on(event, callback) {
	      if (this._eventHandlers[event]) {
	        console.error('[swiper] event ' + event + ' is already register');
	      }
	      if (typeof callback !== 'function') {
	        console.error('[swiper] parameter callback must be a function');
	      }
	      this._eventHandlers[event] = callback;
	      return this;
	    }
	  }, {
	    key: '_itemDestoy',
	    value: function _itemDestoy() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.$items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var item = _step.value;

	          item.removeEventListener('webkitTransitionEnd', this.transitionEndHandler, false);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (isServer) return;
	      this.stop();
	      this._current = 0;
	      this._setTransfrom(0);
	      window.removeEventListener('orientationchange', this.resizeHandler, false);
	      this.$container.removeEventListener('touchstart', this.touchstartHandler, false);
	      this.$container.removeEventListener('touchmove', this.touchmoveHandler, false);
	      this.$container.removeEventListener('touchend', this.touchendHandler, false);
	      this._itemDestoy();

	      if (this._options.loop && this.count === 2) {
	        var $item = this.$container.querySelector(this._options.item + '-clone');
	        $item && this.$container.removeChild($item);
	        $item = this.$container.querySelector(this._options.item + '-clone');
	        $item && this.$container.removeChild($item);
	      }
	    }
	  }]);
	  return Swiper;
	}();

	exports.default = Swiper;

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/get-iterator");

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/classCallCheck");

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/createClass");

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = require("array-from");

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = require("object-assign");

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-slider",
	    class: _vm.classes
	  }, [_c('div', {
	    staticClass: "vux-swiper",
	    style: ({
	      height: _vm.xheight
	    })
	  }, [_vm._t("default"), _vm._l((_vm.list), function(item, index) {
	    return _c('div', {
	      staticClass: "vux-swiper-item",
	      attrs: {
	        "data-index": index
	      },
	      on: {
	        "click": function($event) {
	          _vm.clickListItem(item)
	        }
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "javascript:"
	      }
	    }, [_c('div', {
	      staticClass: "vux-img",
	      style: ({
	        backgroundImage: _vm.buildBackgroundUrl(item[_vm.imgKey])
	      })
	    }), (_vm.showDescMask) ? _c('p', {
	      staticClass: "vux-swiper-desc"
	    }, [_vm._v(_vm._s(item[_vm.titleKey]))]) : _vm._e()])])
	  })], 2), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showDots),
	      expression: "showDots"
	    }],
	    class: [_vm.dotsClass, 'vux-indicator', 'vux-indicator-' + _vm.dotsPosition]
	  }, _vm._l((_vm.length), function(key) {
	    return _c('a', {
	      attrs: {
	        "href": "javascript:"
	      }
	    }, [_c('i', {
	      staticClass: "vux-icon-dot",
	      class: {
	        'active': key === _vm.current + 1
	      }
	    })])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _swiperItem = __webpack_require__(190);

	var _swiperItem2 = _interopRequireDefault(_swiperItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_swiperItem2.default.install = function (Vue) {
	  Vue.component('LxSwiperItem', _swiperItem2.default);
	};

	exports.default = _swiperItem2.default;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(191)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(193),
	  /* template */
	  __webpack_require__(194),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6949dace!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./swiper-item.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6949dace!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./swiper-item.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

	// exports


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  created: function created() {
	    var _this = this;

	    this.$nextTick(function () {
	      _this.$parent.rerender();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var $parent = this.$parent;
	    this.$nextTick(function () {
	      $parent.rerender();
	    });
	  }
	};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-swiper-item"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _sticky = __webpack_require__(196);

	var _sticky2 = _interopRequireDefault(_sticky);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_sticky2.default.install = function (Vue) {
	  Vue.component('LxSticky', _sticky2.default);
	};

	exports.default = _sticky2.default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(197)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(199),
	  /* template */
	  __webpack_require__(201),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(198);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-114bdbdc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sticky.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-114bdbdc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sticky.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-sticky {\r\n  width: 100%;\r\n  position: sticky;\r\n  top: 0;\n}\n.vux-fixed {\r\n  width: 100%;\r\n  position: fixed;\r\n  top: 0;\n}\r\n", ""]);

	// exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _sticky = __webpack_require__(200);

	var _sticky2 = _interopRequireDefault(_sticky);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  mounted: function mounted() {
	    (0, _sticky2.default)(this.$el);
	  }
	};

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (nav) {
	  if (isServer) return;
	  if (gtIOS6() || isSupportSticky()) {
	    nav.classList.add('vux-sticky');
	  } else {
	    var navOffsetY = nav.offsetTop;
	    window.addEventListener('scroll', function () {
	      window.scrollY >= navOffsetY ? nav.classList.add('vux-fixed') : nav.classList.remove('vux-fixed');
	    });
	  }
	};

	var isServer = typeof window === 'undefined';

	function gtIOS6() {
	  if (isServer) return;
	  var userAgent = window.navigator.userAgent;
	  var ios = userAgent.match(/(iPad|iPhone|iPod)\s+OS\s([\d_.]+)/);
	  return ios && ios[2] && parseInt(ios[2].replace(/_/g, '.'), 10) >= 6;
	}

	function isSupportSticky() {
	  if (isServer) return;
	  var prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-'];
	  var stickyText = '';
	  for (var i = 0; i < prefixTestList.length; i++) {
	    stickyText += 'position:' + prefixTestList[i] + 'sticky';
	  }

	  var div = document.createElement('div');
	  var body = document.body;
	  div.style.cssText = 'display:none' + stickyText;
	  body.appendChild(div);
	  var isSupport = /sticky/i.test(window.getComputedStyle(div).position);
	  body.removeChild(div);
	  div = null;
	  return isSupport;
	}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _picker = __webpack_require__(203);

	var _picker2 = _interopRequireDefault(_picker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_picker2.default.install = function (Vue) {
	  Vue.component('LxPicker', _picker2.default);
	};

	exports.default = _picker2.default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(204)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(206),
	  /* template */
	  __webpack_require__(224),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(205);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f3384f88!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./picker.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f3384f88!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./picker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.scroller-component {\n  display: block;\n  position: relative;\n  height: 6.34666667rem;\n  overflow: hidden;\n  width: 100%;\n}\n.scroller-content {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n.scroller-mask {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  margin: 0 auto;\n  width: 100%;\n  z-index: 3;\n  background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), linear-gradient(to top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));\n  background-position: top, bottom;\n  background-size: 100% 2.72rem;\n  background-repeat: no-repeat;\n}\n.scroller-item {\n  text-align: center;\n  font-size: 0.42666667rem;\n  height: 0.90666667rem;\n  line-height: 0.90666667rem;\n  color: #000;\n}\n.scroller-indicator {\n  width: 100%;\n  height: 0.90666667rem;\n  position: absolute;\n  left: 0;\n  top: 2.72rem;\n  z-index: 3;\n  background-image: -webkit-linear-gradient(top, #d0d0d0, #d0d0d0, transparent, transparent), -webkit-linear-gradient(bottom, #d0d0d0, #d0d0d0, transparent, transparent);\n  background-image: linear-gradient(to bottom, #d0d0d0, #d0d0d0, transparent, transparent), linear-gradient(to top, #d0d0d0, #d0d0d0, transparent, transparent);\n  background-position: top, bottom;\n  background-size: 100% 1px;\n  background-repeat: no-repeat;\n}\n.scroller-item {\n  line-clamp: 1;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);

	// exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _typeof2 = __webpack_require__(88);

	var _typeof3 = _interopRequireDefault(_typeof2);

	var _scroller = __webpack_require__(207);

	var _scroller2 = _interopRequireDefault(_scroller);

	var _flexbox = __webpack_require__(210);

	var _flexbox2 = _interopRequireDefault(_flexbox);

	var _flexboxItem = __webpack_require__(216);

	var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

	var _chain = __webpack_require__(222);

	var _chain2 = _interopRequireDefault(_chain);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: 'picker',
	  components: {
	    Flexbox: _flexbox2.default,
	    FlexboxItem: _flexboxItem2.default
	  },
	  created: function created() {
	    if (this.columns !== 0) {
	      var length = this.columns;
	      this.store = new _chain2.default(this.data, length, this.fixedColumns || this.columns);
	      this.currentData = this.store.getColumns(this.value);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;

	    this.uuid = Math.random().toString(36).substring(3, 8);
	    this.$nextTick(function () {
	      _this2.render(_this2.currentData, _this2.currentValue);
	    });
	  },

	  props: {
	    data: Array,
	    columns: {
	      type: Number,
	      default: 0
	    },
	    fixedColumns: {
	      type: Number,
	      default: 0
	    },
	    value: Array,
	    itemClass: {
	      type: String,
	      default: 'scroller-item'
	    }
	  },
	  methods: {
	    getId: function getId(i) {
	      return '#vux-picker-' + this.uuid + '-' + i;
	    },
	    render: function render(data, value) {
	      this.count = this.currentData.length;
	      var _this = this;
	      if (!data || !data.length) {
	        return;
	      }
	      var count = this.currentData.length;

	      if (value.length < count) {
	        for (var i = 0; i < count; i++) {
	          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
	        }
	      }

	      var _loop = function _loop(_i) {
	        if (!document.querySelector(_this.getId(_i))) {
	          return {
	            v: void 0
	          };
	        }

	        _this.scroller[_i] && _this.scroller[_i].destroy();
	        _this.scroller[_i] = new _scroller2.default(_this.getId(_i), {
	          data: data[_i],
	          defaultValue: value[_i] || data[_i][0].value,
	          itemClass: _this.itemClass,
	          onSelect: function onSelect(value) {
	            _this.$set(_this.currentValue, _i, value);
	            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
	              _this.$nextTick(function () {
	                _this.$emit('on-change', _this.getValue());
	              });
	            }
	            if (_this.columns !== 0) {
	              _this.renderChain(_i + 1);
	            }
	          }
	        });
	        if (_this.currentValue && _this.currentValue !== value) {
	          _this.scroller[_i].select(value[_i]);
	        }
	      };

	      for (var _i = 0; _i < data.length; _i++) {
	        var _ret = _loop(_i);

	        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	      }
	    },
	    renderChain: function renderChain(i) {
	      if (!this.columns) {
	        return;
	      }

	      if (i > this.count - 1) {
	        return;
	      }

	      var _this = this;
	      var ID = this.getId(i);

	      if (this.scroller[i]) {
	        this.scroller[i].destroy();
	      }
	      var list = this.store.getChildren(_this.getValue()[i - 1]);
	      this.scroller[i] = new _scroller2.default(ID, {
	        data: list,
	        itemClass: _this.itemClass,
	        onSelect: function onSelect(value) {
	          _this.$set(_this.currentValue, i, value);
	          _this.$nextTick(function () {
	            _this.$emit('on-change', _this.getValue());
	          });
	          _this.renderChain(i + 1);
	        }
	      });

	      if (list.length) {
	        this.$set(this.currentValue, i, list[0].value);
	        this.renderChain(i + 1);
	      } else {
	        this.$set(this.currentValue, i, null);
	      }
	    },
	    getValue: function getValue() {
	      var data = [];
	      for (var i = 0; i < this.currentData.length; i++) {
	        if (this.scroller[i]) {
	          data.push(this.scroller[i].value);
	        } else {
	          return [];
	        }
	      }
	      return data;
	    },
	    emitValueChange: function emitValueChange(val) {
	      if (!this.columns || this.columns && val.length === this.store.count) {
	        this.$emit('on-change', val);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      scroller: [],
	      count: 0,
	      uuid: '',
	      currentData: this.data,
	      currentValue: this.value
	    };
	  },

	  watch: {
	    value: function value(val) {
	      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentValue)) {
	        this.currentValue = val;
	      }
	    },
	    currentValue: function currentValue(val, oldVal) {
	      this.$emit('input', val);

	      if (this.columns !== 0) {
	        if (val.length > 0) {
	          if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(oldVal)) {
	            this.currentData = this.store.getColumns(val);
	            this.$nextTick(function () {
	              this.render(this.currentData, val);
	            });
	          }
	        }
	      } else {
	        if (val.length) {
	          for (var i = 0; i < val.length; i++) {
	            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
	              this.scroller[i].select(val[i]);
	            }
	          }
	        } else {
	          this.render(this.currentData, []);
	        }
	      }
	    },
	    data: function data(val) {
	      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.currentData)) {
	        this.currentData = val;
	      }
	    },
	    currentData: function currentData(newData) {
	      var _this3 = this;

	      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
	        this.$nextTick(function () {
	          _this3.render(newData, _this3.currentValue);

	          _this3.$nextTick(function () {
	            _this3.emitValueChange(_this3.getValue());

	            if ((0, _stringify2.default)(_this3.getValue()) !== (0, _stringify2.default)(_this3.currentValue)) {
	              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
	                _this3.currentValue = _this3.getValue();
	              }
	            }
	          });
	        });
	      } else {
	        if (this.columns !== 0) {
	          if (!newData.length) {
	            return;
	          }
	          var length = this.columns;
	          this.store = new _chain2.default(newData, length, this.fixedColumns || this.columns);
	          this.currentData = this.store.getColumns(this.currentValue);
	        }
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    for (var i = 0; i < this.count; i++) {
	      this.scroller[i] && this.scroller[i].destroy();
	      this.scroller[i] = null;
	    }
	  }
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _animate = __webpack_require__(208);

	var _animate2 = _interopRequireDefault(_animate);

	var _util = __webpack_require__(209);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TEMPLATE = '\n<div class="scroller-component" data-role="component">\n  <div class="scroller-mask" data-role="mask"></div>\n  <div class="scroller-indicator" data-role="indicator"></div>\n  <div class="scroller-content" data-role="content"></div>\n</div>\n';

	var Scroller = function Scroller(container, options) {
	  var self = this;

	  options = options || {};

	  self.options = {
	    itemClass: 'scroller-item',
	    onSelect: function onSelect() {},

	    defaultValue: 0,
	    data: []
	  };

	  for (var key in options) {
	    if (options[key] !== undefined) {
	      self.options[key] = options[key];
	    }
	  }

	  self.__container = (0, _util.getElement)(container);

	  var tempContainer = document.createElement('div');
	  tempContainer.innerHTML = options.template || TEMPLATE;

	  var component = self.__component = tempContainer.querySelector('[data-role=component]');
	  var content = self.__content = component.querySelector('[data-role=content]');
	  var indicator = component.querySelector('[data-role=indicator]');

	  var data = self.options.data;
	  var html = '';
	  if (data.length && data[0].constructor === Object) {
	    data.forEach(function (row) {
	      html += '<div class="' + self.options.itemClass + '" data-value="' + row.value + '">' + row.name + '</div>';
	    });
	  } else {
	    data.forEach(function (val) {
	      html += '<div class="' + self.options.itemClass + '" data-value="' + val + '">' + val + '</div>';
	    });
	  }
	  content.innerHTML = html;
	  if (self.__container) {
	    self.__container.appendChild(component);
	  }

	  self.__itemHeight = parseFloat((0, _util.getComputedStyle)(indicator, 'height'), 10).toFixed(6);

	  self.__callback = options.callback || function (top) {
	    content.style.webkitTransform = 'translate3d(0, ' + -top + 'px, 0)';
	  };

	  var rect = component.getBoundingClientRect();

	  self.__clientTop = rect.top + component.clientTop || 0;

	  self.__setDimensions(component.clientHeight, content.offsetHeight);

	  if (component.clientHeight === 0) {
	    self.__setDimensions(parseInt((0, _util.getComputedStyle)(component, 'height'), 10), 204);
	  }
	  self.select(self.options.defaultValue, false);

	  component.addEventListener('touchstart', function (e) {
	    if (e.target.tagName.match(/input|textarea|select/i)) {
	      return;
	    }
	    e.preventDefault();
	    self.__doTouchStart(e.touches, e.timeStamp);
	  }, false);

	  component.addEventListener('touchmove', function (e) {
	    self.__doTouchMove(e.touches, e.timeStamp);
	  }, false);

	  component.addEventListener('touchend', function (e) {
	    self.__doTouchEnd(e.timeStamp);
	  }, false);
	};

	var members = {
	  value: null,
	  __prevValue: null,
	  __isSingleTouch: false,
	  __isTracking: false,
	  __didDecelerationComplete: false,
	  __isGesturing: false,
	  __isDragging: false,
	  __isDecelerating: false,
	  __isAnimating: false,
	  __clientTop: 0,
	  __clientHeight: 0,
	  __contentHeight: 0,
	  __itemHeight: 0,
	  __scrollTop: 0,
	  __minScrollTop: 0,
	  __maxScrollTop: 0,
	  __scheduledTop: 0,
	  __lastTouchTop: null,
	  __lastTouchMove: null,
	  __positions: null,
	  __minDecelerationScrollTop: null,
	  __maxDecelerationScrollTop: null,
	  __decelerationVelocityY: null,

	  __setDimensions: function __setDimensions(clientHeight, contentHeight) {
	    var self = this;

	    self.__clientHeight = clientHeight;
	    self.__contentHeight = contentHeight;

	    var totalItemCount = self.options.data.length;
	    var clientItemCount = Math.floor(self.__clientHeight / self.__itemHeight);

	    self.__minScrollTop = -self.__itemHeight * (clientItemCount / 2);
	    self.__maxScrollTop = self.__minScrollTop + totalItemCount * self.__itemHeight - 0.1;
	  },
	  selectByIndex: function selectByIndex(index, animate) {
	    var self = this;
	    if (index < 0 || index > self.__content.childElementCount - 1) {
	      return;
	    }
	    self.__scrollTop = self.__minScrollTop + index * self.__itemHeight;

	    self.scrollTo(self.__scrollTop, animate);

	    self.__selectItem(self.__content.children[index]);
	  },
	  select: function select(value, animate) {
	    var self = this;

	    var children = self.__content.children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      if (children[i].dataset.value === value) {
	        self.selectByIndex(i, animate);
	        return;
	      }
	    }

	    self.selectByIndex(0, animate);
	  },
	  getValue: function getValue() {
	    return this.value;
	  },
	  scrollTo: function scrollTo(top, animate) {
	    var self = this;

	    animate = animate === undefined ? true : animate;

	    if (self.__isDecelerating) {
	      _animate2.default.stop(self.__isDecelerating);
	      self.__isDecelerating = false;
	    }

	    top = Math.round(top / self.__itemHeight) * self.__itemHeight;
	    top = Math.max(Math.min(self.__maxScrollTop, top), self.__minScrollTop);

	    if (top === self.__scrollTop || !animate) {
	      self.__publish(top);
	      self.__scrollingComplete();
	      return;
	    }
	    self.__publish(top, 250);
	  },
	  destroy: function destroy() {
	    this.__component.parentNode && this.__component.parentNode.removeChild(this.__component);
	  },
	  __selectItem: function __selectItem(selectedItem) {
	    var self = this;

	    var selectedItemClass = self.options.itemClass + '-selected';
	    var lastSelectedElem = self.__content.querySelector('.' + selectedItemClass);
	    if (lastSelectedElem) {
	      lastSelectedElem.classList.remove(selectedItemClass);
	    }
	    if (selectedItem) {
	      selectedItem.classList.add(selectedItemClass);
	    }
	    if (self.value !== null) {
	      self.__prevValue = self.value;
	    }
	    if (selectedItem) {
	      self.value = selectedItem.dataset.value;
	    }
	  },
	  __scrollingComplete: function __scrollingComplete() {
	    var self = this;

	    var index = Math.ceil((self.__scrollTop - self.__minScrollTop - self.__itemHeight / 2) / self.__itemHeight);

	    self.__selectItem(self.__content.children[index]);

	    if (self.__prevValue !== null && self.__prevValue !== self.value) {
	      self.options.onSelect(self.value);
	    }
	  },
	  __doTouchStart: function __doTouchStart(touches, timeStamp) {
	    var self = this;

	    if (touches.length == null) {
	      throw new Error('Invalid touch list: ' + touches);
	    }
	    if (timeStamp instanceof Date) {
	      timeStamp = timeStamp.valueOf();
	    }
	    if (typeof timeStamp !== 'number') {
	      throw new Error('Invalid timestamp value: ' + timeStamp);
	    }

	    self.__interruptedAnimation = true;

	    if (self.__isDecelerating) {
	      _animate2.default.stop(self.__isDecelerating);
	      self.__isDecelerating = false;
	      self.__interruptedAnimation = true;
	    }

	    if (self.__isAnimating) {
	      _animate2.default.stop(self.__isAnimating);
	      self.__isAnimating = false;
	      self.__interruptedAnimation = true;
	    }

	    var currentTouchTop;
	    var isSingleTouch = touches.length === 1;
	    if (isSingleTouch) {
	      currentTouchTop = touches[0].pageY;
	    } else {
	      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
	    }

	    self.__initialTouchTop = currentTouchTop;
	    self.__lastTouchTop = currentTouchTop;
	    self.__lastTouchMove = timeStamp;
	    self.__lastScale = 1;
	    self.__enableScrollY = !isSingleTouch;
	    self.__isTracking = true;
	    self.__didDecelerationComplete = false;
	    self.__isDragging = !isSingleTouch;
	    self.__isSingleTouch = isSingleTouch;
	    self.__positions = [];
	  },
	  __doTouchMove: function __doTouchMove(touches, timeStamp, scale) {
	    var self = this;

	    if (touches.length == null) {
	      throw new Error('Invalid touch list: ' + touches);
	    }
	    if (timeStamp instanceof Date) {
	      timeStamp = timeStamp.valueOf();
	    }
	    if (typeof timeStamp !== 'number') {
	      throw new Error('Invalid timestamp value: ' + timeStamp);
	    }

	    if (!self.__isTracking) {
	      return;
	    }

	    var currentTouchTop;

	    if (touches.length === 2) {
	      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
	    } else {
	      currentTouchTop = touches[0].pageY;
	    }

	    var positions = self.__positions;

	    if (self.__isDragging) {
	      var moveY = currentTouchTop - self.__lastTouchTop;
	      var scrollTop = self.__scrollTop;

	      if (self.__enableScrollY) {
	        scrollTop -= moveY;

	        var minScrollTop = self.__minScrollTop;
	        var maxScrollTop = self.__maxScrollTop;

	        if (scrollTop > maxScrollTop || scrollTop < minScrollTop) {
	          if (scrollTop > maxScrollTop) {
	            scrollTop = maxScrollTop;
	          } else {
	            scrollTop = minScrollTop;
	          }
	        }
	      }

	      if (positions.length > 40) {
	        positions.splice(0, 20);
	      }

	      positions.push(scrollTop, timeStamp);

	      self.__publish(scrollTop);
	    } else {
	      var minimumTrackingForScroll = 0;
	      var minimumTrackingForDrag = 5;

	      var distanceY = Math.abs(currentTouchTop - self.__initialTouchTop);

	      self.__enableScrollY = distanceY >= minimumTrackingForScroll;

	      positions.push(self.__scrollTop, timeStamp);

	      self.__isDragging = self.__enableScrollY && distanceY >= minimumTrackingForDrag;

	      if (self.__isDragging) {
	        self.__interruptedAnimation = false;
	      }
	    }

	    self.__lastTouchTop = currentTouchTop;
	    self.__lastTouchMove = timeStamp;
	    self.__lastScale = scale;
	  },
	  __doTouchEnd: function __doTouchEnd(timeStamp) {
	    var self = this;

	    if (timeStamp instanceof Date) {
	      timeStamp = timeStamp.valueOf();
	    }
	    if (typeof timeStamp !== 'number') {
	      throw new Error('Invalid timestamp value: ' + timeStamp);
	    }

	    if (!self.__isTracking) {
	      return;
	    }

	    self.__isTracking = false;

	    if (self.__isDragging) {
	      self.__isDragging = false;

	      if (self.__isSingleTouch && timeStamp - self.__lastTouchMove <= 100) {
	        var positions = self.__positions;
	        var endPos = positions.length - 1;
	        var startPos = endPos;

	        for (var i = endPos; i > 0 && positions[i] > self.__lastTouchMove - 100; i -= 2) {
	          startPos = i;
	        }

	        if (startPos !== endPos) {
	          var timeOffset = positions[endPos] - positions[startPos];
	          var movedTop = self.__scrollTop - positions[startPos - 1];

	          self.__decelerationVelocityY = movedTop / timeOffset * (1000 / 60);

	          var minVelocityToStartDeceleration = 4;

	          if (Math.abs(self.__decelerationVelocityY) > minVelocityToStartDeceleration) {
	            self.__startDeceleration(timeStamp);
	          }
	        }
	      }
	    }

	    if (!self.__isDecelerating) {
	      self.scrollTo(self.__scrollTop);
	    }

	    self.__positions.length = 0;
	  },
	  __publish: function __publish(top, animationDuration) {
	    var self = this;

	    var wasAnimating = self.__isAnimating;
	    if (wasAnimating) {
	      _animate2.default.stop(wasAnimating);
	      self.__isAnimating = false;
	    }

	    if (animationDuration) {
	      self.__scheduledTop = top;

	      var oldTop = self.__scrollTop;
	      var diffTop = top - oldTop;

	      var step = function step(percent, now, render) {
	        self.__scrollTop = oldTop + diffTop * percent;

	        if (self.__callback) {
	          self.__callback(self.__scrollTop);
	        }
	      };

	      var verify = function verify(id) {
	        return self.__isAnimating === id;
	      };

	      var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
	        if (animationId === self.__isAnimating) {
	          self.__isAnimating = false;
	        }
	        if (self.__didDecelerationComplete || wasFinished) {
	          self.__scrollingComplete();
	        }
	      };

	      self.__isAnimating = _animate2.default.start(step, verify, completed, animationDuration, wasAnimating ? _util.easeOutCubic : _util.easeInOutCubic);
	    } else {
	      self.__scheduledTop = self.__scrollTop = top;

	      if (self.__callback) {
	        self.__callback(top);
	      }
	    }
	  },
	  __startDeceleration: function __startDeceleration(timeStamp) {
	    var self = this;

	    self.__minDecelerationScrollTop = self.__minScrollTop;
	    self.__maxDecelerationScrollTop = self.__maxScrollTop;

	    var step = function step(percent, now, render) {
	      self.__stepThroughDeceleration(render);
	    };

	    var minVelocityToKeepDecelerating = 0.5;

	    var verify = function verify() {
	      var shouldContinue = Math.abs(self.__decelerationVelocityY) >= minVelocityToKeepDecelerating;
	      if (!shouldContinue) {
	        self.__didDecelerationComplete = true;
	      }
	      return shouldContinue;
	    };

	    var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
	      self.__isDecelerating = false;
	      if (self.__scrollTop <= self.__minScrollTop || self.__scrollTop >= self.__maxScrollTop) {
	        self.scrollTo(self.__scrollTop);
	        return;
	      }
	      if (self.__didDecelerationComplete) {
	        self.__scrollingComplete();
	      }
	    };

	    self.__isDecelerating = _animate2.default.start(step, verify, completed);
	  },
	  __stepThroughDeceleration: function __stepThroughDeceleration(render) {
	    var self = this;

	    var scrollTop = self.__scrollTop + self.__decelerationVelocityY;

	    var scrollTopFixed = Math.max(Math.min(self.__maxDecelerationScrollTop, scrollTop), self.__minDecelerationScrollTop);
	    if (scrollTopFixed !== scrollTop) {
	      scrollTop = scrollTopFixed;
	      self.__decelerationVelocityY = 0;
	    }

	    if (Math.abs(self.__decelerationVelocityY) <= 1) {
	      if (Math.abs(scrollTop % self.__itemHeight) < 1) {
	        self.__decelerationVelocityY = 0;
	      }
	    } else {
	      self.__decelerationVelocityY *= 0.95;
	    }

	    self.__publish(scrollTop);
	  }
	};

	for (var key in members) {
	  Scroller.prototype[key] = members[key];
	}

	module.exports = Scroller;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var time = Date.now || function () {
	  return +new Date();
	};

	var running = {};
	var counter = 1;
	var desiredFrames = 60;
	var millisecondsPerSecond = 1000;
	var isServer = typeof window === 'undefined';(function () {
	  if (isServer) return;
	  var lastTime = 0;
	  var vendors = ['ms', 'moz', 'webkit', 'o'];
	  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }

	  if (!window.requestAnimationFrame) {
	    window.requestAnimationFrame = function (callback, element) {
	      var currTime = new Date().getTime();
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	      var id = window.setTimeout(function () {
	        callback(currTime + timeToCall);
	      }, timeToCall);
	      lastTime = currTime + timeToCall;
	      return id;
	    };
	  }
	  if (!window.cancelAnimationFrame) {
	    window.cancelAnimationFrame = function (id) {
	      clearTimeout(id);
	    };
	  }
	})();

	exports.default = {
	  requestAnimationFrame: function () {
	    if (isServer) return '';
	    var requestFrame = window.requestAnimationFrame;
	    return function (callback, root) {
	      requestFrame(callback, root);
	    };
	  }(),

	  stop: function stop(id) {
	    var cleared = running[id] != null;
	    if (cleared) {
	      running[id] = null;
	    }
	    return cleared;
	  },
	  isRunning: function isRunning(id) {
	    return running[id] != null;
	  },
	  start: function start(stepCallback, verifyCallback, completedCallback, duration, easingMethod, root) {
	    var _this = this;
	    var start = time();
	    var lastFrame = start;
	    var percent = 0;
	    var dropCounter = 0;
	    var id = counter++;

	    if (!root) {
	      root = document.body;
	    }

	    if (id % 20 === 0) {
	      var newRunning = {};
	      for (var usedId in running) {
	        newRunning[usedId] = true;
	      }
	      running = newRunning;
	    }

	    var step = function step(virtual) {
	      var render = virtual !== true;

	      var now = time();

	      if (!running[id] || verifyCallback && !verifyCallback(id)) {
	        running[id] = null;
	        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, false);
	        return;
	      }

	      if (render) {
	        var droppedFrames = Math.round((now - lastFrame) / (millisecondsPerSecond / desiredFrames)) - 1;
	        for (var j = 0; j < Math.min(droppedFrames, 4); j++) {
	          step(true);
	          dropCounter++;
	        }
	      }

	      if (duration) {
	        percent = (now - start) / duration;
	        if (percent > 1) {
	          percent = 1;
	        }
	      }

	      var value = easingMethod ? easingMethod(percent) : percent;
	      if ((stepCallback(value, now, render) === false || percent === 1) && render) {
	        running[id] = null;
	        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, percent === 1 || duration == null);
	      } else if (render) {
	        lastFrame = now;
	        _this.requestAnimationFrame(step, root);
	      }
	    };

	    running[id] = true;

	    _this.requestAnimationFrame(step, root);

	    return id;
	  }
	};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getElement = getElement;
	exports.getComputedStyle = getComputedStyle;
	exports.easeOutCubic = easeOutCubic;
	exports.easeInOutCubic = easeInOutCubic;
	var isServer = typeof window === 'undefined';
	function getElement(expr) {
	  return typeof expr === 'string' ? document.querySelector(expr) : expr;
	}

	function getComputedStyle(el, key) {
	  if (isServer) return '';
	  var computedStyle = window.getComputedStyle(el);
	  return computedStyle[key] || '';
	}

	function easeOutCubic(pos) {
	  return Math.pow(pos - 1, 3) + 1;
	}

	function easeInOutCubic(pos) {
	  if ((pos /= 0.5) < 1) {
	    return 0.5 * Math.pow(pos, 3);
	  }
	  return 0.5 * (Math.pow(pos - 2, 3) + 2);
	}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _flexbox = __webpack_require__(211);

	var _flexbox2 = _interopRequireDefault(_flexbox);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_flexbox2.default.install = function (Vue) {
	  Vue.component('LxFlexbox', _flexbox2.default);
	};

	exports.default = _flexbox2.default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(212)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(214),
	  /* template */
	  __webpack_require__(215),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(213);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6834f022!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./flexbox.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6834f022!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./flexbox.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-flexbox {\n  width: 100%;\n  text-align: left;\n  display: flex;\n  box-align: center;\n  align-items: center;\n}\n.vux-flexbox .vux-flexbox-item {\n  flex: 1;\n  min-width: 0.53333333rem;\n  width: 0%;\n}\n.vux-flexbox-item > .vux-flexbox {\n  width: 100%;\n}\n.vux-flexbox .vux-flexbox-item:first-child {\n  margin-left: 0!important;\n  margin-top: 0!important;\n}\n.vux-flex-col {\n  box-orient: vertical;\n  flex-direction: column;\n}\n.vux-flex-col > .vux-flexbox-item {\n  width: 100%;\n}\n.vux-flex-row {\n  box-direction: row;\n  box-orient: horizontal;\n  flex-direction: row;\n}\n", ""]);

	// exports


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    gutter: {
	      type: Number,
	      default: 8
	    },
	    orient: {
	      type: String,
	      default: 'horizontal'
	    },
	    justify: String,
	    align: String,
	    wrap: String,
	    direction: String
	  },
	  computed: {
	    styles: function styles() {
	      return {
	        'justify-content': this.justify,
	        'align-items': this.align,
	        'flex-wrap': this.wrap,
	        'flex-direction': this.direction
	      };
	    }
	  }
	};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-flexbox",
	    class: {
	      'vux-flex-col': _vm.orient === 'vertical', 'vux-flex-row': _vm.orient === 'horizontal'
	    },
	    style: (_vm.styles)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _flexboxItem = __webpack_require__(217);

	var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_flexboxItem2.default.install = function (Vue) {
	  Vue.component('LxFlexboxItem', _flexboxItem2.default);
	};

	exports.default = _flexboxItem2.default;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(218)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(220),
	  /* template */
	  __webpack_require__(221),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(219);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d701bfc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./flexbox-item.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d701bfc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./flexbox-item.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

	// exports


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});


	var prefixList = ['-moz-box-', '-webkit-box-', ''];

	exports.default = {
	  props: {
	    span: [Number, String],
	    order: [Number, String]
	  },
	  methods: {
	    buildWidth: function buildWidth(width) {
	      if (typeof width === 'number') {
	        if (width < 1) {
	          return width;
	        } else {
	          return width / 12;
	        }
	      } else if (typeof width === 'string') {
	        return width.replace('px', '') / document.documentElement.offsetWidth;
	      }
	    }
	  },
	  computed: {
	    style: function style() {
	      var styles = {};
	      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';
	      styles[marginName] = this.$parent.gutter + 'px';

	      if (this.span) {
	        for (var i = 0; i < prefixList.length; i++) {
	          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
	        }
	      }
	      if (typeof this.order !== 'undefined') {
	        styles.order = this.order;
	      }
	      return styles;
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-flexbox-item",
	    style: (_vm.style)
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _classCallCheck2 = __webpack_require__(184);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(185);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _arrayFilter = __webpack_require__(223);

	var _arrayFilter2 = _interopRequireDefault(_arrayFilter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Manager = function () {
	  function Manager(data, count, fixedColumns) {
	    (0, _classCallCheck3.default)(this, Manager);

	    this.data = data;
	    this.count = count;
	    if (fixedColumns) {
	      this.fixedColumns = fixedColumns;
	    }
	  }

	  (0, _createClass3.default)(Manager, [{
	    key: 'getChildren',
	    value: function getChildren(value) {
	      return (0, _arrayFilter2.default)(this.data, function (one) {
	        return one.parent === value;
	      });
	    }
	  }, {
	    key: 'getFirstColumn',
	    value: function getFirstColumn() {
	      return (0, _arrayFilter2.default)(this.data, function (one) {
	        return !one.parent || one.parent === 0 || one.parent === '0';
	      });
	    }
	  }, {
	    key: 'getPure',
	    value: function getPure(obj) {
	      return JSON.parse((0, _stringify2.default)(obj));
	    }
	  }, {
	    key: 'getColumns',
	    value: function getColumns(value) {
	      var _this = this;

	      if (value.length > 0) {
	        var matchCount = this.getPure(this.data).filter(function (item) {
	          return _this.getPure(value).indexOf(item.value) > -1;
	        }).length;
	        if (matchCount < this.getPure(value).length) {
	          value = [];
	        }
	      }
	      var datas = [];
	      var max = this.fixedColumns || 8;
	      for (var i = 0; i < max; i++) {
	        if (i === 0) {
	          datas.push(this.getFirstColumn());
	        } else {
	          if (!value[i]) {
	            if (typeof datas[i - 1][0] === 'undefined') {
	              break;
	            } else {
	              var topValue = datas[i - 1][0].value;
	              datas.push(this.getChildren(topValue));
	            }
	          } else {
	            datas.push(this.getChildren(value[i - 1]));
	          }
	        }
	      }
	      var list = datas.filter(function (item) {
	        return item.length > 0;
	      });

	      this.count = list.length;
	      return list;
	    }
	  }]);
	  return Manager;
	}();

	exports.default = Manager;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = require("array-filter");

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-picker"
	  }, [_c('flexbox', {
	    attrs: {
	      "gutter": 0
	    }
	  }, _vm._l((_vm.currentData), function(one, index) {
	    return _c('flexbox-item', {
	      key: index,
	      staticStyle: {
	        "margin-left": "0"
	      }
	    }, [_c('div', {
	      staticClass: "vux-picker-item",
	      attrs: {
	        "id": ("vux-picker-" + _vm.uuid + "-" + index)
	      }
	    })])
	  }))], 1)
	},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _datetime = __webpack_require__(226);

	var _datetime2 = _interopRequireDefault(_datetime);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_datetime2.default.install = function (Vue) {
	  Vue.component('LxDatetime', _datetime2.default);
	};

	exports.default = _datetime2.default;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(227)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(229),
	  /* template */
	  __webpack_require__(234),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(228);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3757fc1c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./datetime.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3757fc1c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./datetime.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.with_arrow:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 0.21333333rem;\n  width: 0.21333333rem;\n  border-width: 1px 1px 0 0;\n  border-color: #a0a0a0;\n  border-style: solid;\n  position: relative;\n  top: -1px;\n  margin-left: .3em;\n}\n.scroller-component {\n  display: block;\n  position: relative;\n  height: 6.34666667rem;\n  overflow: hidden;\n  width: 100%;\n}\n.scroller-content {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: -1;\n}\n.scroller-mask {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  margin: 0 auto;\n  width: 100%;\n  z-index: 3;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), linear-gradient(to top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));\n  background-position: top, bottom;\n  background-size: 100% 2.72rem;\n  background-repeat: no-repeat;\n}\n.scroller-item {\n  text-align: center;\n  font-size: 0.42666667rem;\n  height: 0.90666667rem;\n  line-height: 0.90666667rem;\n  color: #000;\n}\n.scroller-indicator {\n  width: 100%;\n  height: 0.90666667rem;\n  position: absolute;\n  left: 0;\n  top: 2.72rem;\n  z-index: 3;\n  background-image: linear-gradient(to bottom, #d0d0d0, #d0d0d0, transparent, transparent), linear-gradient(to top, #d0d0d0, #d0d0d0, transparent, transparent);\n  background-position: top, bottom;\n  background-size: 100% 1px;\n  background-repeat: no-repeat;\n}\n.dp-container {\n  position: fixed;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  z-index: 10000;\n  background-color: #fff;\n  display: none;\n  transition: transform 0.3s ease;\n  transform: translateY(100%);\n}\n.dp-mask {\n  z-index: 998;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  opacity: 0;\n  transition: opacity 0.1s ease;\n  background-color: #000;\n  z-index: 9999;\n}\n.dp-header {\n  display: flex;\n  width: 100%;\n  box-align: center;\n  align-items: center;\n  background-image: linear-gradient(to bottom, #e7e7e7, #e7e7e7, transparent, transparent);\n  background-position: bottom;\n  background-size: 100% 1px;\n  background-repeat: no-repeat;\n}\n.dp-header .dp-item {\n  font-size: 0.48rem;\n  height: 1.17333333rem;\n  line-height: 1.17333333rem;\n  cursor: pointer;\n}\n.dp-left,\n.dp-center {\n  color: #333;\n}\n.dp-right {\n  color: #5890ff;\n}\n.dp-content {\n  display: flex;\n  width: 100%;\n  box-align: center;\n  align-items: center;\n  padding: 0.26666667rem 0;\n}\n.dp-header .dp-item,\n.dp-content .dp-item {\n  box-sizing: border-box;\n  flex: 1;\n  text-align: center;\n}\n.vux-datetime .vux-input-icon {\n  float: right;\n}\n.vux-cell-primary {\n  flex: 1;\n}\n.cvux-datetime-placeholder {\n  color: #a0a0a0;\n}\n", ""]);

	// exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _keys = __webpack_require__(95);

	var _keys2 = _interopRequireDefault(_keys);

	var _icon = __webpack_require__(96);

	var _icon2 = _interopRequireDefault(_icon);

	var _datetimepicker = __webpack_require__(230);

	var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

	var _group = __webpack_require__(151);

	var _group2 = _interopRequireDefault(_group);

	var _inlineDesc = __webpack_require__(102);

	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);

	var _base = __webpack_require__(85);

	var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  mixins: [_base2.default],
	  components: {
	    Group: _group2.default,
	    InlineDesc: _inlineDesc2.default,
	    Icon: _icon2.default
	  },
	  props: {
	    format: {
	      type: String,
	      default: 'YYYY-MM-DD'
	    },
	    title: {
	      type: String,
	      required: true
	    },
	    value: {
	      type: String,
	      default: ''
	    },
	    inlineDesc: String,
	    placeholder: String,
	    minYear: Number,
	    maxYear: Number,
	    confirmText: {
	      type: String,
	      default: 'ok'
	    },
	    cancelText: {
	      type: String,
	      default: 'cancel'
	    },
	    clearText: {
	      type: String,
	      default: ''
	    },
	    yearRow: {
	      type: String,
	      default: '{value}'
	    },
	    monthRow: {
	      type: String,
	      default: '{value}'
	    },
	    dayRow: {
	      type: String,
	      default: '{value}'
	    },
	    hourRow: {
	      type: String,
	      default: '{value}'
	    },
	    minuteRow: {
	      type: String,
	      default: '{value}'
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    minHour: {
	      type: Number,
	      default: 0
	    },
	    maxHour: {
	      type: Number,
	      default: 23
	    },
	    startDate: String,
	    endDate: String,
	    valueTextAlign: String
	  },
	  mounted: function mounted() {
	    var _this2 = this;

	    var uuid = this.uuid;
	    this.$nextTick(function () {
	      _this2.$el.setAttribute('id', 'vux-datetime-' + uuid);
	      _this2.render();
	    });
	  },

	  computed: {
	    pickerOptions: function pickerOptions() {
	      var _this = this;
	      var options = {
	        trigger: '#vux-datetime-' + this.uuid,
	        format: this.format,
	        value: this.currentValue,
	        output: '.vux-datetime-value',
	        confirmText: this.confirmText,
	        cancelText: _this.cancelText,
	        clearText: _this.clearText,
	        yearRow: this.yearRow,
	        monthRow: this.monthRow,
	        dayRow: this.dayRow,
	        hourRow: this.hourRow,
	        minuteRow: this.minuteRow,
	        minHour: this.minHour,
	        maxHour: this.maxHour,
	        startDate: this.startDate,
	        endDate: this.endDate,
	        onConfirm: function onConfirm(value) {
	          _this.currentValue = value;
	        },
	        onClear: function onClear(value) {
	          _this.$emit('on-clear', value);
	        },
	        onHide: function onHide() {
	          _this.validate();
	        }
	      };
	      if (this.minYear) {
	        options.minYear = this.minYear;
	      }
	      if (this.maxYear) {
	        options.maxYear = this.maxYear;
	      }
	      return options;
	    },
	    firstError: function firstError() {
	      var key = (0, _keys2.default)(this.errors)[0];
	      return this.errors[key];
	    }
	  },
	  methods: {
	    render: function render() {
	      if (this.picker) {
	        this.picker.destroy();
	      }
	      this.picker = new _datetimepicker2.default(this.pickerOptions);
	    },
	    validate: function validate() {
	      if (!this.currentValue && this.required) {
	        this.valid = false;
	        this.errors.required = this.title + '必填';
	      } else {
	        this.valid = true;
	        this.errors = {};
	      }
	      this.$emit('on-vali', this.errors, this.valid, this.uuid);
	    }
	  },
	  created: function created() {
	    this.currentValue = this.value;
	    this.handleChangeEvent = true;
	  },
	  data: function data() {
	    return {
	      currentValue: null,
	      valid: true,
	      errors: {}
	    };
	  },

	  watch: {
	    currentValue: function currentValue(val) {
	      if (this.value !== val) {
	        this.$emit('on-change', val);
	      }
	      this.$emit('input', val);
	      this.validate();
	    },
	    value: function value(val) {
	      if (this.currentValue !== val) {
	        this.currentValue = val;
	        this.picker && this.picker.destroy();
	        this.render();
	      }
	    },
	    startDate: function startDate() {
	      this.render();
	    },
	    endDate: function endDate() {
	      this.render();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.picker && this.picker.destroy();
	  }
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _scroller = __webpack_require__(207);

	var _scroller2 = _interopRequireDefault(_scroller);

	var _util = __webpack_require__(231);

	var _makeData2 = __webpack_require__(233);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MASK_TEMPLATE = '<div class="dp-mask"></div>';

	var TEMPLATE = '<div class="dp-container">\n  <div class="dp-header">\n    <div class="dp-item dp-left" data-role="cancel">cancel</div>\n    <div class="dp-item dp-center" data-role="clear"></div>\n    <div class="dp-item dp-right" data-role="confirm">ok</div>\n  </div>\n  <div class="dp-content">\n    <div class="dp-item" data-role="year"></div>\n    <div class="dp-item" data-role="month"></div>\n    <div class="dp-item" data-role="day"></div>\n    <div class="dp-item" data-role="hour"></div>\n    <div class="dp-item" data-role="minute"></div>\n  </div>\n</div>';

	var SHOW_ANIMATION_TIME = 100;
	var SHOW_CONTAINER_TIME = 300;

	var TYPE_MAP = {
	  year: ['YYYY'],
	  month: ['MM', 'M'],
	  day: ['DD', 'D'],
	  hour: ['HH', 'H'],
	  minute: ['mm', 'm']
	};

	var MASK = null;

	var CURRENT_PICKER;

	var NOW = new Date();

	var DEFAULT_CONFIG = {
	  template: TEMPLATE,
	  trigger: null,
	  output: null,
	  currentYear: NOW.getFullYear(),
	  currentMonth: NOW.getMonth() + 1,
	  minYear: 2000,
	  maxYear: 2030,
	  minHour: 0,
	  maxHour: 23,
	  startDate: null,
	  endDate: null,
	  yearRow: '{value}',
	  monthRow: '{value}',
	  dayRow: '{value}',
	  hourRow: '{value}',
	  minuteRow: '{value}',
	  format: 'YYYY-MM-DD',
	  value: NOW.getFullYear() + '-' + (NOW.getMonth() + 1) + '-' + NOW.getDate(),
	  onSelect: function onSelect() {},
	  onConfirm: function onConfirm() {},
	  onClear: function onClear() {},
	  onShow: function onShow() {},
	  onHide: function onHide() {},

	  confirmText: 'ok',
	  clearText: '',
	  cancelText: 'cancel'
	};

	function renderScroller(el, data, value, fn) {
	  var scroller = new _scroller2.default(el, {
	    data: data,
	    defaultValue: value,
	    onSelect: fn
	  });
	  return scroller;
	}

	function showMask() {
	  if (!MASK) {
	    MASK = (0, _util.toElement)(MASK_TEMPLATE);
	    document.body.appendChild(MASK);

	    MASK.addEventListener('click', function () {
	      CURRENT_PICKER && CURRENT_PICKER.hide();
	    }, false);
	  }

	  MASK.style.display = 'block';

	  setTimeout(function () {
	    MASK && (MASK.style.opacity = 0.5);
	  }, 0);
	}

	function hideMask() {
	  if (!MASK) {
	    return;
	  }

	  MASK.style.opacity = 0;

	  setTimeout(function () {
	    MASK && (MASK.style.display = 'none');
	  }, SHOW_ANIMATION_TIME);
	}

	function DatetimePicker(config) {
	  var self = this;
	  self.config = {};
	  self.value = config.value || '';
	  (0, _util.each)(DEFAULT_CONFIG, function (key, val) {
	    self.config[key] = config[key] || val;
	  });

	  if (typeof this.config.startDate === 'string') {
	    this.config.startDate = new Date(this.config.startDate.replace(/-/g, '/'));
	  }

	  if (typeof this.config.endDate === 'string') {
	    this.config.endDate = new Date(this.config.endDate.replace(/-/g, '/'));
	  }

	  if (this.config.startDate && !this.config.endDate) {
	    this.config.endDate = new Date('2030-12-31');
	  }

	  this.reMakeData = !!this.config.startDate && !!this.config.endDate;

	  var trigger = self.config.trigger;

	  this.triggerHandler = function (e) {
	    e.preventDefault();
	    self.show(self.value);
	  };
	  if (trigger) {
	    trigger = self.trigger = (0, _util.getElement)(trigger);
	    this.trigger = trigger;
	    this.trigger.addEventListener('click', this.triggerHandler, false);
	  }
	}

	DatetimePicker.prototype = {
	  _show: function _show(newValueMap) {
	    var self = this;

	    self.container.style.display = 'block';

	    (0, _util.each)(TYPE_MAP, function (type) {
	      self[type + 'Scroller'] && self[type + 'Scroller'].select((0, _util.trimZero)(newValueMap[type]), false);
	    });

	    setTimeout(function () {
	      self.container.style['-webkit-transform'] = 'translateY(0)';
	      self.container.style.transform = 'translateY(0)';
	    }, 0);
	  },
	  show: function show(value) {
	    var self = this;
	    var config = self.config;
	    CURRENT_PICKER = self;
	    var valueMap = self.valueMap = (0, _util.parseDate)(config.format, value || config.value);
	    var newValueMap = {};

	    (0, _util.each)(TYPE_MAP, function (type, list) {
	      newValueMap[type] = list.length === 1 ? valueMap[list[0]] : valueMap[list[0]] || valueMap[list[1]];
	    });

	    if (self.container) {
	      self._show(newValueMap);
	    } else {
	      var container = self.container = (0, _util.toElement)(config.template);
	      document.body.appendChild(container);

	      self.container.style.display = 'block';

	      container.addEventListener('touchstart', function (e) {}, false);

	      (0, _util.each)(TYPE_MAP, function (type) {
	        var div = self.find('[data-role=' + type + ']');
	        if (newValueMap[type] === undefined) {
	          (0, _util.removeElement)(div);
	          return;
	        }
	        var data;
	        if (type === 'day') {
	          data = self._makeData(type, (0, _util.trimZero)(newValueMap.year), (0, _util.trimZero)(newValueMap.month));
	        } else {
	          data = self._makeData(type);
	        }

	        self[type + 'Scroller'] = renderScroller(div, data, (0, _util.trimZero)(newValueMap[type]), function (currentValue) {
	          config.onSelect.call(self, type, currentValue);
	          var currentDay;
	          if (!self.dayScroller) {
	            return;
	          }
	          if (type === 'year') {
	            var currentMonth = self.monthScroller ? self.monthScroller.value : config.currentMonth;
	            currentDay = self.dayScroller.value;
	            self._setMonthScroller(currentValue, currentMonth);
	            self._setDayScroller(currentValue, currentMonth, currentDay);
	          } else if (type === 'month') {
	            var currentYear = self.yearScroller ? self.yearScroller.value : config.currentYear;
	            currentDay = self.dayScroller.value;
	            self._setDayScroller(currentYear, currentValue, currentDay);
	          }
	        });
	      });

	      if (!self.renderText) {
	        if (self.config.confirmText) {
	          self.find('[data-role=confirm]').innerText = self.config.confirmText;
	        }

	        if (self.config.cancelText) {
	          self.find('[data-role=cancel]').innerText = self.config.cancelText;
	        }
	        if (self.config.clearText) {
	          self.find('[data-role=clear]').innerText = self.config.clearText;
	        }
	        self.renderText = true;
	      }

	      this._show(newValueMap);

	      self.find('[data-role=cancel]').addEventListener('click', function (e) {
	        e.preventDefault();
	        self.hide();
	      }, false);

	      self.find('[data-role=confirm]').addEventListener('click', function (e) {
	        e.preventDefault();
	        self.confirm();
	      }, false);

	      if (self.config.clearText) {
	        self.find('[data-role=clear]').addEventListener('click', function (e) {
	          e.preventDefault();
	          self.clear();
	        }, false);
	      }
	    }

	    showMask();
	    config.onShow.call(self);
	  },
	  _makeData: function _makeData(type, year, month) {
	    var config = this.config;
	    var valueMap = this.valueMap;
	    var list = TYPE_MAP[type];
	    var data = [];
	    var min;
	    var max;

	    if (type === 'year') {
	      min = config.minYear;
	      max = config.maxYear;
	      if (this.reMakeData) {
	        var _getYears = (0, _makeData2.getYears)(this.config.startDate, this.config.endDate),
	            minYear = _getYears.minYear,
	            maxYear = _getYears.maxYear;

	        min = Math.max(min, minYear);
	        max = Math.min(max, maxYear);
	      }
	    } else if (type === 'month') {
	      min = 1;
	      max = 12;
	      if (this.reMakeData) {
	        var _getMonths = (0, _makeData2.getMonths)(this.config.startDate, this.config.endDate, this.yearScroller.value * 1),
	            minMonth = _getMonths.minMonth,
	            maxMonth = _getMonths.maxMonth;

	        min = Math.max(min, minMonth);
	        max = Math.min(max, maxMonth);
	      }
	    } else if (type === 'day') {
	      min = 1;
	      max = (0, _util.getMaxDay)(year, month);
	      if (this.reMakeData) {
	        var _getDays = (0, _makeData2.getDays)(this.config.startDate, this.config.endDate, this.yearScroller.value * 1, this.monthScroller.value * 1),
	            minDay = _getDays.minDay,
	            maxDay = _getDays.maxDay;

	        min = Math.max(min, minDay);
	        max = Math.min(max, maxDay);
	      }
	    } else if (type === 'hour') {
	      min = this.config.minHour;
	      max = this.config.maxHour;
	    } else if (type === 'minute') {
	      min = 0;
	      max = 59;
	    }
	    for (var i = min; i <= max; i++) {
	      var name;
	      if (type === 'year') {
	        name = (0, _util.parseRow)(config.yearRow, i);
	      } else {
	        var val = valueMap[list[0]] ? (0, _util.addZero)(i) : i;
	        name = (0, _util.parseRow)(config[type + 'Row'], val);
	      }
	      data.push({
	        name: name,
	        value: i
	      });
	    }
	    return data;
	  },
	  _setMonthScroller: function _setMonthScroller(currentValue, month) {
	    var self = this;
	    this.monthScroller.destroy();
	    if (!self.container) return;
	    var div = self.find('[data-role=month]');
	    self.monthScroller = renderScroller(div, self._makeData('month'), month, function (currentValue) {
	      self.config.onSelect.call(self, 'month', currentValue);
	      var currentYear = self.yearScroller ? self.yearScroller.value : self.config.currentYear;
	      var currentDay = self.dayScroller.value;
	      self._setDayScroller(currentYear, currentValue, currentDay);
	    });
	  },
	  _setDayScroller: function _setDayScroller(year, month, day) {
	    var self = this;
	    var maxDay = (0, _util.getMaxDay)(year, month);
	    if (day > maxDay) {
	      day = maxDay;
	    }
	    self.dayScroller.destroy();
	    if (!self.container) return;
	    var div = self.find('[data-role=day]');
	    self.dayScroller = renderScroller(div, self._makeData('day', year, month), day, function (currentValue) {
	      self.config.onSelect.call(self, 'day', currentValue);
	    });
	  },
	  find: function find(selector) {
	    return this.container.querySelector(selector);
	  },
	  hide: function hide() {
	    var self = this;
	    self.container.style.removeProperty('transform');
	    self.container.style.removeProperty('-webkit-transform');

	    setTimeout(function () {
	      self.container && (self.container.style.display = 'none');
	    }, SHOW_CONTAINER_TIME);

	    hideMask();

	    self.config.onHide.call(self);
	  },
	  select: function select(type, value) {
	    this[type + 'Scroller'].select(value, false);
	  },
	  destroy: function destroy() {
	    var self = this;
	    this.trigger.removeEventListener('click', this.triggerHandler, false);
	    (0, _util.removeElement)(MASK);
	    (0, _util.removeElement)(self.container);
	    MASK = null;
	    self.container = null;
	  },
	  getValue: function getValue() {
	    var self = this;
	    var config = self.config;

	    var value = config.format;

	    function formatValue(scroller, expr1, expr2) {
	      if (scroller) {
	        var val = scroller.value;
	        if (expr1) {
	          value = value.replace(new RegExp(expr1, 'g'), (0, _util.addZero)(val));
	        }
	        if (expr2) {
	          value = value.replace(new RegExp(expr2, 'g'), (0, _util.trimZero)(val));
	        }
	      }
	    }

	    (0, _util.each)(TYPE_MAP, function (key, list) {
	      formatValue(self[key + 'Scroller'], list[0], list[1]);
	    });

	    return value;
	  },
	  confirm: function confirm() {
	    var self = this;
	    var value = self.getValue();
	    this.value = value;

	    if (self.config.onConfirm.call(self, value) === false) {
	      return;
	    }

	    self.hide();
	  },
	  clear: function clear() {
	    var self = this;
	    var value = self.getValue();

	    if (self.config.onClear.call(self, value) === false) {
	      return;
	    }

	    self.hide();
	  }
	};

	exports.default = DatetimePicker;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.each = each;
	exports.trimZero = trimZero;
	exports.addZero = addZero;
	exports.isLeapYear = isLeapYear;
	exports.getMaxDay = getMaxDay;
	exports.parseRow = parseRow;
	exports.parseDate = parseDate;
	exports.getElement = getElement;
	exports.toElement = toElement;
	exports.removeElement = removeElement;

	var _format = __webpack_require__(232);

	var _format2 = _interopRequireDefault(_format);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function each(obj, fn) {
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      if (fn.call(obj[key], key, obj[key]) === false) {
	        break;
	      }
	    }
	  }
	}

	function trimZero(val) {
	  val = String(val);
	  val = val ? parseFloat(val.replace(/^0+/g, '')) : '';
	  val = val || 0;
	  val = val + '';
	  return val;
	}

	function addZero(val) {
	  val = String(val);
	  return val.length < 2 ? '0' + val : val;
	}

	function isLeapYear(year) {
	  return year % 100 !== 0 && year % 4 === 0 || year % 400 === 0;
	}

	function getMaxDay(year, month) {
	  year = parseFloat(year);
	  month = parseFloat(month);
	  if (month === 2) {
	    return isLeapYear(year) ? 29 : 28;
	  }
	  return [4, 6, 9, 11].indexOf(month) >= 0 ? 30 : 31;
	}

	function parseRow(tmpl, value) {
	  return tmpl.replace(/\{value\}/g, value);
	}

	function parseDate(format, value) {
	  var formatParts = format.split(/[^A-Za-z]+/);
	  var valueParts = value.split(/\D+/);
	  if (formatParts.length !== valueParts.length) {
	    var date = (0, _format2.default)(new Date(), format);
	    valueParts = date.split(/\D+/);
	  }

	  var result = {};

	  for (var i = 0; i < formatParts.length; i++) {
	    if (formatParts[i]) {
	      result[formatParts[i]] = valueParts[i];
	    }
	  }
	  return result;
	}

	function getElement(expr) {
	  return typeof expr === 'string' ? document.querySelector(expr) : expr;
	}

	function toElement(html) {
	  var tempContainer = document.createElement('div');
	  tempContainer.innerHTML = html;
	  return tempContainer.firstElementChild;
	}

	function removeElement(el) {
	  el && el.parentNode.removeChild(el);
	}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (date) {
	  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

	  var o = {
	    'M+': date.getMonth() + 1,
	    'D+': date.getDate(),
	    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
	    'H+': date.getHours(),
	    'm+': date.getMinutes(),
	    's+': date.getSeconds(),
	    'q+': Math.floor((date.getMonth() + 3) / 3),
	    'S': date.getMilliseconds()
	  };
	  var week = {
	    '0': '/u65e5',
	    '1': '/u4e00',
	    '2': '/u4e8c',
	    '3': '/u4e09',
	    '4': '/u56db',
	    '5': '/u4e94',
	    '6': '/u516d'
	  };
	  if (/(Y+)/.test(fmt)) {
	    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	  }
	  if (/(E+)/.test(fmt)) {
	    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468' : '') + week[date.getDay() + '']);
	  }
	  for (var k in o) {
	    if (new RegExp('(' + k + ')').test(fmt)) {
	      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	    }
	  }
	  return fmt;
	};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function isLeapYear(year) {
	  return year % 100 !== 0 && year % 4 === 0 || year % 400 === 0;
	}

	function getMaxDay(year, month) {
	  year = parseFloat(year);
	  month = parseFloat(month);
	  if (month === 2) {
	    return isLeapYear(year) ? 29 : 28;
	  }
	  return [4, 6, 9, 11].indexOf(month) >= 0 ? 30 : 31;
	}

	function getYears(startDate, endDate) {
	  var startYear = startDate.getFullYear();
	  var endYear = endDate.getFullYear();
	  var rs = [];
	  while (startYear <= endYear) {
	    rs.push(startYear);
	    startYear++;
	  }
	  return {
	    minYear: rs[0],
	    maxYear: rs[rs.length - 1]
	  };
	}

	function getMonths(startDate, endDate, year) {
	  var startYear = startDate.getFullYear();
	  var endYear = endDate.getFullYear();
	  var startMonth = startDate.getMonth() + 1;
	  var endMonth = endDate.getMonth() + 1;
	  var start = 1;
	  var end = 12;
	  if (year === startYear) {
	    start = startMonth;
	  }
	  if (year === endYear) {
	    end = endMonth;
	  }
	  return {
	    minMonth: start,
	    maxMonth: end
	  };
	}

	function getDays(startDate, endDate, year, month) {
	  var startYear = startDate.getFullYear();
	  var endYear = endDate.getFullYear();
	  var startMonth = startDate.getMonth() + 1;
	  var endMonth = endDate.getMonth() + 1;
	  var startDay = startDate.getDate();
	  var endDay = endDate.getDate();

	  var start = 1;
	  var end = getMaxDay(year, month);

	  if (year === startYear && month === startMonth) {
	    start = startDay;
	  }
	  if (year === endYear && month === endMonth) {
	    end = endDay;
	  }
	  return {
	    minDay: start,
	    maxDay: end
	  };
	}

	exports.getYears = getYears;
	exports.getMonths = getMonths;
	exports.getDays = getDays;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "weui_cell",
	    attrs: {
	      "href": "javascript:"
	    }
	  }, [_c('div', {
	    staticClass: "weui_cell_bd weui_cell_content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 1), _c('div', {
	    staticClass: "weui_cell_ft vux-cell-primary vux-datetime-value",
	    style: ({
	      textAlign: _vm.valueTextAlign
	    })
	  }, [_vm._v("\n    " + _vm._s(_vm.currentValue) + "\n    "), (!_vm.currentValue.length && _vm.placeholder) ? _c('span', {
	    staticClass: "cvux-datetime-placeholder",
	    domProps: {
	      "innerHTML": _vm._s(_vm.placeholder)
	    }
	  }) : _vm._e()]), _c('div', {
	    staticClass: "with_arrow"
	  }, [_c('icon', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.valid),
	      expression: "!valid"
	    }],
	    staticClass: "vux-input-icon",
	    attrs: {
	      "type": "warn",
	      "title": _vm.firstError
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _popup = __webpack_require__(236);

	var _popup2 = _interopRequireDefault(_popup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_popup2.default.install = function (Vue) {
	  Vue.component('LxPopup', _popup2.default);
	};

	exports.default = _popup2.default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(237)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(239),
	  /* template */
	  __webpack_require__(241),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(238);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6ff744d6!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./popup.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6ff744d6!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./popup.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-popup {\r\n  border-top: 2px solid #04BE02;\n}\n.vux-popup-dialog {\r\n  position: fixed;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  background: #eee;\r\n  z-index: 999999;\r\n  transition-property: transform;\r\n  transition-duration: 300ms;\n}\n.vux-popup-mask {\r\n  display: block;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  opacity: 0;\r\n  tap-highlight-color: rgba(0,0,0,0);\r\n  z-index: -1;\n}\n.vux-popup-mask.vux-popup-show {\r\n  opacity: 1;\r\n  z-index: 100;\r\n  transition: opacity 0.3s;\n}\n.vux-popup-transiton {\n}\n.vux-popup-enter {\r\n  transform: translate3d(0, 100%, 0);\n}\n.vux-popup-leave {\r\n  transform: translate3d(0, 100%, 0);\n}\r\n", ""]);

	// exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _keys = __webpack_require__(95);

	var _keys2 = _interopRequireDefault(_keys);

	var _popup = __webpack_require__(240);

	var _popup2 = _interopRequireDefault(_popup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    value: Boolean,
	    height: {
	      type: String,
	      default: 'auto'
	    },
	    hideOnBlur: {
	      type: Boolean,
	      default: true
	    }
	  },
	  mounted: function mounted() {
	    this.show = this.value;
	    var _this = this;
	    this.popup = new _popup2.default({
	      container: _this.$el,
	      innerHTML: '',
	      hideOnBlur: _this.hideOnBlur,
	      onOpen: function onOpen(dialog) {
	        _this.fixSafariOverflowScrolling('auto');
	        _this.show = true;
	      },
	      onClose: function onClose(dialog) {
	        _this.show = false;
	        if ((0, _keys2.default)(window.__$vuxPopups).length >= 1) return;
	        _this.fixSafariOverflowScrolling('touch');
	      }
	    });
	    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
	  },

	  methods: {
	    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
	      if (!this.$overflowScrollingList.length) return;
	      if (!/iphone/i.test(navigator.userAgent)) return;
	      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
	        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hasFirstShow: false,
	      show: false
	    };
	  },

	  watch: {
	    value: function value() {
	      this.show = this.value;
	    },
	    show: function show(val) {
	      if (val) {
	        this.popup.show();
	        this.$emit('on-show');
	        if (!this.hasFirstShow) {
	          this.$emit('on-first-show');
	          this.hasFirstShow = true;
	        }
	      } else {
	        this.$emit('on-hide');
	        this.show = false;
	        this.popup.hide(false);
	      }
	      this.$emit('input', val);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.popup.destroy();
	    this.fixSafariOverflowScrolling('touch');
	  }
	};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var isServer = typeof window === 'undefined';
	if (!isServer) {
	  window.__$vuxPopups = window.__$vuxPopups || {};
	}
	var popupDialog = function popupDialog(option) {
	  this.uuid = Math.random().toString(36).substring(3, 8);
	  this.params = {};
	  this.isShow = false;
	  if (Object.prototype.toString.call(option) === '[object Object]') {
	    this.params = {
	      input: option.input || '',
	      container: document.querySelector(option.input) || '',
	      innerHTML: option.innerHTML || '',
	      hideOnBlur: option.hideOnBlur,
	      onOpen: option.onOpen || function () {},
	      onClose: option.onClose || function () {}
	    };
	  }
	  if (!!document.querySelectorAll('.vux-popup-mask').length <= 0) {
	    this.divMask = document.createElement('a');
	    this.divMask.className = 'vux-popup-mask';
	    this.divMask.dataset.uuid = '';
	    this.divMask.href = 'javascript:void(0)';
	    document.body.appendChild(this.divMask);
	  }
	  var div = void 0;
	  if (!option.container) {
	    div = document.createElement('div');
	  } else {
	    div = option.container;
	  }
	  div.className = 'vux-popup-dialog vux-popup-dialog-' + this.uuid;

	  if (!option.container) {
	    document.body.appendChild(div);
	  }
	  this.container = document.querySelector('.vux-popup-dialog-' + this.uuid);
	  this.mask = document.querySelector('.vux-popup-mask');
	  this.mask.dataset.uuid += ',' + this.uuid;
	  this._bindEvents();
	  option = null;
	  return this;
	};

	popupDialog.prototype.onClickMask = function () {
	  if (this.params.hideOnBlur && this.isShow) {
	    this.hide(false);
	  }
	};

	popupDialog.prototype._bindEvents = function () {
	  this.params.hideOnBlur && this.mask.addEventListener('click', this.onClickMask.bind(this), false);
	};

	popupDialog.prototype.show = function () {
	  this.mask.classList.add('vux-popup-show');
	  this.container.classList.add('vux-popup-show');
	  this.params.onOpen && this.params.onOpen(this);
	  this.isShow = true;
	  window.__$vuxPopups[this.uuid] = 1;
	};

	popupDialog.prototype.hide = function () {
	  var shouldCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	  this.container.classList.remove('vux-popup-show');
	  if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
	    this.mask.classList.remove('vux-popup-show');
	  }
	  shouldCallback === false && this.params.onClose && this.params.hideOnBlur && this.params.onClose(this);
	  this.isShow = false;
	  delete window.__$vuxPopups[this.uuid];
	};

	popupDialog.prototype.html = function (html) {
	  this.container.innerHTML = html;
	};

	popupDialog.prototype.destroy = function () {
	  this.mask.dataset.uuid = this.mask.dataset.uuid.replace(new RegExp(',' + this.uuid, 'g'), '');
	  if (!this.mask.dataset.uuid) {
	    this.mask.removeEventListener('click', this.onClickMask.bind(this), false);
	    this.mask && this.mask.parentNode && this.mask.parentNode.removeChild(this.mask);
	  } else {
	    this.hide();
	  }
	  delete window.__$vuxPopups[this.uuid];
	};

	exports.default = popupDialog;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "vux-popup",
	    style: ({
	      height: _vm.height
	    }),
	    attrs: {
	      "transition": "vux-popup"
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _actionsheet = __webpack_require__(243);

	var _actionsheet2 = _interopRequireDefault(_actionsheet);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_actionsheet2.default.install = function (Vue) {
	  Vue.component('LxActionSheet', _actionsheet2.default);
	};

	exports.default = _actionsheet2.default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(244)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(246),
	  /* template */
	  __webpack_require__(247),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(245);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-be3f38e0!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./actionsheet.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-be3f38e0!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./actionsheet.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui_mask {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_mask_transparent {\n  position: fixed;\n  z-index: 5001;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.weui_mask_transition {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: background .3s;\n}\n.weui_fade_toggle {\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-actionsheet {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  transform: translate(0, 100%);\n  backface-visibility: hidden;\n  z-index: 5000;\n  width: 100%;\n  background-color: #EFEFF4;\n  transition: transform .3s;\n}\n.weui-actionsheet__menu {\n  background-color: #FFFFFF;\n}\n.weui-actionsheet__action {\n  margin-top: 6px;\n  background-color: #FFFFFF;\n}\n.weui-actionsheet__cell {\n  position: relative;\n  padding: 10px 0;\n  text-align: center;\n  font-size: 18px;\n}\n.weui-actionsheet__cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui-actionsheet__cell:active {\n  background-color: #ECECEC;\n}\n.weui-actionsheet__cell:first-child:before {\n  display: none;\n}\n.weui-skin_android .weui-actionsheet {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  bottom: auto;\n  transform: translate(-50%, -50%);\n  width: 274px;\n  box-sizing: border-box;\n  backface-visibility: hidden;\n  background: transparent;\n  transition: transform .3s;\n}\n.weui-skin_android .weui-actionsheet__action {\n  display: none;\n}\n.weui-skin_android .weui-actionsheet__menu {\n  border-radius: 2px;\n  box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.1);\n}\n.weui-skin_android .weui-actionsheet__cell {\n  padding: 13px 24px;\n  font-size: 16px;\n  line-height: 1.4;\n  text-align: left;\n}\n.weui-skin_android .weui-actionsheet__cell:first-child {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n.weui-skin_android .weui-actionsheet__cell:last-child {\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.weui-actionsheet_toggle {\n  transform: translate(0, 0);\n}\n.vux-actionsheet-menu-primary {\n  color: #1AAD19;\n}\n.vux-actionsheet-menu-warn {\n  color: #E64340;\n}\n.vux-actionsheet-menu-default {\n  color: #000;\n}\n.vux-actionsheet-menu-disabled {\n  color: #ccc;\n}\n.vux-actionsheet-mask-enter,\n.vux-actionsheet-mask-leave-active,\n.vux-android-actionsheet-enter,\n.vux-android-actionsheet-leave-active {\n  opacity: 0;\n}\n.vux-actionsheet-mask-leave-active,\n.vux-actionsheet-mask-enter-active,\n.vux-android-actionsheet-leave-active,\n.vux-android-actionsheet-enter-active {\n  transition: opacity 300ms!important;\n}\n", ""]);

	// exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _typeof2 = __webpack_require__(88);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: 'actionsheet',
	  mounted: function mounted() {
	    var _this = this;

	    this.hasHeaderSlot = !!this.$slots.header;
	    this.$nextTick(function () {
	      _this.$tabbar = document.querySelector('.weui-tabbar');
	    });
	  },

	  props: {
	    value: Boolean,
	    showCancel: Boolean,
	    cancelText: String,
	    theme: {
	      type: String,
	      default: 'ios'
	    },
	    menus: {
	      type: [Object, Array],
	      default: function _default() {
	        return {};
	      }
	    },
	    closeOnClickingMask: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickingMenu: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      hasHeaderSlot: false,
	      show: false
	    };
	  },

	  methods: {
	    onMenuClick: function onMenuClick(text, key) {
	      if (typeof text === 'string') {
	        this.emitEvent('on-click-menu', key, text);
	      } else {
	        if (text.type !== 'disabled' && text.type !== 'info') {
	          if (text.value || text.value === 0) {
	            this.emitEvent('on-click-menu', text.value, text);
	          } else {
	            this.emitEvent('on-click-menu', '', text);
	            this.show = false;
	          }
	        }
	      }
	    },
	    onClickingMask: function onClickingMask() {
	      this.$emit('on-click-mask');
	      this.closeOnClickingMask && (this.show = false);
	    },
	    emitEvent: function emitEvent(event, menu, item) {
	      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
	        var _item = item;
	        if ((typeof _item === 'undefined' ? 'undefined' : (0, _typeof3.default)(_item)) === 'object') {
	          _item = JSON.parse((0, _stringify2.default)(_item));
	        }
	        this.$emit(event, menu, _item);
	        this.$emit(event + '-' + menu);
	        this.closeOnClickingMenu && (this.show = false);
	      }
	    },
	    fixIos: function fixIos(zIndex) {
	      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
	        return;
	      }
	      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
	        this.$tabbar.style.zIndex = zIndex;
	      }
	    }
	  },
	  watch: {
	    show: function show(val) {
	      var _this2 = this;

	      this.$emit('input', val);
	      if (val) {
	        this.fixIos(-1);
	      } else {
	        setTimeout(function () {
	          _this2.fixIos(100);
	        }, 200);
	      }
	    },

	    value: {
	      handler: function handler(val) {
	        this.show = val;
	      },
	      immediate: true
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.fixIos(100);
	  }
	};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-actionsheet"
	  }, [_c('transition', {
	    attrs: {
	      "name": "vux-actionsheet-mask"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui-mask weui-mask_transparent",
	    on: {
	      "click": _vm.onClickingMask
	    }
	  })]), (_vm.theme === 'android') ? _c('div', {
	    staticClass: "weui-skin_android"
	  }, [_c('transition', {
	    attrs: {
	      "name": "vux-android-actionsheet"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui-actionsheet"
	  }, [_c('div', {
	    staticClass: "weui-actionsheet__menu"
	  }, _vm._l((_vm.menus), function(text, key) {
	    return _c('div', {
	      staticClass: "weui-actionsheet__cell",
	      domProps: {
	        "innerHTML": _vm._s(text.label || text)
	      },
	      on: {
	        "click": function($event) {
	          _vm.onMenuClick(text, key)
	        }
	      }
	    })
	  }))])])], 1) : _c('div', {
	    staticClass: "weui-actionsheet",
	    class: {
	      'weui-actionsheet_toggle': _vm.show
	    }
	  }, [_c('div', {
	    staticClass: "weui-actionsheet__menu"
	  }, [(_vm.hasHeaderSlot) ? _c('div', {
	    staticClass: "weui-actionsheet__cell"
	  }, [_vm._t("header")], 2) : _vm._e(), _vm._l((_vm.menus), function(text, key) {
	    return _c('div', {
	      staticClass: "weui-actionsheet__cell",
	      class: ("vux-actionsheet-menu-" + (text.type || 'default')),
	      domProps: {
	        "innerHTML": _vm._s(text.label || text)
	      },
	      on: {
	        "click": function($event) {
	          _vm.onMenuClick(text, key)
	        }
	      }
	    })
	  })], 2), (_vm.showCancel) ? _c('div', {
	    staticClass: "weui-actionsheet__action",
	    on: {
	      "click": function($event) {
	        _vm.emitEvent('on-click-menu', 'cancel')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "weui-actionsheet__cell"
	  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _clocker = __webpack_require__(249);

	var _clocker2 = _interopRequireDefault(_clocker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_clocker2.default.install = function (Vue) {
	  Vue.component('LxClocker', _clocker2.default);
	};

	exports.default = _clocker2.default;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(250),
	  /* template */
	  __webpack_require__(253),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});


	var Clocker = __webpack_require__(251);
	exports.default = {
	  mounted: function mounted() {
	    this.slot = this.$el.querySelector('.vux-clocker-tpl');
	    this.slotString = this.slot.innerHTML;
	    if (this.slotString !== '') {
	      this.showTimeString = false;
	    }
	    this.render();
	  },

	  methods: {
	    render: function render() {
	      var _this = this;

	      if (!this.time) return;
	      this.clocker = new Clocker(this.time, {
	        sTime: this.sTime
	      }).on('tick', function (event) {
	        _this.update(event);
	        _this.$emit('on-tick', event);
	      }).on('finish', function () {
	        _this.timeString = '00:00:00';
	        _this.$emit('on-finish');
	      }).start();
	    },
	    update: function update(event) {
	      if (this.showTimeString) {
	        this.timeString = event.strftime(this.format);
	      } else {
	        var string = event.strftime(this.slotString);
	        if (string !== this.cacheSlotString) {
	          this.slot.innerHTML = this.cacheSlotString = string;
	        }
	      }
	    }
	  },
	  props: {
	    sTime: [String, Number],
	    time: [String, Number],
	    format: {
	      type: String,
	      default: '%D 天 %H 小时 %M 分 %S 秒'
	    }
	  },
	  watch: {
	    time: function time() {
	      if (this.clocker) {
	        this.clocker.remove();
	      }
	      this.render();
	    }
	  },
	  data: function data() {
	    return {
	      showTimeString: true,
	      timeString: '',
	      slotString: '',
	      cacheSlotString: ''
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.clocker) {
	      this.clocker.remove();
	    }
	    this.clocker = null;
	  }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var instances = [];
	var matchers = [];

	matchers.push(/^[0-9]*$/.source);

	matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);

	matchers.push(/[0-9]{4}([/-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);

	matchers = new RegExp(matchers.join('|'));


	function parseDateString(dateString) {
	  if (dateString instanceof Date) {
	    return dateString;
	  }

	  if (String(dateString).match(matchers)) {
	    if (String(dateString).match(/^[0-9]*$/)) {
	      dateString = Number(dateString);
	    }

	    if (String(dateString).match(/-/)) {
	      dateString = String(dateString).replace(/-/g, '/');
	    }
	    return new Date(dateString);
	  } else {
	    throw new Error('Couldn\'t cast `' + dateString + '` to a date object.');
	  }
	}

	var DIRECTIVE_KEY_MAP = {
	  'Y': 'years',
	  'm': 'months',
	  'w': 'weeks',
	  'D': 'days',
	  'H': 'hours',
	  'M': 'minutes',
	  'S': 'seconds'
	};


	function escapedRegExp(str) {
	  var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  return new RegExp(sanitize);
	}


	function strftime(offsetObject) {
	  return function (format) {
	    var directives = format.match(/%(-|!)?[A-Z]{1}(:[^]+)?/gi);
	    if (directives) {
	      for (var i = 0, len = directives.length; i < len; ++i) {
	        var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^]+)?/);
	        var regexp = escapedRegExp(directive[0]);
	        var modifier = directive[1] || '';
	        var plural = directive[3] || '';
	        var value = null;

	        directive = directive[2];

	        if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
	          value = DIRECTIVE_KEY_MAP[directive];
	          value = Number(offsetObject[value]);
	        }
	        if (value !== null) {
	          if (modifier === '!') {
	            value = pluralize(plural, value);
	          }

	          if (modifier === '') {
	            if (value < 10) {
	              value = '0' + value.toString();
	            }
	          }

	          format = format.replace(regexp, value.toString());
	        }
	      }
	    }
	    format = format.replace('%_M1', offsetObject.minutes_1).replace('%_M2', offsetObject.minutes_2).replace('%_S1', offsetObject.seconds_1).replace('%_S2', offsetObject.seconds_2).replace('%_H1', offsetObject.hours_1).replace('%_H2', offsetObject.hours_2).replace('%_D1', offsetObject.days_1).replace('%_D2', offsetObject.days_2);
	    format = format.replace(/%%/, '%');
	    return format;
	  };
	}


	function pluralize(format, count) {
	  var plural = 's';
	  var singular = '';
	  if (format) {
	    format = format.replace(/(:||\s)/gi, '').split(/,/);
	    if (format.length === 1) {
	      plural = format[0];
	    } else {
	      singular = format[0];
	      plural = format[1];
	    }
	  }
	  if (Math.abs(count) === 1) {
	    return singular;
	  } else {
	    return plural;
	  }
	}

	function splitNumber(number) {
	  number = number + '';
	  number = (number.length === 1 ? '0' + number : number) + '';
	  return number.split('');
	}

	var Countdown = function Countdown(finalDate, option) {
	  option = option || {};
	  this.PRECISION = option.precision || 100;
	  this.interval = null;
	  this.offset = {};

	  this.instanceNumber = instances.length;
	  instances.push(this);

	  this.setFinalDate(finalDate, option.sTime);
	};
	var Eventor = __webpack_require__(252);
	Eventor.mixTo(Countdown);
	var pro = Countdown.prototype;

	var fns = {
	  start: function start() {
	    if (this.interval !== null) {
	      clearInterval(this.interval);
	    }
	    var self = this;
	    this.update();
	    this.interval = setInterval(function () {
	      self.update();
	    }, this.PRECISION);
	    return this;
	  },
	  stop: function stop() {
	    clearInterval(this.interval);
	    this.interval = null;
	    this._dispatchEvent('stoped');
	    return this;
	  },
	  toggle: function toggle() {
	    if (this.interval) {
	      this.stop();
	    } else {
	      this.start();
	    }
	    return this;
	  },
	  pause: function pause() {
	    return this.stop();
	  },
	  resume: function resume() {
	    return this.start();
	  },
	  remove: function remove() {
	    this.stop();
	    instances[this.instanceNumber] = null;
	  },
	  setFinalDate: function setFinalDate(fValue, sValue) {
	    if (sValue) {
	      this.finalDate = parseDateString(parseDateString(fValue).getTime() - parseDateString(sValue).getTime() + new Date().getTime());
	    } else {
	      this.finalDate = parseDateString(fValue);
	    }
	    return this;
	  },
	  getOffset: function getOffset() {
	    this.totalSecsLeft = this.finalDate.getTime() - new Date().getTime();
	    this.totalSecsLeft = Math.ceil(this.totalSecsLeft / 1000);
	    this.totalSecsLeft = this.totalSecsLeft < 0 ? 0 : this.totalSecsLeft;

	    return {
	      seconds: this.totalSecsLeft % 60,
	      minutes: Math.floor(this.totalSecsLeft / 60) % 60,
	      hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
	      days: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
	      weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
	      months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30),
	      years: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 365)
	    };
	  },
	  update: function update() {
	    this.offset = this.getOffset();


	    var list = ['days', 'hours', 'minutes', 'seconds'];

	    for (var i = 0; i < list.length; i++) {
	      var key = list[i];
	      var numbers = splitNumber(this.offset[key]);
	      this.offset[key + '_1'] = numbers[0];
	      this.offset[key + '_2'] = numbers[1];
	    }

	    if (this.totalSecsLeft === 0) {
	      this.stop();
	      this._dispatchEvent('finish');
	    } else {
	      this._dispatchEvent('update');
	    }
	    return this;
	  },
	  _dispatchEvent: function _dispatchEvent(eventName) {
	    var event = {};
	    event.finalDate = this.finalDate;
	    event.offset = this.offset;
	    event.strftime = strftime(this.offset);
	    this.emit(eventName, event);
	    this.emit('tick', event);
	  }
	};

	for (var i in fns) {
	  pro[i] = fns[i];
	}

	module.exports = Countdown;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _keys = __webpack_require__(95);

	var _keys2 = _interopRequireDefault(_keys);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var eventSplitter = /\s+/;

	function Events() {}

	Events.prototype.on = function (events, callback, context) {
	  var cache, event, list;
	  if (!callback) return this;
	  cache = this.__events || (this.__events = {});
	  events = events.split(eventSplitter);
	  while (event = events.shift()) {
	    list = cache[event] || (cache[event] = []);
	    list.push(callback, context);
	  }
	  return this;
	};
	Events.prototype.once = function (events, callback, context) {
	  var that = this;
	  var cb = function cb() {
	    that.off(events, cb);
	    callback.apply(context || that, arguments);
	  };
	  return this.on(events, cb, context);
	};

	Events.prototype.off = function (events, callback, context) {
	  var cache, event, list, i;

	  if (!(cache = this.__events)) return this;
	  if (!(events || callback || context)) {
	    delete this.__events;
	    return this;
	  }
	  events = events ? events.split(eventSplitter) : keys(cache);

	  while (event = events.shift()) {
	    list = cache[event];
	    if (!list) continue;
	    if (!(callback || context)) {
	      delete cache[event];
	      continue;
	    }
	    for (i = list.length - 2; i >= 0; i -= 2) {
	      if (!(callback && list[i] !== callback || context && list[i + 1] !== context)) {
	        list.splice(i, 2);
	      }
	    }
	  }
	  return this;
	};

	Events.prototype.trigger = function (events) {
	  var cache, event, all, list, i, len;
	  var rest = [];
	  var returned = true;
	  if (!(cache = this.__events)) return this;
	  events = events.split(eventSplitter);

	  for (i = 1, len = arguments.length; i < len; i++) {
	    rest[i - 1] = arguments[i];
	  }

	  while (event = events.shift()) {
	    if (all = cache.all) all = all.slice();
	    if (list = cache[event]) list = list.slice();
	    if (event !== 'all') {
	      returned = triggerEvents(list, rest, this) && returned;
	    }

	    returned = triggerEvents(all, [event].concat(rest), this) && returned;
	  }
	  return returned;
	};
	Events.prototype.emit = Events.prototype.trigger;

	var keys = _keys2.default;
	if (!keys) {
	  keys = function keys(o) {
	    var result = [];
	    for (var name in o) {
	      if (o.hasOwnProperty(name)) {
	        result.push(name);
	      }
	    }
	    return result;
	  };
	}

	Events.mixTo = function (receiver) {
	  var proto = Events.prototype;
	  if (isFunction(receiver)) {
	    for (var key in proto) {
	      if (proto.hasOwnProperty(key)) {
	        receiver.prototype[key] = proto[key];
	      }
	    }
	  } else {
	    var event = new Events();
	    for (var _key in proto) {
	      if (proto.hasOwnProperty(_key)) {
	        copyProto(_key);
	      }
	    }
	  }

	  function copyProto(key) {
	    receiver[key] = function () {
	      proto[key].apply(event, Array.prototype.slice.call(arguments));
	      return this;
	    };
	  }
	};

	function triggerEvents(list, args, context) {
	  var pass = true;
	  if (list) {
	    var i = 0;
	    var l = list.length;
	    var a1 = args[0];
	    var a2 = args[1];
	    var a3 = args[2];

	    switch (args.length) {
	      case 0:
	        for (; i < l; i += 2) {
	          pass = list[i].call(list[i + 1] || context) !== false && pass;
	        }
	        break;
	      case 1:
	        for (; i < l; i += 2) {
	          pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
	        }
	        break;
	      case 2:
	        for (; i < l; i += 2) {
	          pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
	        }
	        break;
	      case 3:
	        for (; i < l; i += 2) {
	          pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
	        }
	        break;
	      default:
	        for (; i < l; i += 2) {
	          pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
	        }
	        break;
	    }
	  }

	  return pass;
	}

	function isFunction(func) {
	  return Object.prototype.toString.call(func) === '[object Function]';
	}
	module.exports = Events;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [(_vm.showTimeString) ? _c('span', [_vm._v(_vm._s(_vm.timeString))]) : _vm._e(), _c('div', {
	    staticClass: "vux-clocker-tpl"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _popupPicker = __webpack_require__(255);

	var _popupPicker2 = _interopRequireDefault(_popupPicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_popupPicker2.default.install = function (Vue) {
	  Vue.component('LxPopupPicker', _popupPicker2.default);
	};

	exports.default = _popupPicker2.default;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(256)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(258),
	  /* template */
	  __webpack_require__(262),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(257);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6e37959c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./popup-picker.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6e37959c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./popup-picker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-popup-picker {\n  border-top: 1px solid #04BE02;\n}\n.vux-popup-picker-header {\n  height: 1.17333333rem;\n  color: #5890ff;\n}\n.vux-popup-picker-value {\n  display: inline-block;\n}\n.vue-popup-cancel {\n  text-align: left;\n  padding-left: 0.4rem;\n  line-height: 1.17333333rem;\n  color: #000;\n}\n.vue-popup-confirm {\n  text-align: right;\n  padding-right: 0.4rem;\n  line-height: 1.17333333rem;\n}\n.cvux-popup-placeholder {\n  color: #a0a0a0;\n}\n", ""]);

	// exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _picker = __webpack_require__(202);

	var _picker2 = _interopRequireDefault(_picker);

	var _cell = __webpack_require__(118);

	var _cell2 = _interopRequireDefault(_cell);

	var _popup = __webpack_require__(235);

	var _popup2 = _interopRequireDefault(_popup);

	var _flexbox = __webpack_require__(210);

	var _flexbox2 = _interopRequireDefault(_flexbox);

	var _flexboxItem = __webpack_require__(216);

	var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

	var _array2String = __webpack_require__(259);

	var _array2String2 = _interopRequireDefault(_array2String);

	var _value2name = __webpack_require__(260);

	var _value2name2 = _interopRequireDefault(_value2name);

	var _mixin_uuid = __webpack_require__(86);

	var _mixin_uuid2 = _interopRequireDefault(_mixin_uuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var getObject = function getObject(obj) {
	  return JSON.parse((0, _stringify2.default)(obj));
	};

	exports.default = {
	  created: function created() {
	    if (typeof this.show !== 'undefined') {
	      this.showValue = this.show;
	    }
	  },

	  mixins: [_mixin_uuid2.default],
	  components: {
	    Picker: _picker2.default,
	    Cell: _cell2.default,
	    Popup: _popup2.default,
	    Flexbox: _flexbox2.default,
	    FlexboxItem: _flexboxItem2.default
	  },
	  filters: {
	    array2string: _array2String2.default,
	    value2name: _value2name2.default
	  },
	  props: {
	    title: String,
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    valueTextAlign: {
	      type: String,
	      default: 'right'
	    },
	    placeholder: String,
	    columns: {
	      type: Number,
	      default: 0
	    },
	    fixedColumns: {
	      type: Number,
	      default: 0
	    },
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    showName: Boolean,
	    inlineDesc: String,
	    showCell: {
	      type: Boolean,
	      default: true
	    },
	    show: Boolean,
	    id: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    getNameValues: function getNameValues() {
	      return (0, _value2name2.default)(this.currentValue, this.data);
	    },
	    onClick: function onClick() {
	      this.showValue = true;
	    },
	    onHide: function onHide(type) {
	      this.showValue = false;
	      if (type) {
	        this.closeType = true;
	        this.currentValue = getObject(this.tempValue);
	      }
	      if (!type) {
	        this.closeType = false;
	        if (this.currentValue.length > 0) {
	          this.tempValue = getObject(this.currentValue);
	        }
	      }
	    },
	    onPopupHide: function onPopupHide(val) {
	      if (this.value.length > 0) {
	        this.tempValue = getObject(this.currentValue);
	      }
	      this.$emit('on-hide', this.closeType);
	    },
	    onPickerChange: function onPickerChange(val) {
	      if ((0, _stringify2.default)(this.currentValue) !== (0, _stringify2.default)(val)) {
	        if (this.value.length) {
	          var nowData = (0, _stringify2.default)(this.data);
	          if (nowData !== this.currentData && this.currentData !== '[]') {
	            this.tempValue = getObject(val);
	          }
	          this.currentData = nowData;
	        } else {}
	      }
	      this.$emit('on-shadow-change', getObject(val));
	    }
	  },
	  watch: {
	    value: function value(val) {
	      if ((0, _stringify2.default)(val) !== (0, _stringify2.default)(this.tempValue)) {
	        this.tempValue = getObject(val);
	      }
	    },
	    currentValue: function currentValue(val) {
	      this.$emit('on-change', getObject(val));
	      this.$emit('input', getObject(val));
	    },
	    show: function show(val) {
	      this.showValue = val;
	    }
	  },
	  data: function data() {
	    return {
	      tempValue: getObject(this.value),
	      closeType: false,
	      currentData: (0, _stringify2.default)(this.data),
	      showValue: false,
	      currentValue: this.value
	    };
	  }
	};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (array) {
	  return array.length === 1 ? array[0] : array.join(' ');
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (value, list) {
	  var rs = (0, _arrayMap2.default)(value, function (one, index) {
	    return (0, _arrayFind2.default)(list, function (item) {
	      return item.value === one;
	    });
	  });
	  return (0, _arrayMap2.default)(rs, function (one) {
	    return one ? one.name : '';
	  }).join(' ').replace('--', '');
	};

	var _arrayMap = __webpack_require__(261);

	var _arrayMap2 = _interopRequireDefault(_arrayMap);

	var _arrayFind = __webpack_require__(169);

	var _arrayFind2 = _interopRequireDefault(_arrayFind);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = require("array-map");

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('cell', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showCell),
	      expression: "showCell"
	    }],
	    attrs: {
	      "title": _vm.title,
	      "primary": "content",
	      "is-link": "",
	      "inline-desc": _vm.inlineDesc,
	      "value-text-align": _vm.valueTextAlign
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.onClick($event)
	      }
	    }
	  }, [(!_vm.showName && _vm.value.length) ? _c('span', {
	    staticClass: "vux-popup-picker-value"
	  }, [_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]) : (_vm.showName && _vm.value.length) ? _c('span', {
	    staticClass: "vux-popup-picker-value"
	  }, [_vm._v(_vm._s(_vm._f("value2name")(_vm.value, _vm.data)))]) : _vm._e(), (!_vm.value.length && _vm.placeholder) ? _c('span', {
	    staticClass: "cvux-popup-placeholder",
	    domProps: {
	      "innerHTML": _vm._s(_vm.placeholder)
	    }
	  }) : _vm._e()]), _c('popup', {
	    staticClass: "vux-popup-picker",
	    attrs: {
	      "id": ("vux-popup-picker-" + _vm.uuid)
	    },
	    on: {
	      "on-hide": _vm.onPopupHide,
	      "on-show": function($event) {
	        _vm.$emit('on-show')
	      }
	    },
	    model: {
	      value: (_vm.showValue),
	      callback: function($$v) {
	        _vm.showValue = $$v
	      },
	      expression: "showValue"
	    }
	  }, [_c('div', {
	    staticClass: "vux-popup-picker-container"
	  }, [_c('div', {
	    staticClass: "vux-popup-picker-header"
	  }, [_c('flexbox', [_c('flexbox-item', {
	    staticClass: "vue-popup-cancel",
	    nativeOn: {
	      "click": function($event) {
	        _vm.onHide(false)
	      }
	    }
	  }, [_vm._v("取消")]), _c('flexbox-item', {
	    staticClass: "vue-popup-confirm",
	    nativeOn: {
	      "click": function($event) {
	        _vm.onHide(true)
	      }
	    }
	  }, [_vm._v("完成")])], 1)], 1), _c('picker', {
	    attrs: {
	      "data": _vm.data,
	      "columns": _vm.columns,
	      "fixed-columns": _vm.fixedColumns,
	      "container": ("#vux-popup-picker-" + _vm.uuid),
	      "id": _vm.id
	    },
	    on: {
	      "on-change": _vm.onPickerChange
	    },
	    model: {
	      value: (_vm.tempValue),
	      callback: function($$v) {
	        _vm.tempValue = $$v
	      },
	      expression: "tempValue"
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xAddress = __webpack_require__(264);

	var _xAddress2 = _interopRequireDefault(_xAddress);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xAddress2.default.install = function (Vue) {
	  Vue.component('LxXAddress', _xAddress2.default);
	};

	exports.default = _xAddress2.default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(265),
	  /* template */
	  __webpack_require__(267),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _name2value = __webpack_require__(266);

	var _name2value2 = _interopRequireDefault(_name2value);

	var _value2name = __webpack_require__(260);

	var _value2name2 = _interopRequireDefault(_value2name);

	var _popupPicker = __webpack_require__(254);

	var _popupPicker2 = _interopRequireDefault(_popupPicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    PopupPicker: _popupPicker2.default
	  },
	  props: {
	    title: {
	      type: String,
	      required: true
	    },
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    rawValue: Boolean,
	    list: {
	      type: Array,
	      required: true
	    },
	    inlineDesc: String,
	    placeholder: String,
	    hideDistrict: Boolean,
	    valueTextAlign: String
	  },
	  created: function created() {
	    if (this.currentValue.length && this.rawValue) {
	      var parsedVal = (0, _name2value2.default)(this.currentValue, this.list);
	      if (/__/.test(parsedVal)) {
	        console.error('Vux: Wrong address value', this.currentValue);
	        this.currentValue = [];
	      } else {
	        this.currentValue = parsedVal.split(' ');
	      }
	    }
	  },

	  methods: {
	    emitHide: function emitHide(val) {
	      this.$emit('on-hide', val);
	    },
	    getAddressName: function getAddressName() {
	      return (0, _value2name2.default)(this.value, this.list);
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },

	  computed: {
	    nameValue: function nameValue() {
	      return (0, _value2name2.default)(this.currentValue, this.list);
	    }
	  },
	  watch: {
	    currentValue: function currentValue(val, oldVal) {
	      if (val !== oldVal) {
	        this.$emit('input', val);
	      }
	    },
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  }
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (name, list) {
	  var rs = (0, _arrayMap2.default)(name, function (one, index) {
	    var parent = '';
	    if (index === 2) {
	      parent = (0, _arrayFind2.default)(list, function (item) {
	        return item.name === name[1];
	      }) || { value: '__' };
	      return (0, _arrayFind2.default)(list, function (item) {
	        return item.name === one && item.parent === parent.value;
	      });
	    } else {
	      return (0, _arrayFind2.default)(list, function (item) {
	        return item.name === one;
	      });
	    }
	  });
	  return (0, _arrayMap2.default)(rs, function (one) {
	    return one ? one.value : '__';
	  }).join(' ');
	};

	var _arrayMap = __webpack_require__(261);

	var _arrayMap2 = _interopRequireDefault(_arrayMap);

	var _arrayFind = __webpack_require__(169);

	var _arrayFind2 = _interopRequireDefault(_arrayFind);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('popup-picker', {
	    attrs: {
	      "fixed-columns": _vm.hideDistrict ? 2 : 0,
	      "columns": 3,
	      "data": _vm.list,
	      "title": _vm.title,
	      "show-name": "",
	      "inline-desc": _vm.inlineDesc,
	      "placeholder": _vm.placeholder,
	      "value-text-align": _vm.valueTextAlign
	    },
	    on: {
	      "on-hide": _vm.emitHide,
	      "on-show": function($event) {
	        _vm.$emit('on-show')
	      }
	    },
	    model: {
	      value: (_vm.currentValue),
	      callback: function($$v) {
	        _vm.currentValue = $$v
	      },
	      expression: "currentValue"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _toast = __webpack_require__(269);

	var _toast2 = _interopRequireDefault(_toast);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_toast2.default.install = function (Vue) {
	  Vue.component('LxToast', _toast2.default);
	};

	exports.default = _toast2.default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(270)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(272),
	  /* template */
	  __webpack_require__(273),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(271);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5649fc8c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./toast.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5649fc8c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./toast.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-fade-transition {\n  opacity: 1;\n  transition: opacity linear 0.2s;\n}\n.vux-fade-enter,\n.vux-fade-leave {\n  opacity: 0;\n}\n.vux-dialog-transition {\n  opacity: 1;\n  transition-duration: .4s;\n  transform: translate(-50%, -50%) scale(1) !important;\n  transition-property: transform, opacity!important;\n}\n.vux-dialog-enter,\n.vux-dialog-leave {\n  opacity: 0;\n}\n.vux-dialog-enter {\n  transform: translate(-50%, -50%) scale(1.185) !important;\n}\n.vux-dialog-leave {\n  transform: translate(-50%, -50%) scale(1) !important;\n}\n/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui_mask {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_mask_transparent {\n  position: fixed;\n  z-index: 5001;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.weui_mask_transition {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: background .3s;\n}\n.weui_fade_toggle {\n  background: rgba(0, 0, 0, 0.6);\n}\n@font-face {\n  font-weight: normal;\n  font-style: normal;\n  font-family: \"weui\";\n  src: url('data:application/octet-stream;base64,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') format('truetype');\n}\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  font-family: \"weui\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: inherit;\n  width: 1em;\n  margin-right: 0.56rem;\n  text-align: center;\n  /* opacity: .8; */\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1;\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  margin-left: .2rem;\n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n.weui_icon_circle:before {\n  content: \"\\EA01\";\n}\n/* '' */\n.weui_icon_download:before {\n  content: \"\\EA02\";\n}\n/* '' */\n.weui_icon_info:before {\n  content: \"\\EA03\";\n}\n/* '' */\n.weui_icon_safe_success:before {\n  content: \"\\EA04\";\n}\n/* '' */\n.weui_icon_safe_warn:before {\n  content: \"\\EA05\";\n}\n/* '' */\n.weui_icon_success:before {\n  content: \"\\EA06\";\n}\n/* '' */\n.weui_icon_success_circle:before {\n  content: \"\\EA07\";\n}\n/* '' */\n.weui_icon_success_no_circle:before {\n  content: \"\\EA08\";\n}\n/* '' */\n.weui_icon_waiting:before {\n  content: \"\\EA09\";\n}\n/* '' */\n.weui_icon_waiting_circle:before {\n  content: \"\\EA0A\";\n}\n/* '' */\n.weui_icon_warn:before {\n  content: \"\\EA0B\";\n}\n/* '' */\n.weui_icon_info_circle:before {\n  content: \"\\EA0C\";\n}\n/* '' */\n.weui_icon_cancel:before {\n  content: \"\\EA0D\";\n}\n/* '' */\n.weui_icon_search:before {\n  content: \"\\EA0E\";\n}\n/* '' */\n.weui_icon_clear:before {\n  content: \"\\EA0F\";\n}\n/* '' */\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  margin: 0;\n}\n.weui_icon_success:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_waiting:before {\n  font-size: 0.61333333rem;\n  color: #10AEFF;\n}\n.weui_icon_warn:before {\n  font-size: 0.61333333rem;\n  color: #F43530;\n}\n.weui_icon_info:before {\n  font-size: 0.61333333rem;\n  color: #10AEFF;\n}\n.weui_icon_success_circle:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_success_no_circle:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_waiting_circle:before {\n  font-size: 0.48rem;\n  color: #10AEFF;\n}\n.weui_icon_circle:before {\n  font-size: 0.48rem;\n  color: #C9C9C9;\n}\n.weui_icon_download:before {\n  font-size: 0.48rem;\n  color: #09BB07;\n}\n.weui_icon_info_circle:before {\n  font-size: 0.48rem;\n  color: #09BB07;\n}\n.weui_icon_safe_success:before {\n  color: #09BB07;\n}\n.weui_icon_safe_warn:before {\n  color: #FFBE00;\n}\n.weui_icon_cancel:before {\n  color: #F43530;\n  font-size: 0.58666667rem;\n}\n.weui_icon_search:before {\n  color: #B2B2B2;\n  font-size: 0.37333333rem;\n}\n.weui_icon_clear:before {\n  color: #B2B2B2;\n  font-size: 0.37333333rem;\n}\n.weui_icon_msg:before {\n  font-size: 2.77333333rem;\n}\n.weui_icon_warn.weui_icon_msg:before {\n  color: #F76260;\n}\n.weui_icon_safe:before {\n  font-size: 2.77333333rem;\n}\n.weui_toast {\n  position: fixed;\n  z-index: 50000;\n  width: 3.25333333rem;\n  min-height: 3.25333333rem;\n  top: 4.8rem;\n  left: 50%;\n  margin-left: -0.81333333rem;\n  background: rgba(40, 40, 40, 0.75);\n  text-align: center;\n  border-radius: 5px;\n  color: #FFFFFF;\n}\n.weui_icon_toast {\n  margin: 0.58666667rem 0 0;\n  display: block;\n}\n.weui_icon_toast:before {\n  content: '\\EA08';\n  color: #FFFFFF;\n  font-size: 1.46666667rem;\n}\n.weui_toast_content {\n  margin: 0 0 0.4rem;\n}\n.weui_loading_toast .weui_toast_content {\n  margin-top: 64%;\n  font-size: 0.37333333rem;\n}\n.weui_loading {\n  position: absolute;\n  width: 0px;\n  z-index: 1;\n  left: 50%;\n  top: 38%;\n}\n.weui_toast {\n  transform: translateX(-50%);\n  margin-left: 0!important;\n}\n.weui_toast_forbidden {\n  color: #F76260;\n}\n.weui_toast.weui_toast_text {\n  min-height: 0;\n}\n.weui_toast_text .weui_toast_content {\n  margin: 0;\n  padding-top: 0.26666667rem;\n  padding-bottom: 0.26666667rem;\n  border-radius: 0.4rem;\n}\n.weui_toast_success .weui_icon_toast:before {\n  content: \"\\EA08\";\n}\n.weui_toast_cancel .weui_icon_toast:before {\n  content: \"\\EA0D\";\n}\n.weui_toast_forbidden .weui_icon_toast:before {\n  content: \"\\EA0B\";\n  color: #F76260;\n}\n", ""]);

	// exports


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    time: {
	      type: Number,
	      default: 2000
	    },
	    type: {
	      type: String,
	      default: 'success'
	    },
	    transition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    width: {
	      type: String,
	      default: '100/@w'
	    },
	    text: String
	  },
	  data: function data() {
	    return {
	      show: false
	    };
	  },
	  created: function created() {
	    if (this.value) {
	      this.show = true;
	    }
	  },

	  computed: {
	    toastClass: function toastClass() {
	      return {
	        'weui_toast_forbidden': this.type === 'warn',
	        'weui_toast_cancel': this.type === 'cancel',
	        'weui_toast_success': this.type === 'success',
	        'weui_toast_text': this.type === 'text'
	      };
	    }
	  },
	  watch: {
	    show: function show(val) {
	      var _this = this;

	      if (val) {
	        this.$emit('on-show');
	        this.$emit('input', true);
	      }
	      if (val) {
	        clearTimeout(this.timeout);
	        this.timeout = setTimeout(function () {
	          _this.show = false;
	          _this.$emit('input', false);
	          _this.$emit('on-hide');
	        }, this.time);
	      }
	    },
	    value: function value(val) {
	      this.show = val;
	    }
	  }
	};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-toast"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui_mask_transparent"
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui_toast",
	    class: _vm.toastClass,
	    style: ({
	      width: _vm.width
	    }),
	    attrs: {
	      "transition": _vm.transition
	    }
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.type !== 'text'),
	      expression: "type !== 'text'"
	    }],
	    staticClass: "weui_icon_toast"
	  }), (_vm.text) ? _c('p', {
	    staticClass: "weui_toast_content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }) : _c('p', {
	    staticClass: "weui_toast_content"
	  }, [_vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _loading = __webpack_require__(275);

	var _loading2 = _interopRequireDefault(_loading);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_loading2.default.install = function (Vue) {
	  Vue.component('LxLoading', _loading2.default);
	};

	exports.default = _loading2.default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(276)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(278),
	  /* template */
	  __webpack_require__(279),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(277);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-84fd7f94!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-84fd7f94!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui_mask {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_mask_transparent {\n  position: fixed;\n  z-index: 5001;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.weui_mask_transition {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: background .3s;\n}\n.weui_fade_toggle {\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_toast {\n  position: fixed;\n  z-index: 50000;\n  width: 3.25333333rem;\n  min-height: 3.25333333rem;\n  top: 4.8rem;\n  left: 50%;\n  margin-left: -0.81333333rem;\n  background: rgba(40, 40, 40, 0.75);\n  text-align: center;\n  border-radius: 5px;\n  color: #FFFFFF;\n}\n.weui_icon_toast {\n  margin: 0.58666667rem 0 0;\n  display: block;\n}\n.weui_icon_toast:before {\n  content: '\\EA08';\n  color: #FFFFFF;\n  font-size: 1.46666667rem;\n}\n.weui_toast_content {\n  margin: 0 0 0.4rem;\n}\n.weui_loading_toast .weui_toast_content {\n  margin-top: 64%;\n  font-size: 0.37333333rem;\n}\n.weui_loading {\n  position: absolute;\n  width: 0px;\n  z-index: 1;\n  left: 50%;\n  top: 38%;\n}\n.weui_loading_leaf {\n  position: absolute;\n  top: -1px;\n  opacity: 0.25;\n}\n.weui_loading_leaf:before {\n  content: \" \";\n  position: absolute;\n  width: 0.21706667rem;\n  height: 0.08213333rem;\n  background: #d1d1d5;\n  box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 1px;\n  border-radius: 1px;\n  transform-origin: left 50% 0px;\n}\n.weui_loading_leaf_0 {\n  animation: opacity-60-25-0-12 1.25s linear infinite;\n}\n.weui_loading_leaf_0:before {\n  transform: rotate(0deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_1 {\n  animation: opacity-60-25-1-12 1.25s linear infinite;\n}\n.weui_loading_leaf_1:before {\n  transform: rotate(30deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_2 {\n  animation: opacity-60-25-2-12 1.25s linear infinite;\n}\n.weui_loading_leaf_2:before {\n  transform: rotate(60deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_3 {\n  animation: opacity-60-25-3-12 1.25s linear infinite;\n}\n.weui_loading_leaf_3:before {\n  transform: rotate(90deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_4 {\n  animation: opacity-60-25-4-12 1.25s linear infinite;\n}\n.weui_loading_leaf_4:before {\n  transform: rotate(120deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_5 {\n  animation: opacity-60-25-5-12 1.25s linear infinite;\n}\n.weui_loading_leaf_5:before {\n  transform: rotate(150deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_6 {\n  animation: opacity-60-25-6-12 1.25s linear infinite;\n}\n.weui_loading_leaf_6:before {\n  transform: rotate(180deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_7 {\n  animation: opacity-60-25-7-12 1.25s linear infinite;\n}\n.weui_loading_leaf_7:before {\n  transform: rotate(210deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_8 {\n  animation: opacity-60-25-8-12 1.25s linear infinite;\n}\n.weui_loading_leaf_8:before {\n  transform: rotate(240deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_9 {\n  animation: opacity-60-25-9-12 1.25s linear infinite;\n}\n.weui_loading_leaf_9:before {\n  transform: rotate(270deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_10 {\n  animation: opacity-60-25-10-12 1.25s linear infinite;\n}\n.weui_loading_leaf_10:before {\n  transform: rotate(300deg) translate(0.2112rem, 0px);\n}\n.weui_loading_leaf_11 {\n  animation: opacity-60-25-11-12 1.25s linear infinite;\n}\n.weui_loading_leaf_11:before {\n  transform: rotate(330deg) translate(0.2112rem, 0px);\n}\n@-webkit-keyframes opacity-60-25-0-12 {\n0% {\n    opacity: 0.25;\n}\n0.01% {\n    opacity: 0.25;\n}\n0.02% {\n    opacity: 1;\n}\n60.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-0-12 {\n0% {\n    opacity: 0.25;\n}\n0.01% {\n    opacity: 0.25;\n}\n0.02% {\n    opacity: 1;\n}\n60.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-1-12 {\n0% {\n    opacity: 0.25;\n}\n8.34333% {\n    opacity: 0.25;\n}\n8.35333% {\n    opacity: 1;\n}\n68.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-1-12 {\n0% {\n    opacity: 0.25;\n}\n8.34333% {\n    opacity: 0.25;\n}\n8.35333% {\n    opacity: 1;\n}\n68.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-2-12 {\n0% {\n    opacity: 0.25;\n}\n16.6767% {\n    opacity: 0.25;\n}\n16.6867% {\n    opacity: 1;\n}\n76.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-2-12 {\n0% {\n    opacity: 0.25;\n}\n16.6767% {\n    opacity: 0.25;\n}\n16.6867% {\n    opacity: 1;\n}\n76.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-3-12 {\n0% {\n    opacity: 0.25;\n}\n25.01% {\n    opacity: 0.25;\n}\n25.02% {\n    opacity: 1;\n}\n85.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-3-12 {\n0% {\n    opacity: 0.25;\n}\n25.01% {\n    opacity: 0.25;\n}\n25.02% {\n    opacity: 1;\n}\n85.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-4-12 {\n0% {\n    opacity: 0.25;\n}\n33.3433% {\n    opacity: 0.25;\n}\n33.3533% {\n    opacity: 1;\n}\n93.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-4-12 {\n0% {\n    opacity: 0.25;\n}\n33.3433% {\n    opacity: 0.25;\n}\n33.3533% {\n    opacity: 1;\n}\n93.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-5-12 {\n0% {\n    opacity: 0.270958333333333;\n}\n41.6767% {\n    opacity: 0.25;\n}\n41.6867% {\n    opacity: 1;\n}\n1.67667% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.270958333333333;\n}\n}\n@keyframes opacity-60-25-5-12 {\n0% {\n    opacity: 0.270958333333333;\n}\n41.6767% {\n    opacity: 0.25;\n}\n41.6867% {\n    opacity: 1;\n}\n1.67667% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.270958333333333;\n}\n}\n@-webkit-keyframes opacity-60-25-6-12 {\n0% {\n    opacity: 0.375125;\n}\n50.01% {\n    opacity: 0.25;\n}\n50.02% {\n    opacity: 1;\n}\n10.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.375125;\n}\n}\n@keyframes opacity-60-25-6-12 {\n0% {\n    opacity: 0.375125;\n}\n50.01% {\n    opacity: 0.25;\n}\n50.02% {\n    opacity: 1;\n}\n10.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.375125;\n}\n}\n@-webkit-keyframes opacity-60-25-7-12 {\n0% {\n    opacity: 0.479291666666667;\n}\n58.3433% {\n    opacity: 0.25;\n}\n58.3533% {\n    opacity: 1;\n}\n18.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.479291666666667;\n}\n}\n@keyframes opacity-60-25-7-12 {\n0% {\n    opacity: 0.479291666666667;\n}\n58.3433% {\n    opacity: 0.25;\n}\n58.3533% {\n    opacity: 1;\n}\n18.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.479291666666667;\n}\n}\n@-webkit-keyframes opacity-60-25-8-12 {\n0% {\n    opacity: 0.583458333333333;\n}\n66.6767% {\n    opacity: 0.25;\n}\n66.6867% {\n    opacity: 1;\n}\n26.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.583458333333333;\n}\n}\n@keyframes opacity-60-25-8-12 {\n0% {\n    opacity: 0.583458333333333;\n}\n66.6767% {\n    opacity: 0.25;\n}\n66.6867% {\n    opacity: 1;\n}\n26.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.583458333333333;\n}\n}\n@-webkit-keyframes opacity-60-25-9-12 {\n0% {\n    opacity: 0.687625;\n}\n75.01% {\n    opacity: 0.25;\n}\n75.02% {\n    opacity: 1;\n}\n35.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.687625;\n}\n}\n@keyframes opacity-60-25-9-12 {\n0% {\n    opacity: 0.687625;\n}\n75.01% {\n    opacity: 0.25;\n}\n75.02% {\n    opacity: 1;\n}\n35.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.687625;\n}\n}\n@-webkit-keyframes opacity-60-25-10-12 {\n0% {\n    opacity: 0.791791666666667;\n}\n83.3433% {\n    opacity: 0.25;\n}\n83.3533% {\n    opacity: 1;\n}\n43.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.791791666666667;\n}\n}\n@keyframes opacity-60-25-10-12 {\n0% {\n    opacity: 0.791791666666667;\n}\n83.3433% {\n    opacity: 0.25;\n}\n83.3533% {\n    opacity: 1;\n}\n43.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.791791666666667;\n}\n}\n@-webkit-keyframes opacity-60-25-11-12 {\n0% {\n    opacity: 0.895958333333333;\n}\n91.6767% {\n    opacity: 0.25;\n}\n91.6867% {\n    opacity: 1;\n}\n51.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.895958333333333;\n}\n}\n@keyframes opacity-60-25-11-12 {\n0% {\n    opacity: 0.895958333333333;\n}\n91.6767% {\n    opacity: 0.25;\n}\n91.6867% {\n    opacity: 1;\n}\n51.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.895958333333333;\n}\n}\n/* .weui-icon_toast{\n    margin: 30px 0 0;\n    width: 38px;\n    height: 38px;\n    vertical-align: baseline;\n    display: inline-block;\n    animation: c 1s steps(12) infinite;\n    background: transparent url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=) no-repeat;\n    background-size: 100%;\n}\n@-webkit-keyframes c{\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes c{\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n} */\n", ""]);

	// exports


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    show: Boolean,
	    text: {
	      type: String,
	      default: 'Loading'
	    },
	    position: String
	  }
	};

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui_loading_toast"
	  }, [_c('div', {
	    staticClass: "weui_mask_transparent"
	  }), _c('div', {
	    staticClass: "weui_toast",
	    style: ({
	      position: _vm.position
	    })
	  }, [_c('div', {
	    staticClass: "weui_loading"
	  }, _vm._l((12), function(i) {
	    return _c('div', {
	      staticClass: "weui_loading_leaf",
	      class: ['weui_loading_leaf_' + (i - 1)]
	    })
	  })), _c('p', {
	    staticClass: "weui_toast_content"
	  }, [_vm._v(_vm._s(_vm.text)), _vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xAlert = __webpack_require__(281);

	var _xAlert2 = _interopRequireDefault(_xAlert);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xAlert2.default.install = function (Vue) {
	  Vue.component('LxXAlert', _xAlert2.default);
	};

	exports.default = _xAlert2.default;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(282)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(284),
	  /* template */
	  __webpack_require__(291),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(283);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6fe58f4c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-alert.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6fe58f4c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-alert.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-fade-transition {\n  opacity: 1;\n  transition: opacity linear 0.2s;\n}\n.vux-fade-enter,\n.vux-fade-leave {\n  opacity: 0;\n}\n.vux-dialog-transition {\n  opacity: 1;\n  transition-duration: .4s;\n  transform: translate(-50%, -50%) scale(1) !important;\n  transition-property: transform, opacity!important;\n}\n.vux-dialog-enter,\n.vux-dialog-leave {\n  opacity: 0;\n}\n.vux-dialog-enter {\n  transform: translate(-50%, -50%) scale(1.185) !important;\n}\n.vux-dialog-leave {\n  transform: translate(-50%, -50%) scale(1) !important;\n}\n/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui_mask {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_mask_transparent {\n  position: fixed;\n  z-index: 5001;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.weui_mask_transition {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: background .3s;\n}\n.weui_fade_toggle {\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_dialog {\n  position: fixed;\n  z-index: 5000;\n  width: 85%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #FAFAFC;\n  text-align: center;\n  border-radius: 0.21333333rem;\n  overflow: hidden;\n}\n.weui_dialog_confirm .weui_dialog .weui_dialog_bd {\n  text-align: left;\n}\n.weui_dialog_mes {\n  line-height: 0.66666667rem;\n  padding: 0.66666667rem 0;\n}\n.weui_dialog_title {\n  font-weight: 400;\n  font-size: 0.45333333rem;\n}\n.weui_dialog_bd {\n  padding: 0 0.26666667rem;\n  font-size: 0.4rem;\n  color: #000;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.weui_dialog_ft {\n  position: relative;\n  line-height: 1.12rem;\n  font-size: 0.45333333rem;\n  display: flex;\n}\n.weui_dialog_ft a {\n  display: block;\n  flex: 1;\n  color: #3CC51F;\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_dialog_ft a:active {\n  background-color: #EEEEEE;\n}\n.weui_dialog_ft:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D5D5D6;\n  color: #D5D5D6;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_dialog_confirm .weui_dialog_ft a {\n  position: relative;\n}\n.weui_dialog_confirm .weui_dialog_ft a:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  border-left: 1px solid #D5D5D6;\n  color: #D5D5D6;\n  transform-origin: 0 0;\n  transform: scaleX(0.5);\n}\n.weui_dialog_confirm .weui_dialog_ft a:first-child:after {\n  display: none;\n}\n.weui_btn_dialog.default {\n  color: #333;\n}\n.weui_btn_dialog.primary {\n  color: #5890ff;\n}\n@media screen and (min-width: 1024px) {\n.weui_dialog {\n    width: 35%;\n}\n}\n", ""]);

	// exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xDialog = __webpack_require__(285);

	var _xDialog2 = _interopRequireDefault(_xDialog);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    XDialog: _xDialog2.default
	  },
	  props: {
	    value: Boolean,
	    title: String,
	    content: String,
	    buttonText: {
	      type: String,
	      default: 'OK'
	    },
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    },
	    autoCloseTime: Number
	  },
	  methods: {
	    _onHide: function _onHide() {
	      this.show = false;
	    }
	  },
	  data: function data() {
	    return {
	      show: false,
	      timeId: ''
	    };
	  },

	  watch: {
	    show: function show(val) {
	      var _this = this;

	      if (val && this.autoCloseTime > 0) {
	        var _autoCloseTime = this.autoCloseTime;
	        this.timeId = setTimeout(function () {
	          _this.show = false;
	        }, _autoCloseTime);
	      }
	      if (!val && this.timeId) {
	        clearTimeout(this.timeId);
	        this.timeId = '';
	      }
	      this.$emit('input', val);
	    },
	    value: function value(val) {
	      this.show = val;
	    }
	  }
	};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xDialog = __webpack_require__(286);

	var _xDialog2 = _interopRequireDefault(_xDialog);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xDialog2.default.install = function (Vue) {
	  Vue.component('LxXDialog', _xDialog2.default);
	};

	exports.default = _xDialog2.default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(287)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(289),
	  /* template */
	  __webpack_require__(290),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(288);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5bf9d348!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-dialog.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5bf9d348!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-dialog.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-fade-transition {\n  opacity: 1;\n  transition: opacity linear 0.2s;\n}\n.vux-fade-enter,\n.vux-fade-leave {\n  opacity: 0;\n}\n.vux-dialog-transition {\n  opacity: 1;\n  transition-duration: .4s;\n  transform: translate(-50%, -50%) scale(1) !important;\n  transition-property: transform, opacity!important;\n}\n.vux-dialog-enter,\n.vux-dialog-leave {\n  opacity: 0;\n}\n.vux-dialog-enter {\n  transform: translate(-50%, -50%) scale(1.185) !important;\n}\n.vux-dialog-leave {\n  transform: translate(-50%, -50%) scale(1) !important;\n}\n/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui_mask {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_mask_transparent {\n  position: fixed;\n  z-index: 5001;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.weui_mask_transition {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: background .3s;\n}\n.weui_fade_toggle {\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_dialog {\n  position: fixed;\n  z-index: 5000;\n  width: 85%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #FAFAFC;\n  text-align: center;\n  border-radius: 0.21333333rem;\n  overflow: hidden;\n}\n.weui_dialog_confirm .weui_dialog .weui_dialog_bd {\n  text-align: left;\n}\n.weui_dialog_mes {\n  line-height: 0.66666667rem;\n  padding: 0.66666667rem 0;\n}\n.weui_dialog_title {\n  font-weight: 400;\n  font-size: 0.45333333rem;\n}\n.weui_dialog_bd {\n  padding: 0 0.26666667rem;\n  font-size: 0.4rem;\n  color: #000;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.weui_dialog_ft {\n  position: relative;\n  line-height: 1.12rem;\n  font-size: 0.45333333rem;\n  display: flex;\n}\n.weui_dialog_ft a {\n  display: block;\n  flex: 1;\n  color: #3CC51F;\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_dialog_ft a:active {\n  background-color: #EEEEEE;\n}\n.weui_dialog_ft:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D5D5D6;\n  color: #D5D5D6;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_dialog_confirm .weui_dialog_ft a {\n  position: relative;\n}\n.weui_dialog_confirm .weui_dialog_ft a:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  border-left: 1px solid #D5D5D6;\n  color: #D5D5D6;\n  transform-origin: 0 0;\n  transform: scaleX(0.5);\n}\n.weui_dialog_confirm .weui_dialog_ft a:first-child:after {\n  display: none;\n}\n.weui_btn_dialog.default {\n  color: #333;\n}\n.weui_btn_dialog.primary {\n  color: #5890ff;\n}\n@media screen and (min-width: 1024px) {\n.weui_dialog {\n    width: 35%;\n}\n}\n", ""]);

	// exports


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    },
	    hideOnBlur: Boolean,
	    scroll: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      show: false
	    };
	  },

	  methods: {
	    onHide: function onHide() {
	      this.show = false;
	      this.$emit('on-hide');
	    }
	  },
	  watch: {
	    show: function show(val) {
	      this.$emit(val ? 'on-show' : 'on-hide');
	      this.$emit('input', val);
	    },
	    value: function value(val) {
	      this.show = val;
	    }
	  }
	};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_dialog_alert",
	    on: {
	      "touchmove": function($event) {
	        !this.scroll && $event.preventDefault()
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui_mask",
	    attrs: {
	      "transition": _vm.maskTransition
	    },
	    on: {
	      "click": _vm.onHide
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui_dialog",
	    attrs: {
	      "transition": _vm.dialogTransition
	    }
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-alert"
	  }, [_c('x-dialog', {
	    staticClass: "weui_dialog_alert",
	    attrs: {
	      "mask-transition": _vm.maskTransition,
	      "dialog-transition": _vm.dialogTransition
	    },
	    on: {
	      "on-hide": function($event) {
	        _vm.$emit('on-hide')
	      },
	      "on-show": function($event) {
	        _vm.$emit('on-show')
	      }
	    },
	    model: {
	      value: (_vm.show),
	      callback: function($$v) {
	        _vm.show = $$v
	      },
	      expression: "show"
	    }
	  }, [_c('div', {
	    staticClass: "weui_dialog_mes"
	  }, [_c('div', {
	    staticClass: "weui_dialog_hd"
	  }, [_c('strong', {
	    staticClass: "weui_dialog_title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
	    staticClass: "weui_dialog_bd"
	  }, [_vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 2)]), _c('div', {
	    staticClass: "weui_dialog_ft"
	  }, [_c('a', {
	    staticClass: "weui_btn_dialog primary",
	    on: {
	      "click": _vm._onHide
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText))])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _confirm = __webpack_require__(293);

	var _confirm2 = _interopRequireDefault(_confirm);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_confirm2.default.install = function (Vue) {
	  Vue.component('LxConfirm', _confirm2.default);
	};

	exports.default = _confirm2.default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(294)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(296),
	  /* template */
	  __webpack_require__(297),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(295);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c1aa7984!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./confirm.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c1aa7984!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./confirm.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-fade-transition {\n  opacity: 1;\n  transition: opacity linear 0.2s;\n}\n.vux-fade-enter,\n.vux-fade-leave {\n  opacity: 0;\n}\n.vux-dialog-transition {\n  opacity: 1;\n  transition-duration: .4s;\n  transform: translate(-50%, -50%) scale(1) !important;\n  transition-property: transform, opacity!important;\n}\n.vux-dialog-enter,\n.vux-dialog-leave {\n  opacity: 0;\n}\n.vux-dialog-enter {\n  transform: translate(-50%, -50%) scale(1.185) !important;\n}\n.vux-dialog-leave {\n  transform: translate(-50%, -50%) scale(1) !important;\n}\n/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui_mask {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_mask_transparent {\n  position: fixed;\n  z-index: 5001;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.weui_mask_transition {\n  display: none;\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0);\n  transition: background .3s;\n}\n.weui_fade_toggle {\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui_dialog {\n  position: fixed;\n  z-index: 5000;\n  width: 85%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #FAFAFC;\n  text-align: center;\n  border-radius: 0.21333333rem;\n  overflow: hidden;\n}\n.weui_dialog_confirm .weui_dialog .weui_dialog_bd {\n  text-align: left;\n}\n.weui_dialog_mes {\n  line-height: 0.66666667rem;\n  padding: 0.66666667rem 0;\n}\n.weui_dialog_title {\n  font-weight: 400;\n  font-size: 0.45333333rem;\n}\n.weui_dialog_bd {\n  padding: 0 0.26666667rem;\n  font-size: 0.4rem;\n  color: #000;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.weui_dialog_ft {\n  position: relative;\n  line-height: 1.12rem;\n  font-size: 0.45333333rem;\n  display: flex;\n}\n.weui_dialog_ft a {\n  display: block;\n  flex: 1;\n  color: #3CC51F;\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_dialog_ft a:active {\n  background-color: #EEEEEE;\n}\n.weui_dialog_ft:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D5D5D6;\n  color: #D5D5D6;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_dialog_confirm .weui_dialog_ft a {\n  position: relative;\n}\n.weui_dialog_confirm .weui_dialog_ft a:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  border-left: 1px solid #D5D5D6;\n  color: #D5D5D6;\n  transform-origin: 0 0;\n  transform: scaleX(0.5);\n}\n.weui_dialog_confirm .weui_dialog_ft a:first-child:after {\n  display: none;\n}\n.weui_btn_dialog.default {\n  color: #333;\n}\n.weui_btn_dialog.primary {\n  color: #5890ff;\n}\n@media screen and (min-width: 1024px) {\n.weui_dialog {\n    width: 35%;\n}\n}\n", ""]);

	// exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xDialog = __webpack_require__(285);

	var _xDialog2 = _interopRequireDefault(_xDialog);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    XDialog: _xDialog2.default
	  },
	  props: {
	    value: {
	      type: Boolean,
	      defalut: false
	    },
	    title: {
	      type: String,
	      required: true
	    },
	    confirmText: {
	      type: String,
	      default: 'confirm'
	    },
	    cancelText: {
	      type: String,
	      default: 'cancel'
	    },
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    }
	  },
	  methods: {
	    onConfirm: function onConfirm() {
	      this.show = false;
	      this.$emit('on-confirm');
	    },
	    onCancel: function onCancel() {
	      this.show = false;
	      this.$emit('on-cancel');
	    }
	  },
	  mounted: function mounted() {
	    this.show = this.value;
	  },
	  data: function data() {
	    return {
	      show: false
	    };
	  },

	  watch: {
	    show: function show(val) {
	      this.$emit('input', val);
	    },
	    value: function value(val) {
	      if (this.show !== val) {
	        this.show = val;
	      }
	    }
	  }
	};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('x-dialog', {
	    staticClass: "weui_dialog_confirm",
	    attrs: {
	      "mask-transition": _vm.maskTransition,
	      "dialog-transition": _vm.dialogTransition
	    },
	    on: {
	      "on-hide": function($event) {
	        _vm.$emit('on-hide')
	      },
	      "on-show": function($event) {
	        _vm.$emit('on-show')
	      }
	    },
	    model: {
	      value: (_vm.show),
	      callback: function($$v) {
	        _vm.show = $$v
	      },
	      expression: "show"
	    }
	  }, [_c('div', {
	    staticClass: "weui_dialog_mes"
	  }, [_c('div', {
	    staticClass: "weui_dialog_hd"
	  }, [_c('strong', {
	    staticClass: "weui_dialog_title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
	    staticClass: "weui_dialog_bd"
	  }, [_vm._t("default")], 2)]), _c('div', {
	    staticClass: "weui_dialog_ft"
	  }, [_c('a', {
	    staticClass: "weui_btn_dialog default",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText))]), _c('a', {
	    staticClass: "weui_btn_dialog primary",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.onConfirm
	    }
	  }, [_vm._v(_vm._s(_vm.confirmText))])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xProgress = __webpack_require__(299);

	var _xProgress2 = _interopRequireDefault(_xProgress);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xProgress2.default.install = function (Vue) {
	  Vue.component('LxXProgress', _xProgress2.default);
	};

	exports.default = _xProgress2.default;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(300)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(302),
	  /* template */
	  __webpack_require__(303),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(301);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d06be3c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-progress.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d06be3c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-progress.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n.weui_progress {\n  display: flex;\n  align-items: center;\n}\n.weui_progress_bar {\n  background-color: #EBEBEB;\n  height: 3px;\n  flex: 1;\n}\n.weui_progress_inner_bar {\n  width: 0;\n  height: 100%;\n  background-color: #09BB07;\n}\n.weui_progress_opr {\n  display: block;\n  margin-left: 15px;\n  font-size: 0;\n}\n", ""]);

	// exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _base = __webpack_require__(85);

	var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: 'x-progress',
	  mixins: [_base2.default],
	  props: {
	    percent: {
	      type: Number,
	      default: 0
	    },
	    showCancel: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    cancel: function cancel() {
	      this.$emit('on-cancel');
	    }
	  }
	};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_progress"
	  }, [_c('div', {
	    staticClass: "weui_progress_bar"
	  }, [_c('div', {
	    staticClass: "weui_progress_inner_bar",
	    style: ({
	      width: _vm.percent + '%'
	    })
	  })]), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showCancel),
	      expression: "showCancel"
	    }],
	    staticClass: "weui_progress_opr",
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('i', {
	    staticClass: "weui_icon_cancel",
	    on: {
	      "click": _vm.cancel
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _spinner = __webpack_require__(305);

	var _spinner2 = _interopRequireDefault(_spinner);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_spinner2.default.install = function (Vue) {
	  Vue.component('LxSpinner', _spinner2.default);
	};

	exports.default = _spinner2.default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(306)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(308),
	  /* template */
	  __webpack_require__(311),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(307);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3813c7f0!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./spinner.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3813c7f0!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./spinner.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-spinner {\r\n  stroke: #444;\r\n  fill: #444;\r\n  vertical-align: middle;\r\n  display: inline-block;\r\n  width: 28px;\r\n  height: 28px;\n}\n.vux-spinner svg {\r\n  width: 28px;\r\n  height: 28px;\n}\n.vux-spinner.vux-spinner-inverse {\r\n  stroke: #fff;\r\n  fill: #fff;\n}\n.vux-spinner-android {\r\n  stroke: #4b8bf4;\n}\n.vux-spinner-ios, .vux-spinner-ios-small {\r\n  stroke: #69717d;\n}\n.vux-spinner-spiral .stop1 {\r\n  stop-color: #fff;\r\n  stop-opacity: 0;\n}\n.vux-spinner-spiral.vux-spinner-inverse .stop1 {\r\n  stop-color: #000;\n}\n.vux-spinner-spiral.vux-spinner-inverse .stop2 {\r\n  stop-color: #fff;\n}\r\n", ""]);

	// exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _spinner = __webpack_require__(309);

	var _spinner2 = _interopRequireDefault(_spinner);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

	exports.default = {
	  mounted: function mounted() {
	    (0, _spinner2.default)(this.$el, this.type);
	  },

	  props: {
	    type: {
	      type: String,
	      default: 'ios'
	    }
	  },
	  computed: {
	    className: function className() {
	      var rs = {};
	      for (var i = 0; i < types.length; i++) {
	        rs['vux-spinner-' + types[i]] = this.type === types[i];
	      }
	      return rs;
	    }
	  }
	};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (el, icon) {
	  if (isServer) return;
	  var spinnerName, anim;
	  spinnerName = icon;
	  var container = document.createElement('div');
	  createSvgElement('svg', {
	    viewBox: '0 0 64 64',
	    g: [spinners[spinnerName]]
	  }, container, spinnerName);

	  el.innerHTML = container.innerHTML;
	  start();
	  function start() {
	    if (animations[spinnerName]) {
	      anim = animations[spinnerName](el)();
	    }
	  }
	  return el;
	};

	__webpack_require__(310);

	var isServer = typeof window === 'undefined';
	var TRANSLATE32 = 'translate(32,32)';
	var STROKE_OPACITY = 'stroke-opacity';
	var ROUND = 'round';
	var INDEFINITE = 'indefinite';
	var DURATION = '750ms';
	var NONE = 'none';
	var SHORTCUTS = {
	  a: 'animate',
	  an: 'attributeName',
	  at: 'animateTransform',
	  c: 'circle',
	  da: 'stroke-dasharray',
	  os: 'stroke-dashoffset',
	  f: 'fill',
	  lc: 'stroke-linecap',
	  rc: 'repeatCount',
	  sw: 'stroke-width',
	  t: 'transform',
	  v: 'values'
	};

	var SPIN_ANIMATION = {
	  v: '0,32,32;360,32,32',
	  an: 'transform',
	  type: 'rotate',
	  rc: INDEFINITE,
	  dur: DURATION
	};

	function createSvgElement(tagName, data, parent, spinnerName) {
	  if (isServer) return;
	  var ele = document.createElement(SHORTCUTS[tagName] || tagName);
	  var k, x, y;

	  for (k in data) {
	    if (Object.prototype.toString.call(data[k]) === '[object Array]') {
	      for (x = 0; x < data[k].length; x++) {
	        if (data[k][x].fn) {
	          for (y = 0; y < data[k][x].t; y++) {
	            createSvgElement(k, data[k][x].fn(y, spinnerName), ele, spinnerName);
	          }
	        } else {
	          createSvgElement(k, data[k][x], ele, spinnerName);
	        }
	      }
	    } else {
	      setSvgAttribute(ele, k, data[k]);
	    }
	  }

	  parent.appendChild(ele);
	}

	function setSvgAttribute(ele, k, v) {
	  ele.setAttribute(SHORTCUTS[k] || k, v);
	}

	function animationValues(strValues, i) {
	  var values = strValues.split(';');
	  var back = values.slice(i);
	  var front = values.slice(0, values.length - back.length);
	  values = back.concat(front).reverse();
	  return values.join(';') + ';' + values[0];
	}

	var IOS_SPINNER = {
	  sw: 4,
	  lc: ROUND,
	  line: [{
	    fn: function fn(i, spinnerName) {
	      return {
	        y1: spinnerName === 'ios' ? 17 : 12,
	        y2: spinnerName === 'ios' ? 29 : 20,
	        t: TRANSLATE32 + ' rotate(' + (30 * i + (i < 6 ? 180 : -180)) + ')',
	        a: [{
	          fn: function fn() {
	            return {
	              an: STROKE_OPACITY,
	              dur: DURATION,
	              v: animationValues('0;.1;.15;.25;.35;.45;.55;.65;.7;.85;1', i),
	              rc: INDEFINITE
	            };
	          },

	          t: 1
	        }]
	      };
	    },

	    t: 12
	  }]
	};

	var spinners = {

	  android: {
	    c: [{
	      sw: 6,
	      da: 128,
	      os: 82,
	      r: 26,
	      cx: 32,
	      cy: 32,
	      f: NONE
	    }]
	  },

	  ios: IOS_SPINNER,

	  'ios-small': IOS_SPINNER,

	  bubbles: {
	    sw: 0,
	    c: [{
	      fn: function fn(i) {
	        return {
	          cx: 24 * Math.cos(2 * Math.PI * i / 8),
	          cy: 24 * Math.sin(2 * Math.PI * i / 8),
	          t: TRANSLATE32,
	          a: [{
	            fn: function fn() {
	              return {
	                an: 'r',
	                dur: DURATION,
	                v: animationValues('1;2;3;4;5;6;7;8', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }]
	        };
	      },

	      t: 8
	    }]
	  },

	  circles: {

	    c: [{
	      fn: function fn(i) {
	        return {
	          r: 5,
	          cx: 24 * Math.cos(2 * Math.PI * i / 8),
	          cy: 24 * Math.sin(2 * Math.PI * i / 8),
	          t: TRANSLATE32,
	          sw: 0,
	          a: [{
	            fn: function fn() {
	              return {
	                an: 'fill-opacity',
	                dur: DURATION,
	                v: animationValues('.3;.3;.3;.4;.7;.85;.9;1', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }]
	        };
	      },

	      t: 8
	    }]
	  },

	  crescent: {
	    c: [{
	      sw: 4,
	      da: 128,
	      os: 82,
	      r: 26,
	      cx: 32,
	      cy: 32,
	      f: NONE,
	      at: [SPIN_ANIMATION]
	    }]
	  },

	  dots: {

	    c: [{
	      fn: function fn(i) {
	        return {
	          cx: 16 + 16 * i,
	          cy: 32,
	          sw: 0,
	          a: [{
	            fn: function fn() {
	              return {
	                an: 'fill-opacity',
	                dur: DURATION,
	                v: animationValues('.5;.6;.8;1;.8;.6;.5', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }, {
	            fn: function fn() {
	              return {
	                an: 'r',
	                dur: DURATION,
	                v: animationValues('4;5;6;5;4;3;3', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }]
	        };
	      },

	      t: 3
	    }]
	  },

	  lines: {
	    sw: 7,
	    lc: ROUND,
	    line: [{
	      fn: function fn(i) {
	        return {
	          x1: 10 + i * 14,
	          x2: 10 + i * 14,
	          a: [{
	            fn: function fn() {
	              return {
	                an: 'y1',
	                dur: DURATION,
	                v: animationValues('16;18;28;18;16', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }, {
	            fn: function fn() {
	              return {
	                an: 'y2',
	                dur: DURATION,
	                v: animationValues('48;44;36;46;48', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }, {
	            fn: function fn() {
	              return {
	                an: STROKE_OPACITY,
	                dur: DURATION,
	                v: animationValues('1;.8;.5;.4;1', i),
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }]
	        };
	      },

	      t: 4
	    }]
	  },

	  ripple: {
	    f: NONE,
	    'fill-rule': 'evenodd',
	    sw: 3,
	    circle: [{
	      fn: function fn(i) {
	        return {
	          cx: 32,
	          cy: 32,
	          a: [{
	            fn: function fn() {
	              return {
	                an: 'r',
	                begin: i * -1 + 's',
	                dur: '2s',
	                v: '0;24',
	                keyTimes: '0;1',
	                keySplines: '0.1,0.2,0.3,1',
	                calcMode: 'spline',
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }, {
	            fn: function fn() {
	              return {
	                an: STROKE_OPACITY,
	                begin: i * -1 + 's',
	                dur: '2s',
	                v: '.2;1;.2;0',
	                rc: INDEFINITE
	              };
	            },

	            t: 1
	          }]
	        };
	      },

	      t: 2
	    }]
	  },

	  spiral: {
	    defs: [{
	      linearGradient: [{
	        id: 'sGD',
	        gradientUnits: 'userSpaceOnUse',
	        x1: 55,
	        y1: 46,
	        x2: 2,
	        y2: 46,
	        stop: [{
	          offset: 0.1,
	          class: 'stop1'
	        }, {
	          offset: 1,
	          class: 'stop2'
	        }]
	      }]
	    }],
	    g: [{
	      sw: 4,
	      lc: ROUND,
	      f: NONE,
	      path: [{
	        stroke: 'url(#sGD)',
	        d: 'M4,32 c0,15,12,28,28,28c8,0,16-4,21-9'
	      }, {
	        d: 'M60,32 C60,16,47.464,4,32,4S4,16,4,32'
	      }],
	      at: [SPIN_ANIMATION]
	    }]
	  }

	};

	var animations = {
	  android: function android(ele) {
	    var self = this;

	    this.stop = false;

	    var rIndex = 0;
	    var rotateCircle = 0;
	    var startTime;
	    var svgEle = ele.querySelector('g');
	    var circleEle = ele.querySelector('circle');

	    function run() {
	      if (isServer) return;
	      if (self.stop) return;

	      var v = easeInOutCubic(Date.now() - startTime, 650);
	      var scaleX = 1;
	      var translateX = 0;
	      var dasharray = 188 - 58 * v;
	      var dashoffset = 182 - 182 * v;

	      if (rIndex % 2) {
	        scaleX = -1;
	        translateX = -64;
	        dasharray = 128 - -58 * v;
	        dashoffset = 182 * v;
	      }

	      var rotateLine = [0, -101, -90, -11, -180, 79, -270, -191][rIndex];

	      setSvgAttribute(circleEle, 'da', Math.max(Math.min(dasharray, 188), 128));
	      setSvgAttribute(circleEle, 'os', Math.max(Math.min(dashoffset, 182), 0));
	      setSvgAttribute(circleEle, 't', 'scale(' + scaleX + ',1) translate(' + translateX + ',0) rotate(' + rotateLine + ',32,32)');

	      rotateCircle += 4.1;
	      if (rotateCircle > 359) rotateCircle = 0;
	      setSvgAttribute(svgEle, 't', 'rotate(' + rotateCircle + ',32,32)');

	      if (v >= 1) {
	        rIndex++;
	        if (rIndex > 7) rIndex = 0;
	        startTime = Date.now();
	      }

	      window.requestAnimationFrame(run);
	    }

	    return function () {
	      startTime = Date.now();
	      run();
	      return self;
	    };
	  }
	};

	function easeInOutCubic(t, c) {
	  t /= c / 2;
	  if (t < 1) return 1 / 2 * t * t * t;
	  t -= 2;
	  return 1 / 2 * (t * t * t + 2);
	}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';

	var isServer = typeof window === 'undefined';
	if (!isServer) {
	  var lastTime = 0;
	  var vendors = ['webkit', 'moz'];
	  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }

	  if (!window.requestAnimationFrame) {
	    window.requestAnimationFrame = function (callback, element) {
	      var currTime = new Date().getTime();
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	      var id = window.setTimeout(function () {
	        callback(currTime + timeToCall);
	      }, timeToCall);
	      lastTime = currTime + timeToCall;
	      return id;
	    };
	  }
	  if (!window.cancelAnimationFrame) {
	    window.cancelAnimationFrame = function (id) {
	      clearTimeout(id);
	    };
	  }
	}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "vux-spinner",
	    class: _vm.className
	  })
	},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _calendar = __webpack_require__(313);

	var _calendar2 = _interopRequireDefault(_calendar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_calendar2.default.install = function (Vue) {
	  Vue.component('LxCalendar', _calendar2.default);
	};

	exports.default = _calendar2.default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(314),
	  /* template */
	  __webpack_require__(323),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inlineCalendar = __webpack_require__(315);

	var _inlineCalendar2 = _interopRequireDefault(_inlineCalendar);

	var _popup = __webpack_require__(235);

	var _popup2 = _interopRequireDefault(_popup);

	var _cell = __webpack_require__(118);

	var _cell2 = _interopRequireDefault(_cell);

	var _props = __webpack_require__(321);

	var _props2 = _interopRequireDefault(_props);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Props = (0, _props2.default)();
	Props.title = {
	  type: String,
	  required: true
	};

	exports.default = {
	  components: {
	    InlineCalendar: _inlineCalendar2.default,
	    Popup: _popup2.default,
	    Cell: _cell2.default
	  },
	  props: Props,
	  methods: {
	    onClick: function onClick() {
	      console.log(this.show);
	      this.show = true;
	    },
	    onSelect: function onSelect() {
	      this.show = false;
	    }
	  },
	  data: function data() {
	    return {
	      show: false,
	      currentValue: ''
	    };
	  },
	  created: function created() {
	    this.currentValue = this.value;
	  },

	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    }
	  }
	};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inlineCalendar = __webpack_require__(316);

	var _inlineCalendar2 = _interopRequireDefault(_inlineCalendar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_inlineCalendar2.default.install = function (Vue) {
	  Vue.component('LxInlineCalendar', _inlineCalendar2.default);
	};

	exports.default = _inlineCalendar2.default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(317)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(319),
	  /* template */
	  __webpack_require__(322),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-91fbb6bc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./inline-calendar.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-91fbb6bc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./inline-calendar.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-prev-icon,\n.vux-next-icon {\n  position: absolute;\n  left: 0;\n  top: 0.4rem;\n  display: inline-block;\n  width: 0.32rem;\n  height: 0.32rem;\n  border: 1px solid #5890ff;\n  border-radius: 0;\n  border-top: none;\n  border-right: none;\n  transform: rotate(45deg);\n  margin-left: 0.4rem;\n  line-height: 1.06666667rem;\n}\n.vux-next-icon {\n  transform: rotate(-135deg);\n  left: auto;\n  top: 0.37333333rem;\n  right: 0.4rem;\n}\n.vux-prev-icon:before {\n  display: block;\n  width: 0.32rem;\n  height: 0.32rem;\n  border: 1px solid #04be02;\n  border-width: 1px 0 0 1px;\n  transform: rotate(315deg);\n}\n.is-weekend-highlight td.is-week-list-0,\n.is-weekend-highlight td.is-week-list-6,\n.is-weekend-highlight td.is-week-0,\n.is-weekend-highlight td.is-week-6 {\n  color: #E59313;\n}\n.inline-calendar a {\n  text-decoration: none;\n  tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.calendar-year,\n.calendar-month {\n  position: relative;\n}\n.calendar-header {\n  line-height: 1.06666667rem;\n  font-size: 0.42666667rem;\n  overflow: hidden;\n}\n.calendar-header > div {\n  float: left;\n  width: 50%;\n  text-align: center;\n  overflow: hidden;\n}\n.calendar-header a:last-of-type {\n  float: right;\n  vertical-align: bottom;\n}\n.switch-btn,\n.calendar-title {\n  display: inline-block;\n  border-radius: 4px;\n  line-height: 0.8rem;\n}\n.switch-btn {\n  width: 0.8rem;\n  margin: 0.13333333rem;\n  color: #39b5b8;\n  font-family: \"SimSun\";\n}\n.calendar-title {\n  padding: 0 6%;\n  color: #333;\n}\n.switch-btn:active,\n.calendar-title:active,\n.calendar-header a.active {\n  background-color: #39b5b8;\n  color: #fff;\n}\n.calendar-week {\n  overflow: hidden;\n}\n.calendar-week span {\n  float: left;\n  width: 14.28%;\n  font-size: 0.53333333rem;\n  line-height: 0.90666667rem;\n  text-align: center;\n}\n.inline-calendar {\n  width: 100%;\n  background: #fff;\n  border-radius: 2px;\n  transition: all .5s ease;\n}\n.inline-calendar td.is-today,\n.inline-calendar td.is-today.is-disabled {\n  color: #5890ff;\n}\n.calendar-enter,\n.calendar-leave {\n  opacity: 0;\n  transform: translate3d(0, -10px, 0);\n}\n.calendar:before {\n  position: absolute;\n  left: 0.8rem;\n  top: -0.26666667rem;\n  content: \"\";\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-bottom-color: #DEDEDE;\n}\n.calendar:after {\n  position: absolute;\n  left: 0.8rem;\n  top: -0.24rem;\n  content: \"\";\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-bottom-color: #fff;\n}\n.calendar-tools {\n  height: 0.85333333rem;\n  font-size: 0.53333333rem;\n  line-height: 0.85333333rem;\n  color: #04be02;\n}\n.calendar-tools .float.left {\n  float: left;\n}\n.calendar-tools .float.right {\n  float: right;\n}\n.calendar-tools input {\n  font-size: 0.53333333rem;\n  line-height: 0.85333333rem;\n  color: #04be02;\n  width: 1.86666667rem;\n  text-align: center;\n  border: none;\n  background-color: transparent;\n}\n.calendar-tools > i {\n  margin: 0 0.42666667rem;\n  line-height: 0.85333333rem;\n  cursor: pointer;\n  color: #707070;\n}\n.calendar-tools > i:hover {\n  color: #5e7a88;\n}\n.inline-calendar table {\n  clear: both;\n  width: 100%;\n  border-collapse: collapse;\n  color: #444444;\n}\n.inline-calendar td {\n  padding: 0.13333333rem 0;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 0.4rem;\n  position: relative;\n}\n.inline-calendar td.week {\n  pointer-events: none !important;\n  cursor: default !important;\n}\n.inline-calendar td.is-disabled {\n  color: #c0c0c0;\n  pointer-events: none !important;\n  cursor: default !important;\n}\n.inline-calendar td > span {\n  display: inline-block;\n  width: 0.69333333rem;\n  height: 0.69333333rem;\n  line-height: 0.69333333rem;\n  border-radius: 50%;\n  text-align: center;\n}\n.vux-calendar-range.inline-calendar td.current {\n  background-color: #04be02;\n}\n.vux-calendar-range table {\n  margin-bottom: 0.26666667rem;\n}\n.inline-calendar td.current > span {\n  background-color: #5890ff;\n  color: #fff;\n}\n.inline-calendar .timer {\n  margin: 0.26666667rem 0;\n  text-align: center;\n}\n.inline-calendar .timer input {\n  border-radius: 2px;\n  padding: 0.13333333rem;\n  font-size: 0.37333333rem;\n  line-height: 0.48rem;\n  color: #5e7a88;\n  width: 1.33333333rem;\n  text-align: center;\n  border: 1px solid #efefef;\n}\n.inline-calendar .timer input:focus {\n  border: 1px solid #5e7a88;\n}\n.calendar-button {\n  text-align: center;\n}\n.calendar-button button {\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  min-height: 1em;\n  min-width: 8em;\n  vertical-align: baseline;\n  background: #5e7a88;\n  color: #fff;\n  margin: 0 .25em 0 0;\n  padding: .8em 2.5em;\n  font-size: 1em;\n  line-height: 1em;\n  text-align: center;\n  border-radius: .3em;\n}\n.calendar-button button.cancel {\n  background: #efefef;\n  color: #666;\n}\n", ""]);

	// exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _format = __webpack_require__(232);

	var _format2 = _interopRequireDefault(_format);

	var _util = __webpack_require__(320);

	var _props = __webpack_require__(321);

	var _props2 = _interopRequireDefault(_props);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: (0, _props2.default)(),
	  data: function data() {
	    return {
	      year: 0,
	      month: 0,
	      days: [],
	      current: [],
	      today: (0, _format2.default)(new Date(), 'YYYY-MM-DD'),
	      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
	      currentValue: ''
	    };
	  },
	  created: function created() {
	    this.currentValue = this.value;
	  },
	  mounted: function mounted() {
	    this.currentValue = this.convertDate(this.currentValue);
	    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
	  },

	  computed: {
	    _replaceTextList: function _replaceTextList() {
	      var rs = {};
	      for (var i in this.replaceTextList) {
	        rs[this.convertDate(i)] = this.replaceTextList[i];
	      }
	      return rs;
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(val) {
	      this.currentValue = this.convertDate(val);
	      if (this.renderOnValueChange) {
	        this.render(null, null, val);
	      } else {
	        this.render(this.year, this.month, this.currentValue);
	      }
	      this.$emit('on-change', val);
	      this.$emit('input', val);
	    },
	    returnSixRows: function returnSixRows(val) {
	      this.render(this.year, this.month, this.currentValue);
	    },
	    disablePast: function disablePast() {
	      this.render(this.year, this.month, this.currentValue);
	    },
	    disableFuture: function disableFuture() {
	      this.render(this.year, this.month, this.currentValue);
	    }
	  },
	  methods: {
	    replaceText: function replaceText(day, formatDay) {
	      return this._replaceTextList[formatDay] || day;
	    },
	    convertDate: function convertDate(date) {
	      return date === 'TODAY' ? this.today : date;
	    },
	    buildClass: function buildClass(index, child, isCurrent) {
	      var className = {
	        current: child.current || isCurrent,
	        'is-disabled': child.disabled,
	        'is-today': child.isToday
	      };
	      className['is-week-' + index] = true;
	      return className;
	    },
	    render: function render(year, month) {
	      var data = (0, _util.getDays)({
	        year: year,
	        month: month,
	        value: this.currentValue,
	        rangeBegin: this.convertDate(this.startDate),
	        rangeEnd: this.convertDate(this.endDate),
	        returnSixRows: this.returnSixRows,
	        disablePast: this.disablePast,
	        disableFuture: this.disableFuture
	      });
	      this.days = data.days;
	      this.year = data.year;
	      this.month = data.month;
	    },

	    formatDate: function formatDate(year, month, child) {
	      return [year, (0, _util.zero)(child.month + 1), (0, _util.zero)(child.day)].join('-');
	    },
	    prev: function prev() {
	      if (this.month === 0) {
	        this.month = 11;
	        this.year = this.year - 1;
	      } else {
	        this.month = this.month - 1;
	      }
	      this.render(this.year, this.month);
	    },
	    next: function next() {
	      if (this.month === 11) {
	        this.month = 0;
	        this.year = this.year + 1;
	      } else {
	        this.month = this.month + 1;
	      }
	      this.render(this.year, this.month);
	    },
	    go: function go(year, month) {
	      this.render(year, month);
	    },
	    select: function select(k1, k2) {
	      if (this.current.length > 0) {
	        this.days[this.current[0]][this.current[1]].isCurrent = false;
	      }
	      this.days[k1][k2].current = true;
	      this.current = [k1, k2];
	      this.currentValue = [this.year, (0, _util.zero)(this.month + 1), (0, _util.zero)(this.days[k1][k2].day)].join('-');
	    }
	  }
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.zero = zero;
	exports.splitValue = splitValue;
	exports.getPrevTime = getPrevTime;
	exports.getNextTime = getNextTime;
	exports.getDays = getDays;

	var _format2 = __webpack_require__(232);

	var _format3 = _interopRequireDefault(_format2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function zero(n) {
	  return n < 10 ? '0' + n : n;
	}

	function splitValue(value) {
	  var split = value.split('-');
	  return {
	    year: parseInt(split[0], 10),
	    month: parseInt(split[1], 10) - 1,
	    day: parseInt(split[2], 10)
	  };
	}

	function getPrevTime(year, month) {
	  if (month === 0) {
	    return {
	      month: 11,
	      year: year - 1
	    };
	  } else {
	    return {
	      year: year,
	      month: month - 1
	    };
	  }
	}

	function getNextTime(year, month) {
	  if (month === 11) {
	    return {
	      month: 0,
	      year: year + 1
	    };
	  } else {
	    return {
	      year: year,
	      month: month + 1
	    };
	  }
	}

	function getTime(str) {
	  if (typeof str === 'number') {
	    return str;
	  }
	  return typeof str === 'string' ? new Date(str.replace(/-/g, '/')).getTime() : str.getTime();
	}

	function isBetween(value, start, end) {
	  value = getTime(value);
	  var isGte = start ? value >= getTime(start) : true;
	  var isLte = end ? value <= getTime(end) : true;
	  return isGte && isLte;
	}

	function getDays(_ref) {
	  var year = _ref.year,
	      month = _ref.month,
	      value = _ref.value,
	      _ref$isRange = _ref.isRange,
	      isRange = _ref$isRange === undefined ? false : _ref$isRange,
	      rangeBegin = _ref.rangeBegin,
	      rangeEnd = _ref.rangeEnd,
	      _ref$returnSixRows = _ref.returnSixRows,
	      returnSixRows = _ref$returnSixRows === undefined ? true : _ref$returnSixRows,
	      _ref$disablePast = _ref.disablePast,
	      disablePast = _ref$disablePast === undefined ? false : _ref$disablePast,
	      _ref$disableFuture = _ref.disableFuture,
	      disableFuture = _ref$disableFuture === undefined ? false : _ref$disableFuture;

	  var today = (0, _format3.default)(new Date(), 'YYYY-MM-DD');
	  var startOfToday = new Date();
	  startOfToday.setHours(0, 0, 0, 0);

	  var _splitValue = splitValue(value || today);

	  if (typeof year !== 'number' || typeof month !== 'number' || month < 0) {
	    year = _splitValue.year;
	    month = _splitValue.month;
	  }

	  if (disablePast) {
	    if (!rangeBegin) {
	      rangeBegin = startOfToday;
	    } else {
	      rangeBegin = Math.max(startOfToday.getTime(), getTime(rangeBegin));
	    }
	  }

	  if (disableFuture) {
	    if (!rangeEnd) {
	      rangeEnd = startOfToday;
	    } else {
	      rangeEnd = Math.min(startOfToday.getTime(), getTime(rangeEnd));
	    }
	  }

	  var firstDayOfMonth = new Date(year, month, 1).getDay();
	  var lastDateOfMonth = new Date(year, month + 1, 0).getDate();
	  var lastDayOfLastMonth = new Date(year, month, 0).getDate();

	  var i;
	  var line = 0;
	  var temp = [];
	  for (i = 1; i <= lastDateOfMonth; i++) {
	    var dow = new Date(year, month, i).getDay();

	    if (dow === 0) {
	      temp[line] = [];
	    } else if (i === 1) {
	      temp[line] = [];

	      var k = lastDayOfLastMonth - firstDayOfMonth + 1;
	      for (var j = 0; j < firstDayOfMonth; j++) {
	        var rs = getPrevTime(year, month);
	        temp[line].push({
	          year: rs.year,
	          month: rs.month,
	          month_str: rs.month + 1,
	          day: k,
	          disabled: true,
	          isLastMonth: true
	        });
	        k++;
	      }
	    }

	    var _format = (0, _format3.default)(new Date(year + '/' + (month + 1) + '/' + i), 'YYYY/MM/DD');
	    var options = {
	      year: year,
	      month: month,
	      month_str: month + 1,
	      day: i,
	      isCurrent: value && (0, _format3.default)(new Date(value), 'YYYY/MM/DD') === _format,
	      disabled: !isBetween(_format, rangeBegin, rangeEnd),
	      isToday: (0, _format3.default)(new Date(), 'YYYY/MM/DD') === _format
	    };
	    temp[line].push(options);

	    if (dow === 6) {
	      line++;
	    } else if (i === lastDateOfMonth) {
	      var _k = 1;
	      for (dow; dow < 6; dow++) {
	        var _rs = getNextTime(year, month);
	        temp[line].push({
	          year: _rs.year,
	          month: _rs.month,
	          month_str: _rs.month + 1,
	          day: _k,
	          disabled: true,
	          isNextMonth: true
	        });
	        _k++;
	      }
	    }
	  }

	  if (returnSixRows && temp.length === 5) {
	    var _rs2 = getNextTime(year, month);
	    var start = temp[4][6].isNextMonth ? temp[4][6].day : 0;
	    temp[6] = [];
	    for (var _i = 0; _i < 7; _i++) {
	      temp[6].push({
	        year: _rs2.year,
	        month: _rs2.month,
	        month_str: _rs2.month + 1,
	        day: ++start,
	        disabled: true,
	        isNextMonth: true
	      });
	    }
	  }

	  if (returnSixRows && temp.length === 4) {
	    var _rs3 = getNextTime(year, month);
	    var _start = 0;
	    temp[5] = [];
	    temp[6] = [];
	    for (var _i2 = 0; _i2 < 7; _i2++) {
	      temp[5].push({
	        year: _rs3.year,
	        month: _rs3.month,
	        month_str: _rs3.month + 1,
	        day: ++_start,
	        disabled: true,
	        isNextMonth: true
	      });
	      temp[6].push({
	        year: _rs3.year,
	        month: _rs3.month,
	        month_str: _rs3.month + 1,
	        day: ++_start,
	        disabled: true,
	        isNextMonth: true
	      });
	    }
	  }

	  return {
	    year: year,
	    month: month,
	    month_str: month + 1,
	    days: temp
	  };
	}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function () {
	  return {
	    value: {
	      type: String,
	      default: ''
	    },
	    renderMonth: {
	      type: Array, default: function _default() {
	        return [null, null];
	      }
	    },
	    startDate: {
	      type: String
	    },
	    endDate: {
	      type: String
	    },
	    showLastMonth: {
	      type: Boolean,
	      default: true
	    },
	    showNextMonth: {
	      type: Boolean,
	      default: true
	    },
	    highlightWeekend: {
	      type: Boolean,
	      default: false
	    },
	    returnSixRows: {
	      type: Boolean,
	      default: true
	    },
	    hideHeader: {
	      type: Boolean,
	      default: false
	    },
	    hideWeekList: {
	      type: Boolean,
	      default: false
	    },
	    replaceTextList: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    weeksList: {
	      type: Array,
	      default: function _default() {
	        return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	      }
	    },
	    customSlotFn: {
	      type: Function,
	      default: function _default() {
	        return '';
	      }
	    },
	    renderOnValueChange: {
	      type: Boolean,
	      default: true
	    },
	    disablePast: {
	      type: Boolean,
	      default: false
	    },
	    disableFuture: {
	      type: Boolean,
	      default: false
	    }
	  };
	};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inline-calendar",
	    class: {
	      'is-weekend-highlight': _vm.highlightWeekend
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.hideHeader),
	      expression: "!hideHeader"
	    }],
	    staticClass: "calendar-header"
	  }, [_c('div', {
	    staticClass: "calendar-year"
	  }, [_c('a', {
	    staticClass: "year-prev vux-prev-icon",
	    attrs: {
	      "href": "javascript:"
	    },
	    on: {
	      "click": function($event) {
	        _vm.go(_vm.year - 1, _vm.month)
	      }
	    }
	  }), _c('a', {
	    staticClass: "calendar-year-txt calendar-title",
	    attrs: {
	      "href": "javascript:"
	    }
	  }, [_vm._v(_vm._s(_vm.year))]), _c('a', {
	    staticClass: "year-next vux-next-icon",
	    attrs: {
	      "href": "javascript:"
	    },
	    on: {
	      "click": function($event) {
	        _vm.go(_vm.year + 1, _vm.month)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "calendar-month"
	  }, [_c('a', {
	    staticClass: "month-prev vux-prev-icon",
	    attrs: {
	      "href": "javascript:"
	    },
	    on: {
	      "click": _vm.prev
	    }
	  }), _c('a', {
	    staticClass: "calendar-month-txt calendar-title",
	    attrs: {
	      "href": "javascript:"
	    }
	  }, [_vm._v(_vm._s(_vm.months[_vm.month]))]), _c('a', {
	    staticClass: "month-next vux-next-icon",
	    attrs: {
	      "href": "javascript:"
	    },
	    on: {
	      "click": _vm.next
	    }
	  })])]), _c('table', [_c('thead', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.hideWeekList),
	      expression: "!hideWeekList"
	    }]
	  }, [_c('tr', _vm._l((_vm.weeksList), function(week, index) {
	    return _c('th', {
	      staticClass: "`week is-week-list-${index}`"
	    }, [_vm._v(_vm._s(week))])
	  }))]), _c('tbody', _vm._l((_vm.days), function(day, k1) {
	    return _c('tr', _vm._l((day), function(child, k2) {
	      return _c('td', {
	        class: _vm.buildClass(k2, child, _vm.formatDate(_vm.year, _vm.month, child) === _vm.currentValue && !child.isLastMonth && !child.isNextMonth),
	        attrs: {
	          "data-date": _vm.formatDate(_vm.year, _vm.month, child),
	          "data-current": _vm.currentValue
	        },
	        on: {
	          "click": function($event) {
	            _vm.select(k1, k2, $event)
	          }
	        }
	      }, [_c('span', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: ((!child.isLastMonth && !child.isNextMonth) || (child.isLastMonth && _vm.showLastMonth) || (child.isNextMonth && _vm.showNextMonth)),
	          expression: "(!child.isLastMonth && !child.isNextMonth ) || (child.isLastMonth && showLastMonth) || (child.isNextMonth && showNextMonth)"
	        }]
	      }, [_vm._v(_vm._s(_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child))))]), _vm._v("\n          " + _vm._s(_vm.customSlotFn(k1, k2, child)) + "\n        ")])
	    }))
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('cell', {
	    attrs: {
	      "title": _vm.title,
	      "primary": "content",
	      "is-link": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.onClick($event)
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.currentValue) + "\n  ")]), _c('popup', {
	    model: {
	      value: (_vm.show),
	      callback: function($$v) {
	        _vm.show = $$v
	      },
	      expression: "show"
	    }
	  }, [_c('inline-calendar', {
	    attrs: {
	      "render-month": _vm.renderMonth,
	      "start-date": _vm.startDate,
	      "end-date": _vm.endDate,
	      "show-last-month": _vm.showLastMonth,
	      "show-next-month": _vm.showNextMonth,
	      "highlight-weekend": _vm.highlightWeekend,
	      "return-six-rows": _vm.returnSixRows,
	      "hide-header": _vm.hideHeader,
	      "hide-week-list": _vm.hideWeekList,
	      "replace-text-list": _vm.replaceTextList,
	      "weeks-list": _vm.weeksList,
	      "custom-slot-fn": _vm.customSlotFn,
	      "render-on-value-change": _vm.renderOnValueChange,
	      "disable-past": _vm.disablePast,
	      "disable-future": _vm.disableFuture
	    },
	    on: {
	      "on-change": _vm.onSelect
	    },
	    model: {
	      value: (_vm.currentValue),
	      callback: function($$v) {
	        _vm.currentValue = $$v
	      },
	      expression: "currentValue"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _colorPicker = __webpack_require__(325);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_colorPicker2.default.install = function (Vue) {
	  Vue.component('LxColorPicker', _colorPicker2.default);
	};

	exports.default = _colorPicker2.default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(326)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(328),
	  /* template */
	  __webpack_require__(329),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(327);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2cc1cf88!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./color-picker.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2cc1cf88!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./color-picker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n@font-face {\n  font-weight: normal;\n  font-style: normal;\n  font-family: \"weui\";\n  src: url('data:application/octet-stream;base64,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') format('truetype');\n}\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  font-family: \"weui\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: inherit;\n  width: 1em;\n  margin-right: 0.56rem;\n  text-align: center;\n  /* opacity: .8; */\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1;\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  margin-left: .2rem;\n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n.weui_icon_circle:before {\n  content: \"\\EA01\";\n}\n/* '' */\n.weui_icon_download:before {\n  content: \"\\EA02\";\n}\n/* '' */\n.weui_icon_info:before {\n  content: \"\\EA03\";\n}\n/* '' */\n.weui_icon_safe_success:before {\n  content: \"\\EA04\";\n}\n/* '' */\n.weui_icon_safe_warn:before {\n  content: \"\\EA05\";\n}\n/* '' */\n.weui_icon_success:before {\n  content: \"\\EA06\";\n}\n/* '' */\n.weui_icon_success_circle:before {\n  content: \"\\EA07\";\n}\n/* '' */\n.weui_icon_success_no_circle:before {\n  content: \"\\EA08\";\n}\n/* '' */\n.weui_icon_waiting:before {\n  content: \"\\EA09\";\n}\n/* '' */\n.weui_icon_waiting_circle:before {\n  content: \"\\EA0A\";\n}\n/* '' */\n.weui_icon_warn:before {\n  content: \"\\EA0B\";\n}\n/* '' */\n.weui_icon_info_circle:before {\n  content: \"\\EA0C\";\n}\n/* '' */\n.weui_icon_cancel:before {\n  content: \"\\EA0D\";\n}\n/* '' */\n.weui_icon_search:before {\n  content: \"\\EA0E\";\n}\n/* '' */\n.weui_icon_clear:before {\n  content: \"\\EA0F\";\n}\n/* '' */\n[class^=\"weui_icon_\"]:before,\n[class*=\" weui_icon_\"]:before {\n  margin: 0;\n}\n.weui_icon_success:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_waiting:before {\n  font-size: 0.61333333rem;\n  color: #10AEFF;\n}\n.weui_icon_warn:before {\n  font-size: 0.61333333rem;\n  color: #F43530;\n}\n.weui_icon_info:before {\n  font-size: 0.61333333rem;\n  color: #10AEFF;\n}\n.weui_icon_success_circle:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_success_no_circle:before {\n  font-size: 0.61333333rem;\n  color: #09BB07;\n}\n.weui_icon_waiting_circle:before {\n  font-size: 0.48rem;\n  color: #10AEFF;\n}\n.weui_icon_circle:before {\n  font-size: 0.48rem;\n  color: #C9C9C9;\n}\n.weui_icon_download:before {\n  font-size: 0.48rem;\n  color: #09BB07;\n}\n.weui_icon_info_circle:before {\n  font-size: 0.48rem;\n  color: #09BB07;\n}\n.weui_icon_safe_success:before {\n  color: #09BB07;\n}\n.weui_icon_safe_warn:before {\n  color: #FFBE00;\n}\n.weui_icon_cancel:before {\n  color: #F43530;\n  font-size: 0.58666667rem;\n}\n.weui_icon_search:before {\n  color: #B2B2B2;\n  font-size: 0.37333333rem;\n}\n.weui_icon_clear:before {\n  color: #B2B2B2;\n  font-size: 0.37333333rem;\n}\n.weui_icon_msg:before {\n  font-size: 2.77333333rem;\n}\n.weui_icon_warn.weui_icon_msg:before {\n  color: #F76260;\n}\n.weui_icon_safe:before {\n  font-size: 2.77333333rem;\n}\n.vux-color-box {\n  text-align: center;\n}\n.vux-color-picker {\n  font-size: 0;\n}\n.vux-color-item {\n  display: inline-block;\n  text-align: center;\n  box-sizing: border-box;\n  position: relative;\n}\n.vux-color-checked.weui_icon_success_no_circle:before {\n  color: #fff;\n}\n.vux-color-checked {\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.vux-color-white {\n  border: 1px solid #ccc;\n}\n.vux-color-white .vux-color-checked:before {\n  color: #ccc;\n}\n.vux-color-picker-small .vux-color-checked:before {\n  font-size: 10px;\n}\n.vux-color-picker-middle .vux-color-checked:before {\n  font-size: 18px;\n}\n", ""]);

	// exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _icon = __webpack_require__(96);

	var _icon2 = _interopRequireDefault(_icon);

	var _flexbox = __webpack_require__(210);

	var _flexbox2 = _interopRequireDefault(_flexbox);

	var _flexboxItem = __webpack_require__(216);

	var _flexboxItem2 = _interopRequireDefault(_flexboxItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var sizeMap = {
	  'large': 40,
	  'middle': 30,
	  'small': 20
	};
	exports.default = {
	  components: {
	    Icon: _icon2.default,
	    Flexbox: _flexbox2.default,
	    FlexboxItem: _flexboxItem2.default
	  },
	  props: {
	    colors: {
	      type: Array,
	      required: true
	    },
	    size: {
	      type: String,
	      default: 'large'
	    },
	    value: String,
	    enableNull: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      color: ''
	    };
	  },

	  computed: {
	    width: function width() {
	      return sizeMap[this.size];
	    }
	  },
	  methods: {
	    change: function change(color) {
	      if (this.color === color && this.enableNull) {
	        color = '';
	      }
	      this.color = color;
	    }
	  },
	  watch: {
	    color: function color(val) {
	      this.$emit('input', val);
	      this.$emit('on-change', val);
	    },
	    value: function value(val) {
	      this.color = val;
	    }
	  }
	};

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-color-picker"
	  }, [_c('flexbox', _vm._l((_vm.colors), function(color) {
	    return _c('flexbox-item', {
	      key: color,
	      staticClass: "vux-color-box"
	    }, [_c('span', {
	      staticClass: "vux-color-item",
	      class: {
	        'vux-color-white': color === '#fff' || color === '#fff', 'vux-color-picker-small': _vm.size === 'small', 'vux-color-picker-middle': _vm.size === 'middle'
	      },
	      style: ({
	        borderRadius: _vm.width / 2 + 'px',
	        backgroundColor: color,
	        width: _vm.width + 'px',
	        height: _vm.width + 'px'
	      }),
	      on: {
	        "click": function($event) {
	          _vm.change(color)
	        }
	      }
	    }, [(color === _vm.value) ? _c('icon', {
	      staticClass: "vux-color-checked",
	      style: ({
	        lineHeight: _vm.width + 'px'
	      }),
	      attrs: {
	        "type": "success_no_circle"
	      }
	    }) : _vm._e()], 1)])
	  }))], 1)
	},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _divider = __webpack_require__(331);

	var _divider2 = _interopRequireDefault(_divider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_divider2.default.install = function (Vue) {
	  Vue.component('LxDivider', _divider2.default);
	};

	exports.default = _divider2.default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(332)

	var Component = __webpack_require__(79)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(334),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(333);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-00fc89f0!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./divider.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-00fc89f0!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./divider.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-divider {\n  display: table;\n  white-space: nowrap;\n  height: auto;\n  overflow: hidden;\n  line-height: 1;\n  text-align: center;\n  padding: 0.26666667rem 0;\n  color: #666;\n}\n.vux-divider:after,\n.vux-divider:before {\n  content: '';\n  display: table-cell;\n  position: relative;\n  top: 50%;\n  width: 50%;\n  background-repeat: no-repeat;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC);\n}\n.vux-divider:before {\n  background-position: right 1em top 50%;\n}\n.vux-divider:after {\n  background-position: left 1em top 50%;\n}\n", ""]);

	// exports


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "vux-divider"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _countup = __webpack_require__(336);

	var _countup2 = _interopRequireDefault(_countup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_countup2.default.install = function (Vue) {
	  Vue.component('LxCountup', _countup2.default);
	};

	exports.default = _countup2.default;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(337),
	  /* template */
	  __webpack_require__(339),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _countup = __webpack_require__(338);

	var _countup2 = _interopRequireDefault(_countup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  mounted: function mounted() {
	    this.startVal = this.value;
	    this._countup = new _countup2.default(this.$el, this.startVal, this.endVal, this.decimals, this.duration, this.options);
	    this._countup.start();
	  },

	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    endVal: {
	      type: Number,
	      required: true
	    },

	    decimals: {
	      type: Number,
	      default: 0
	    },

	    duration: {
	      type: Number,
	      default: 2
	    },
	    options: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      startVal: 0
	    };
	  },

	  watch: {
	    value: function value(val) {
	      this.startVal = val;
	    },
	    starValue: function starValue(val) {
	      this.$emit('input', val);
	    },
	    endVal: function endVal(val) {
	      this._countup.update(val);
	    }
	  }
	};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = require("countup.js");

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v(_vm._s(_vm.startVal))])
	},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _scroller = __webpack_require__(341);

	var _scroller2 = _interopRequireDefault(_scroller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_scroller2.default.install = function (Vue) {
	  Vue.component('LxScroller', _scroller2.default);
	};

	exports.default = _scroller2.default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(342)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(344),
	  /* template */
	  __webpack_require__(348),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(343);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-70c3f2fc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./scroller.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-70c3f2fc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./scroller.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.xs-plugin-pullup-container {\r\n  text-align: center;\n}\r\n\r\n", ""]);

	// exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _stringify = __webpack_require__(130);

	var _stringify2 = _interopRequireDefault(_stringify);

	var _objectAssign = __webpack_require__(187);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _xscroll = __webpack_require__(345);

	var _xscroll2 = _interopRequireDefault(_xscroll);

	var _pulldown = __webpack_require__(346);

	var _pulldown2 = _interopRequireDefault(_pulldown);

	var _pullup = __webpack_require__(347);

	var _pullup2 = _interopRequireDefault(_pullup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var pulldownDefaultConfig = function pulldownDefaultConfig() {
	  return {
	    content: 'Pull Down To Refresh',
	    height: 60,
	    autoRefresh: false,
	    downContent: 'Pull Down To Refresh',
	    upContent: 'Release To Refresh',
	    loadingContent: 'Loading...',
	    clsPrefix: 'xs-plugin-pulldown-'
	  };
	};

	var pullupDefaultConfig = function pullupDefaultConfig() {
	  return {
	    content: 'Pull Up To Refresh',
	    pullUpHeight: 60,
	    height: 40,
	    autoRefresh: false,
	    downContent: 'Release To Refresh',
	    upContent: 'Pull Up To Refresh',
	    loadingContent: 'Loading...',
	    clsPrefix: 'xs-plugin-pullup-'
	  };
	};

	exports.default = {
	  props: {
	    value: {
	      type: Object,
	      default: function _default() {
	        return {
	          pulldownStatus: '',
	          pullupStatus: 'enabled'
	        };
	      }
	    },
	    height: String,
	    lockX: Boolean,
	    lockY: Boolean,
	    scrollbarX: Boolean,
	    scrollbarY: Boolean,
	    bounce: {
	      type: Boolean,
	      default: true
	    },
	    useOriginScroll: {
	      type: Boolean,
	      default: false
	    },
	    useTransition: {
	      type: Boolean,
	      default: true
	    },
	    preventDefault: {
	      type: Boolean,
	      default: true
	    },
	    stopPropagation: Boolean,
	    boundryCheck: {
	      type: Boolean,
	      default: true
	    },
	    gpuAcceleration: {
	      type: Boolean,
	      default: true
	    },
	    usePulldown: {
	      type: Boolean,
	      default: false
	    },
	    usePullup: {
	      type: Boolean,
	      default: false
	    },

	    pulldownConfig: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    pullupConfig: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    enableHorizontalSwiping: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    scrollTo: function scrollTo(scrollLeft, scrollTop, duration, easing, callback) {
	      if (this._xscroll) {
	        this._xscroll.scrollTo(scrollLeft, scrollTop, duration, easing, callback);
	      }
	    },
	    getScroll: function getScroll() {
	      return this._xscroll;
	    },
	    reset: function reset(scrollPosition) {
	      if (scrollPosition) {
	        if (typeof scrollPosition.left !== 'undefined') {
	          this._xscroll && this._xscroll.scrollLeft(scrollPosition.left);
	        }
	        if (typeof scrollPosition.top !== 'undefined') {
	          this._xscroll && this._xscroll.scrollTop(scrollPosition.top);
	        }
	      }
	      this._xscroll && this._xscroll.resetSize();
	    },
	    donePulldown: function donePulldown() {
	      var _this = this;

	      this.pulldown.reset(function () {
	        _this.reset();
	      });
	      this.currentValue.pulldownStatus = 'default';
	    },
	    disablePullup: function disablePullup() {
	      this.pullup.stop();
	      this.currentValue.pullupStatus = 'disabled';
	    },
	    enablePullup: function enablePullup() {
	      this.currentValue.pullupStatus = 'default';
	      this.pullup.restart();
	    },
	    donePullup: function donePullup(time) {
	      var _this2 = this;

	      if (time) {
	        this.timer = setTimeout(function () {
	          _this2.pullup.complete();
	          _this2.currentValue.pullupStatus = 'default';
	          _this2.reset();
	        }, time);
	      } else {
	        this.pullup.complete();
	        this.currentValue.pullupStatus = 'default';
	        this.reset();
	      }
	    }
	  },
	  computed: {
	    styles: function styles() {
	      var height = this.height;
	      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
	        height = document.documentElement.clientHeight + 'px';
	        this.reset();
	      }

	      if (this.height && this.height.indexOf('-') === 0) {
	        var clientHeight = document.documentElement.clientHeight;
	        var scale = clientHeight / 667;
	        var h1 = parseInt(this.height);
	        height = clientHeight + parseInt(h1 * scale) + 'px';
	      }
	      return {
	        height: '' + height
	      };
	    }
	  },
	  created: function created() {
	    var _this3 = this;

	    if (!this.value) {
	      this.currentValue = {
	        pulldownStatus: '',
	        pullupStatus: 'enabled'
	      };
	    } else {
	      this.currentValue = this.value;
	    }
	    this.handleOrientationchange = function () {
	      _this3.reset();
	    };
	  },
	  data: function data() {
	    return {
	      timer: null,
	      currentValue: {}
	    };
	  },

	  watch: {
	    currentValue: {
	      handler: function handler(val) {
	        this.$emit('input', pure(val));
	      },
	      deep: true
	    },
	    value: {
	      handler: function handler(val) {
	        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
	          this.donePullup();
	        }
	        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
	          this.donePulldown();
	        }
	        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
	          this.disablePullup();
	        }
	        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
	          this.enablePullup();
	        }
	      },
	      deep: true
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;

	    this.uuid = Math.random().toString(36).substring(3, 8);
	    this.$nextTick(function () {
	      _this4.$el.setAttribute('id', 'vux-scroller-' + _this4.uuid);
	      var content = null;
	      if (_this4.$slots.default) {
	        content = _this4.$slots.default[0].elm;
	      }
	      if (!content) {
	        throw new Error('no content is found');
	      }
	      _this4._xscroll = new _xscroll2.default({
	        renderTo: '#vux-scroller-' + _this4.uuid,
	        lockX: _this4.lockX,
	        lockY: _this4.lockY,
	        scrollbarX: _this4.scrollbarX,
	        scrollbarY: _this4.scrollbarY,
	        content: content,
	        bounce: _this4.bounce,
	        useOriginScroll: _this4.useOriginScroll,
	        useTransition: _this4.useTransition,
	        preventDefault: _this4.preventDefault,
	        boundryCheck: _this4.boundryCheck,
	        gpuAcceleration: _this4.gpuAcceleration,
	        stopPropagation: _this4.stopPropagation
	      });

	      if (_this4.usePulldown) {
	        var container = _this4.$slots.pulldown;
	        var config = (0, _objectAssign2.default)(pulldownDefaultConfig(), _this4.pulldownConfig);
	        if (container) {
	          config.container = container[0].elm;
	        }
	        _this4.pulldown = new _pulldown2.default(config);
	        _this4._xscroll.plug(_this4.pulldown);
	        _this4.pulldown.on('loading', function (e) {
	          _this4.$emit('on-pulldown-loading', _this4.uuid);
	        });
	        _this4.pulldown.on('statuschange', function (val) {
	          _this4.currentValue.pulldownStatus = val.newVal;
	        });
	      }

	      if (_this4.usePullup) {
	        var _container = _this4.$slots.pullup;
	        var _config = (0, _objectAssign2.default)(pullupDefaultConfig(), _this4.pullupConfig);

	        if (_container) {
	          _config.container = _container[0].elm;
	        }
	        _this4.pullup = new _pullup2.default(_config);
	        _this4._xscroll.plug(_this4.pullup);
	        _this4.pullup.on('loading', function (e) {
	          _this4.$emit('on-pullup-loading', _this4.donePullup, _this4.uuid);
	        });
	        _this4.pullup.on('statuschange', function (val) {
	          _this4.currentValue.pullupStatus = val.newVal;
	        });
	      }

	      if (_this4.enableHorizontalSwiping) {
	        _this4._xscroll.on('panstart', function (e) {
	          if (e.direction === 2 || e.direction === 4) {
	            e.preventDefault();
	            if (_this4.scrollbarY) {
	              _this4._xscroll.userConfig.scrollbarY = false;
	            }
	            _this4._xscroll.userConfig.lockY = true;
	          }
	        });
	        _this4._xscroll.on('panend', function () {
	          if (_this4.scrollbarY) {
	            _this4._xscroll.userConfig.scrollbarY = true;
	          }
	          _this4._xscroll.userConfig.lockY = false;
	        });
	      }
	      _this4._xscroll.on('panend', function (e) {
	        _this4.$emit('on-scroll-end', e);
	      });
	      _this4._xscroll.on('panstart', function (e) {
	        _this4.$emit('on-scroll-start', e);
	      });
	      _this4._xscroll.render();
	      window.addEventListener('orientationchange', _this4.handleOrientationchange, false);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.pullup) {
	      this._xscroll.unplug(this.pullup);
	      this.pullup.pluginDestructor();
	    }
	    if (this.pulldown) {
	      this._xscroll.unplug(this.pulldown);
	      this.pulldown.pluginDestructor();
	    }
	    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
	    this._xscroll.destroy();
	    this._xscroll = null;
	    clearTimeout(this.timer);
	  }
	};


	function pure(obj) {
	  return JSON.parse((0, _stringify2.default)(obj));
	}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports = require("cvux-xscroll/build/cjs/xscroll.js");

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports = require("cvux-xscroll/build/cjs/plugins/pulldown.js");

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = require("cvux-xscroll/build/cjs/plugins/pullup.js");

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    style: (_vm.styles)
	  }, [_c('div', {
	    staticClass: "xs-container"
	  }, [_vm._t("default"), _vm._t("pulldown"), _vm._t("pullup")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _shake = __webpack_require__(350);

	var _shake2 = _interopRequireDefault(_shake);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_shake2.default.install = function (Vue) {
	  Vue.component('LxShake', _shake2.default);
	};

	exports.default = _shake2.default;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(351),
	  /* template */
	  __webpack_require__(353),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _shake = __webpack_require__(352);

	var _shake2 = _interopRequireDefault(_shake);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    stop: Boolean,
	    threshold: {
	      type: Number,
	      default: 15
	    },
	    timeout: {
	      type: Number,
	      default: 1000
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	    this._shake = new _shake2.default({
	      threshold: _this.threshold,
	      timeout: _this.timeout });
	    window.addEventListener('shake', this.handler, false);
	    this._shake.start();
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('shake', this.handler, false);
	  },

	  methods: {
	    handler: function handler() {
	      var _this = this;
	      if (_this.stop) {
	        this.$emit('on-shake');
	      } else {
	        this._shake.stop();
	      }
	    }
	  }
	};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports = require("shake.js");

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(355)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(357),
	  /* template */
	  __webpack_require__(358),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(356);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6bda66fc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./search.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6bda66fc!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./search.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* mixin */\n/* variable */\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.search_input {\n  background-color: #eee;\n  padding: 0.26666667rem 0.4rem;\n  font-size: 15px;\n  border-radius: 0.05333333rem;\n}\n.search_input .weui_cell {\n  background-color: #fff;\n}\n.search_input .weui_input {\n  line-height: 0.66666667rem;\n}\n.search_input .weui_cell {\n  padding: 0.2rem 0.4rem;\n}\n.search_input .search_icon {\n  width: 0.53333333rem;\n  margin-bottom: -0.13333333rem;\n  margin-left: 0.13333333rem;\n}\n", ""]);

	// exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(90);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: { XInput: _index2.default },
	  props: {
	    placeholder: {
	      type: String,
	      default: '搜索'
	    },
	    value: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: ''
	    };
	  },

	  methods: {
	    handleBlur: function handleBlur() {
	      this.$emit('on-blur');
	    },
	    handleChange: function handleChange() {
	      this.$emit('on-change', this.currentValue);
	    },
	    handleFocus: function handleFocus() {
	      this.$emit('on-focus');
	    },
	    submit: function submit() {
	      this.$emit('on-submit', this.currentValue);
	    },
	    handleClickClear: function handleClickClear() {
	      this.$emit('on-click-clear-icon');
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  }
	};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "search_input"
	  }, [_c('x-input', {
	    attrs: {
	      "placeholder": _vm.placeholder
	    },
	    on: {
	      "on-change": _vm.handleChange,
	      "on-focus": _vm.handleFocus,
	      "on-blur": _vm.handleBlur,
	      "on-click-clear-icon": _vm.handleClickClear
	    },
	    model: {
	      value: (_vm.currentValue),
	      callback: function($$v) {
	        _vm.currentValue = $$v
	      },
	      expression: "currentValue"
	    }
	  }, [_vm._t("label", null, {
	    slot: "label"
	  }), _c('img', {
	    staticClass: "search_icon",
	    attrs: {
	      "slot": "right",
	      "src": __webpack_require__(359)
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.submit($event)
	      }
	    },
	    slot: "right"
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _masker = __webpack_require__(361);

	var _masker2 = _interopRequireDefault(_masker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_masker2.default.install = function (Vue) {
	  Vue.component('LxMasker', _masker2.default);
	};

	exports.default = _masker2.default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(362)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(364),
	  /* template */
	  __webpack_require__(366),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(363);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-24a0f5dc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./masker.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-24a0f5dc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./masker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-masker-box {\r\n  position: relative;\n}\n.vux-masker {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  border-radius: inherit;\n}\n.vux-masker-fullscreen {\r\n  position: fixed;\r\n  z-index: 10001;\n}\r\n", ""]);

	// exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _converter = __webpack_require__(365);

	exports.default = {
	  props: {
	    color: {
	      type: String,
	      default: '0, 0, 0'
	    },
	    opacity: {
	      type: Number,
	      default: 0.5
	    },
	    fullscreen: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    style: function style() {
	      var color = /,/.test(this.color) ? this.color : (0, _converter.toRGB)(this.color.replace('#', '')).join(',');
	      return {
	        backgroundColor: 'rgba(' + color + ',' + this.opacity + ')'
	      };
	    }
	  }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toRGB = toRGB;
	exports.toHex = toHex;
	function toRGB(color) {
	  var num = parseInt(color, 16);
	  return [num >> 16, num >> 8 & 255, num & 255];
	}

	function toHex(red, green, blue) {
	  return (blue | green << 8 | red << 16 | 1 << 24).toString(16).slice(1);
	}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-masker-box"
	  }, [_vm._t("default"), _c('div', {
	    staticClass: "vux-masker",
	    class: {
	      'vux-masker-fullscreen': _vm.fullscreen
	    },
	    style: (_vm.style)
	  }, [_vm._t("content")], 2)], 2)
	},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _countdown = __webpack_require__(368);

	var _countdown2 = _interopRequireDefault(_countdown);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_countdown2.default.install = function (Vue) {
	  Vue.component('LxCountdown', _countdown2.default);
	};

	exports.default = _countdown2.default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(369),
	  /* template */
	  __webpack_require__(370),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: Object,
	      default: {
	        time: 60,
	        start: true
	      }
	    }
	  },
	  methods: {
	    tick: function tick() {
	      var _this = this;

	      this.interval = setInterval(function () {
	        if (_this.time > 0) {
	          _this.time--;
	        } else {
	          _this.stop();
	          _this.index++;
	          _this.$emit('on-finish', _this.index);
	        }
	      }, 1000);
	    },
	    stop: function stop() {
	      clearInterval(this.interval);
	    }
	  },
	  watch: {
	    'value.time': function valueTime(val) {
	      this.time = val;
	    },
	    'value.start': function valueStart(val) {
	      this.start = val;
	    },
	    time: function time(val) {
	      var options = {
	        time: val,
	        start: this.start
	      };
	      this.$emit('input', options);
	    },
	    start: function start(newVal, oldVal) {
	      if (newVal === true && oldVal === false && this.time > 0) {
	        this.tick();
	      }
	      if (newVal === false && oldVal === true) {
	        this.stop();
	      }
	      var options = {
	        time: this.time,
	        start: newVal
	      };
	      this.$emit('input', options);
	    }
	  },
	  created: function created() {
	    this.time = this.value.time;
	    this.start = this.value.start;
	    if (this.start) {
	      this.tick();
	    }
	  },
	  data: function data() {
	    return {
	      interval: null,
	      index: 0,
	      time: 60,
	      start: true
	    };
	  }
	};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v(_vm._s(_vm.time))])
	},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (time) {
	  var date = typeof time === 'number' ? new Date(time) : new Date((time || '').replace(/-/g, '/'));
	  var diff = (new Date().getTime() - date.getTime()) / 1000;
	  var dayDiff = Math.floor(diff / 86400);

	  var isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());

	  if (!isValidDate) {
	    console.error('not a valid date');
	  }
	  var formatDate = function formatDate(date) {
	    var today = new Date(date);
	    var year = today.getFullYear();
	    var month = ('0' + (today.getMonth() + 1)).slice(-2);
	    var day = ('0' + today.getDate()).slice(-2);
	    var hour = today.getHours();
	    var minute = today.getMinutes();
	    var second = today.getSeconds();
	    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
	  };

	  if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
	    return formatDate(date);
	  }

	  return dayDiff === 0 && (diff < 60 && '刚刚' || diff < 120 && '1分钟前' || diff < 3600 && Math.floor(diff / 60) + '分钟前' || diff < 7200 && '1小时前' || diff < 86400 && Math.floor(diff / 3600) + '小时前') || dayDiff === 1 && '昨天' || dayDiff < 7 && dayDiff + '天前' || dayDiff < 31 && Math.ceil(dayDiff / 7) + '周前';
	};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _xHeader = __webpack_require__(373);

	var _xHeader2 = _interopRequireDefault(_xHeader);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_xHeader2.default.install = function (Vue) {
	  Vue.component('LxXHeader', _xHeader2.default);
	};

	exports.default = _xHeader2.default;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(374)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(377),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(375);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-378f3808!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-header.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-378f3808!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./x-header.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* mixin */\n/* variable */\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_cell {\n  position: relative;\n}\n.weui_cell:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 0.4rem;\n}\n.weui_cell:first-child:before {\n  display: none;\n}\n.weui_cells {\n  background-color: #FFFFFF;\n  line-height: 2.26666667;\n  font-size: 0.4rem;\n  overflow: hidden;\n  position: relative;\n}\n.weui_cells:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_cells:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #D9D9D9;\n  color: #D9D9D9;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_cells_title {\n  padding-top: 0.4rem;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  color: #000;\n  font-size: 0.34666667rem;\n  line-height: 0.8rem;\n  opacity: 0.7;\n}\n.weui_cells_title + .weui_cells {\n  margin-top: 0;\n}\n.weui_cells_tips {\n  margin-top: .3em;\n  color: #000;\n  padding-left: 0.4rem;\n  padding-right: 0.4rem;\n  font-size: 0.34666667rem;\n}\n.weui_cell {\n  padding: 0.26666667rem 0.4rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.weui_cell_ft {\n  text-align: left;\n  color: #666;\n}\n.weui_cell_primary {\n  flex: 1;\n}\n.weui_cell_hd img {\n  width: 0.8rem;\n  margin-right: 0.4rem;\n}\n.weui_cell_hd span {\n  font-size: 0.37333333rem;\n}\n.weui_cell_flexStar {\n  align-items: flex-star;\n}\n.vux-header {\n  position: relative;\n  padding: 0.08rem 0;\n  box-sizing: border-box;\n  background-color: #35495e;\n}\n.vux-header .vux-header-title,\n.vux-header h1 {\n  margin: 0 2.34666667rem;\n  margin-left: 2.66666667rem;\n  line-height: 1.06666667rem;\n  text-align: center;\n  height: 1.06666667rem;\n  font-size: 0.48rem;\n  font-weight: 400;\n  width: auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #fff;\n}\n.vux-header .vux-header-title > span {\n  display: inline-block;\n}\n.vux-header .vux-header-left,\n.vux-header .vux-header-right {\n  position: absolute;\n  top: 0.37333333rem;\n  display: block;\n  font-size: 0.37333333rem;\n  line-height: 0.56rem;\n  color: #ccc;\n}\n.vux-header .vux-header-left a,\n.vux-header .vux-header-left button,\n.vux-header .vux-header-right a,\n.vux-header .vux-header-right button {\n  float: left;\n  margin-right: 0.21333333rem;\n  color: #ccc;\n}\n.vux-header .vux-header-left a:active,\n.vux-header .vux-header-left button:active,\n.vux-header .vux-header-right a:active,\n.vux-header .vux-header-right button:active {\n  opacity: 0.5;\n}\n.vux-header .vux-header-left {\n  left: 0.48rem;\n}\n.vux-header .vux-header-left .vux-header-back {\n  padding-left: 0.42666667rem;\n}\n.vux-header .vux-header-left .left-arrow {\n  position: absolute;\n  width: 0.8rem;\n  height: 0.8rem;\n  top: -0.13333333rem;\n  left: -0.13333333rem;\n}\n.vux-header .vux-header-left .left-arrow:before {\n  content: \"\";\n  position: absolute;\n  width: 0.32rem;\n  height: 0.32rem;\n  border: 1px solid #ccc;\n  border-width: 1px 0 0 1px;\n  transform: rotate(315deg);\n  top: 0.21333333rem;\n  left: 0.18666667rem;\n}\n.vux-header .vux-header-right {\n  right: 0.4rem;\n}\n.vux-header .vux-header-right a,\n.vux-header .vux-header-right button {\n  margin-left: 0.21333333rem;\n  margin-right: 0;\n}\n.vux-header .vux-header-right .vux-header-more:after {\n  content: \"\\2022   \\2022   \\2022   \";\n  font-size: 0.42666667rem;\n}\n.vux-header-fade-in-right-enter {\n  animation: fadeinR .5s;\n}\n.vux-header-fade-in-left-enter {\n  animation: fadeinL .5s;\n}\n@keyframes fadeinR {\n0% {\n    opacity: 0;\n    transform: translateX(2.13333333rem);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes fadeinL {\n0% {\n    opacity: 0;\n    transform: translateX(-2.13333333rem);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n", ""]);

	// exports


/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    leftOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          showBack: true,
	          backText: 'Back',
	          preventGoBack: false
	        };
	      }
	    },
	    title: String,
	    transition: String,
	    rightOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          showMore: false
	        };
	      }
	    }
	  },
	  methods: {
	    onClickBack: function onClickBack() {
	      if (this.leftOptions.preventGoBack) {
	        this.$emit('on-click-back');
	      } else {
	        window.history.back();
	      }
	    }
	  }
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-header"
	  }, [_c('div', {
	    staticClass: "vux-header-left"
	  }, [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.leftOptions.showBack),
	      expression: "leftOptions.showBack"
	    }],
	    staticClass: "vux-header-back",
	    attrs: {
	      "transition": _vm.transition
	    },
	    on: {
	      "click": [function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault", undefined, $event.key)) { return null; }
	      }, _vm.onClickBack]
	    }
	  }, [_vm._v(_vm._s(_vm.leftOptions.backText))]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.leftOptions.showBack),
	      expression: "leftOptions.showBack"
	    }],
	    staticClass: "left-arrow",
	    attrs: {
	      "transition": _vm.transition
	    },
	    on: {
	      "click": _vm.onClickBack
	    }
	  }), _vm._t("left")], 2), _c('h1', {
	    staticClass: "vux-header-title",
	    on: {
	      "click": function($event) {
	        _vm.$emit('on-click-title')
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "transition": _vm.transition
	    }
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("default")], 2), _c('div', {
	    staticClass: "vux-header-right"
	  }, [(_vm.rightOptions.showMore) ? _c('a', {
	    staticClass: "vux-header-more",
	    on: {
	      "click": [function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault", undefined, $event.key)) { return null; }
	      }, function($event) {
	        _vm.$emit('on-click-more')
	      }]
	    }
	  }) : _vm._e(), _vm._t("right")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _panel = __webpack_require__(379);

	var _panel2 = _interopRequireDefault(_panel);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_panel2.default.install = function (Vue) {
	  Vue.component('LxPanel', _panel2.default);
	};

	exports.default = _panel2.default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(380)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(382),
	  /* template */
	  __webpack_require__(383),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(381);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-36803d86!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./panel.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-36803d86!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./panel.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n.weui_panel {\n  background-color: #FFFFFF;\n  margin-top: 10px;\n  position: relative;\n  overflow: hidden;\n}\n.weui_panel:first-child {\n  margin-top: 0;\n}\n.weui_panel:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_panel:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_panel_hd {\n  padding: 14px 15px 10px;\n  color: #999999;\n  font-size: 13px;\n  position: relative;\n}\n.weui_panel_hd:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n  left: 15px;\n}\n.weui_panel_ft {\n  padding: 10px 15px 12px;\n  color: #999999;\n  font-size: 14px;\n  position: relative;\n}\n.weui_panel_ft:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 15px;\n}\n.weui_panel_access .weui_panel_ft {\n  display: block;\n  color: #586C94;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_panel_access .weui_panel_ft:active {\n  background-color: #ECECEC;\n}\n.weui_panel_access .weui_panel_ft:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 6px;\n  width: 6px;\n  border-width: 2px 2px 0 0;\n  border-color: #C7C7CC;\n  border-style: solid;\n  position: relative;\n  top: -2px;\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  margin-top: -4px;\n}\n.weui_media_box {\n  padding: 15px;\n  position: relative;\n}\n.weui_media_box:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 15px;\n}\n.weui_media_box:first-child:before {\n  display: none;\n}\na.weui_media_box {\n  color: #000000;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\na.weui_media_box:active {\n  background-color: #ECECEC;\n}\n.weui_media_box .weui_media_title {\n  font-weight: 400;\n  font-size: 17px;\n  width: auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.weui_media_box .weui_media_desc {\n  color: #999999;\n  font-size: 13px;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n.weui_media_box.weui_media_text .weui_media_title {\n  margin-bottom: 8px;\n}\n.weui_media_box.weui_media_text .weui_media_info {\n  margin-top: 15px;\n  padding-bottom: 5px;\n  font-size: 13px;\n  color: #CECECE;\n  line-height: 1em;\n  list-style: none;\n  overflow: hidden;\n}\n.weui_media_box.weui_media_text .weui_media_info_meta {\n  float: left;\n  padding-right: 1em;\n}\n.weui_media_box.weui_media_text .weui_media_info_meta.weui_media_info_meta_extra {\n  padding-left: 1em;\n  border-left: 1px solid #CECECE;\n}\n.weui_media_box.weui_media_appmsg {\n  display: flex;\n  align-items: center;\n}\n.weui_media_box.weui_media_appmsg .weui_media_hd {\n  margin-right: .8em;\n  width: 60px;\n  height: 60px;\n  line-height: 60px;\n  text-align: center;\n}\n.weui_media_box.weui_media_appmsg .weui_media_appmsg_thumb {\n  width: 100%;\n  max-height: 100%;\n  vertical-align: top;\n}\n.weui_media_box.weui_media_appmsg .weui_media_bd {\n  flex: 1;\n  min-width: 0;\n}\n.weui_media_box.weui_media_small_appmsg {\n  padding: 0;\n}\n.weui_media_box.weui_media_small_appmsg .weui_cells {\n  margin-top: 0;\n}\n.weui_media_box.weui_media_small_appmsg .weui_cells:before {\n  display: none;\n}\n", ""]);

	// exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _router = __webpack_require__(123);

	exports.default = {
	  props: {
	    header: String,
	    footer: Object,
	    list: Array,
	    type: {
	      type: String,
	      default: '1'
	    }
	  },
	  methods: {
	    getUrl: function getUrl(url) {
	      return (0, _router.getUrl)(url, this.$router);
	    },
	    onClickFooter: function onClickFooter() {
	      this.$emit('on-click-footer');
	      (0, _router.go)(this.footer.url, this.$router);
	    },
	    onClickHeader: function onClickHeader() {
	      this.$emit('on-click-header');
	    },
	    onItemClick: function onItemClick(item) {
	      this.$emit('on-click-item', item);
	      (0, _router.go)(item.url, this.$router);
	    }
	  }
	};

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_panel weui_panel_access"
	  }, [(_vm.header) ? _c('div', {
	    staticClass: "weui_panel_hd",
	    domProps: {
	      "innerHTML": _vm._s(_vm.header)
	    },
	    on: {
	      "click": _vm.onClickHeader
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "weui_panel_bd"
	  }, [_vm._l((_vm.list), function(item) {
	    return (_vm.type === '1') ? _c('a', {
	      staticClass: "weui_media_box weui_media_appmsg",
	      attrs: {
	        "href": _vm.getUrl(item.url)
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.onItemClick(item)
	        }
	      }
	    }, [(item.src) ? _c('div', {
	      staticClass: "weui_media_hd"
	    }, [_c('img', {
	      staticClass: "weui_media_appmsg_thumb",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    })]) : _vm._e(), _c('div', {
	      staticClass: "weui_media_bd"
	    }, [_c('h4', {
	      staticClass: "weui_media_title"
	    }, [_vm._v(_vm._s(item.title))]), _c('p', {
	      staticClass: "weui_media_desc"
	    }, [_vm._v(_vm._s(item.desc))])])]) : _vm._e()
	  }), _vm._l((_vm.list), function(item) {
	    return (_vm.type === '2') ? _c('div', {
	      staticClass: "weui_media_box weui_media_text",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.onItemClick(item)
	        }
	      }
	    }, [_c('h4', {
	      staticClass: "weui_media_title"
	    }, [_vm._v(_vm._s(item.title))]), _c('p', {
	      staticClass: "weui_media_desc"
	    }, [_vm._v(_vm._s(item.desc))])]) : _vm._e()
	  }), _c('div', {
	    staticClass: "weui_media_box weui_media_small_appmsg"
	  }, [_c('div', {
	    staticClass: "weui_cells weui_cells_access"
	  }, _vm._l((_vm.list), function(item) {
	    return (_vm.type === '3') ? _c('a', {
	      staticClass: "weui_cell",
	      attrs: {
	        "href": _vm.getUrl(item.url)
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.onItemClick(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "weui_cell_hd"
	    }, [_c('img', {
	      staticStyle: {
	        "width": "20px",
	        "margin-right": "5px",
	        "display": "block"
	      },
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    })]), _c('div', {
	      staticClass: "weui_cell_bd weui_cell_primary"
	    }, [_c('p', [_vm._v(_vm._s(item.title))])]), _c('span', {
	      staticClass: "weui_cell_ft"
	    })]) : _vm._e()
	  }))]), _vm._l((_vm.list), function(item) {
	    return (_vm.type === '4') ? _c('a', {
	      staticClass: "weui_media_box weui_media_appmsg",
	      attrs: {
	        "href": _vm.getUrl(item.url)
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.onItemClick(item)
	        }
	      }
	    }, [(item.src) ? _c('div', {
	      staticClass: "weui_media_hd"
	    }, [_c('img', {
	      staticClass: "weui_media_appmsg_thumb",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    })]) : _vm._e(), _c('div', {
	      staticClass: "weui_media_bd"
	    }, [_c('h4', {
	      staticClass: "weui_media_title"
	    }, [_vm._v(_vm._s(item.title))]), _c('h4', {
	      staticClass: "weui_media_title"
	    }, [_c('span', [_vm._v("title: ")]), _vm._v(_vm._s(item.title))]), _c('h4', {
	      staticClass: "weui_media_title"
	    }, [_c('span', [_vm._v("title: ")]), _vm._v(_vm._s(item.title))]), _c('h4', {
	      staticClass: "weui_media_title"
	    }, [_c('span', [_vm._v("title: ")]), _vm._v(_vm._s(item.title))]), _c('p', {
	      staticClass: "weui_media_desc"
	    }, [_vm._v(_vm._s(item.desc))])])]) : _vm._e()
	  })], 2), (_vm.footer && _vm.type !== '3') ? _c('a', {
	    staticClass: "weui_panel_ft",
	    attrs: {
	      "href": _vm.getUrl(_vm.footer.url)
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.footer.title)
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.onClickFooter($event)
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _badge = __webpack_require__(385);

	var _badge2 = _interopRequireDefault(_badge);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_badge2.default.install = function (Vue) {
	  Vue.component('LxBadge', _badge2.default);
	};

	exports.default = _badge2.default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(386)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(388),
	  /* template */
	  __webpack_require__(389),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(387);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-626182f8!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./badge.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-626182f8!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./badge.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/**\n* @vux Copy weui_tab.less and Remove navbar\n*/\n/* mixin */\n/* variable */\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_tabbar {\n  display: flex;\n  position: absolute;\n  z-index: 100;\n  bottom: 0;\n  width: 100%;\n  background-color: #f7f7fa;\n}\n.weui_tabbar:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #979797;\n  color: #979797;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_tabbar_item {\n  display: block;\n  flex: 1;\n  padding: 0.18666667rem 0 0;\n  -webkit-tap-highlight-color: transparent;\n}\n.weui_tabbar_item.weui_bar_item_on .weui_tabbar_label {\n  color: #09BB07;\n}\n.weui_tabbar_icon {\n  margin: 0 auto;\n  width: 0.64rem;\n  height: 0.64rem;\n}\n.weui_tabbar_icon img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.weui_tabbar_icon + .weui_tabbar_label {\n  margin-top: 0.13333333rem;\n}\n.weui_tabbar_label {\n  text-align: center;\n  color: #000;\n  font-size: 0.32rem;\n}\n.weui_tab {\n  position: relative;\n  height: 100%;\n}\n.weui_tab_bd {\n  box-sizing: border-box;\n  height: 100%;\n  padding-bottom: 1.46666667rem;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  font-size: 0.34666667rem;\n}\n.weui_tab_bd_item {\n  display: none;\n}\n.weui_tab_bd_item_active {\n  display: block;\n}\n.vux-badge {\n  display: inline-block;\n  text-align: center;\n  background: #f74c31;\n  color: #fff;\n  font-size: 0.32rem;\n  height: 0.48rem;\n  line-height: 0.50666667rem;\n  border-radius: 0.21333333rem;\n  padding: 0 0.16rem;\n  background-clip: padding-box;\n}\n.vux-badge-single {\n  padding: 0;\n  width: 0.42666667rem;\n}\n", ""]);

	// exports


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    text: [String, Number]
	  }
	};

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    class: ['vux-badge', {
	      'vux-badge-single': _vm.text.length === 1
	    }],
	    domProps: {
	      "textContent": _vm._s(_vm.text)
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _card = __webpack_require__(391);

	var _card2 = _interopRequireDefault(_card);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_card2.default.install = function (Vue) {
	  Vue.component('LxCard', _card2.default);
	};

	exports.default = _card2.default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(392)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(394),
	  /* template */
	  __webpack_require__(395),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(393);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-13095f88!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./card.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-13095f88!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./card.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_panel {\n  background-color: #FFFFFF;\n  margin-top: 10px;\n  position: relative;\n  overflow: hidden;\n}\n.weui_panel:first-child {\n  margin-top: 0;\n}\n.weui_panel:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_panel:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n}\n.weui_panel_hd {\n  padding: 14px 15px 10px;\n  color: #999999;\n  font-size: 13px;\n  position: relative;\n}\n.weui_panel_hd:after {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 100%;\n  transform: scaleY(0.5);\n  left: 15px;\n}\n.weui_panel_ft {\n  padding: 10px 15px 12px;\n  color: #999999;\n  font-size: 14px;\n  position: relative;\n}\n.weui_panel_ft:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #E5E5E5;\n  color: #E5E5E5;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n  left: 15px;\n}\n.weui_panel_access .weui_panel_ft {\n  display: block;\n  color: #586C94;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.weui_panel_access .weui_panel_ft:active {\n  background-color: #ECECEC;\n}\n.weui_panel_access .weui_panel_ft:after {\n  content: \" \";\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 6px;\n  width: 6px;\n  border-width: 2px 2px 0 0;\n  border-color: #C7C7CC;\n  border-style: solid;\n  position: relative;\n  top: -2px;\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  margin-top: -4px;\n}\n", ""]);

	// exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _router = __webpack_require__(123);

	exports.default = {
	  props: {
	    header: Object,
	    footer: Object
	  },
	  methods: {
	    onClickFooter: function onClickFooter() {
	      this.footer.link && (0, _router.go)(this.footer.link, this.$router);
	      this.$emit('on-click-footer');
	    }
	  }
	};

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_panel weui_panel_access"
	  }, [(_vm.header && _vm.header.title) ? _c('div', {
	    staticClass: "weui_panel_hd",
	    domProps: {
	      "innerHTML": _vm._s(_vm.header.title)
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('on-click-header')
	      }
	    }
	  }) : _vm._e(), _vm._t("header"), _c('div', {
	    staticClass: "weui_panel_bd"
	  }, [_c('div', {
	    staticClass: "vux-card-content"
	  }, [_vm._t("content")], 2)]), (_vm.footer && _vm.footer.title) ? _c('a', {
	    staticClass: "weui_panel_ft",
	    attrs: {
	      "href": "javascript:"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.footer.title)
	    },
	    on: {
	      "click": _vm.onClickFooter
	    }
	  }) : _vm._e(), _vm._t("footer")], 2)
	},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _previewer = __webpack_require__(397);

	var _previewer2 = _interopRequireDefault(_previewer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_previewer2.default.install = function (Vue) {
	  Vue.component('LxPreviewer', _previewer2.default);
	};

	exports.default = _previewer2.default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(398)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(405),
	  /* template */
	  __webpack_require__(409),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(399);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7857c4a8!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./previewer.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7857c4a8!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./previewer.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports
	exports.i(__webpack_require__(400), "");
	exports.i(__webpack_require__(401), "");

	// module
	exports.push([module.id, "\r\n", ""]);

	// exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/*! PhotoSwipe main CSS by Dmitry Semenov | photoswipe.com | MIT license */\n/*\n\tStyles for basic PhotoSwipe functionality (sliding area, open/close transitions)\n*/\n/* pswp = photoswipe */\n.pswp {\n  display: none;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  -ms-touch-action: none;\n  touch-action: none;\n  z-index: 1500;\n  -webkit-text-size-adjust: 100%;\n  /* create separate layer, to avoid paint on window.onscroll in webkit/blink */\n  -webkit-backface-visibility: hidden;\n  outline: none; }\n  .pswp * {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box; }\n  .pswp img {\n    max-width: none; }\n\n/* style is added when JS option showHideOpacity is set to true */\n.pswp--animate_opacity {\n  /* 0.001, because opacity:0 doesn't trigger Paint action, which causes lag at start of transition */\n  opacity: 0.001;\n  will-change: opacity;\n  /* for open/close transition */\n  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1); }\n\n.pswp--open {\n  display: block; }\n\n.pswp--zoom-allowed .pswp__img {\n  /* autoprefixer: off */\n  cursor: -webkit-zoom-in;\n  cursor: -moz-zoom-in;\n  cursor: zoom-in; }\n\n.pswp--zoomed-in .pswp__img {\n  /* autoprefixer: off */\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: grab; }\n\n.pswp--dragging .pswp__img {\n  /* autoprefixer: off */\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing; }\n\n/*\n\tBackground is added as a separate element.\n\tAs animating opacity is much faster than animating rgba() background-color.\n*/\n.pswp__bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  will-change: opacity; }\n\n.pswp__scroll-wrap {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n\n.pswp__container,\n.pswp__zoom-wrap {\n  -ms-touch-action: none;\n  touch-action: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0; }\n\n/* Prevent selection and tap highlights */\n.pswp__container,\n.pswp__img {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n      user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none; }\n\n.pswp__zoom-wrap {\n  position: absolute;\n  width: 100%;\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n  /* for open/close transition */\n  -webkit-transition: -webkit-transform 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: transform 333ms cubic-bezier(0.4, 0, 0.22, 1); }\n\n.pswp__bg {\n  will-change: opacity;\n  /* for open/close transition */\n  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1); }\n\n.pswp--animated-in .pswp__bg,\n.pswp--animated-in .pswp__zoom-wrap {\n  -webkit-transition: none;\n  transition: none; }\n\n.pswp__container,\n.pswp__zoom-wrap {\n  -webkit-backface-visibility: hidden; }\n\n.pswp__item {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  overflow: hidden; }\n\n.pswp__img {\n  position: absolute;\n  width: auto;\n  height: auto;\n  top: 0;\n  left: 0; }\n\n/*\n\tstretched thumbnail or div placeholder element (see below)\n\tstyle is added to avoid flickering in webkit/blink when layers overlap\n*/\n.pswp__img--placeholder {\n  -webkit-backface-visibility: hidden; }\n\n/*\n\tdiv element that matches size of large image\n\tlarge image loads on top of it\n*/\n.pswp__img--placeholder--blank {\n  background: #222; }\n\n.pswp--ie .pswp__img {\n  width: 100% !important;\n  height: auto !important;\n  left: 0;\n  top: 0; }\n\n/*\n\tError message appears when image is not loaded\n\t(JS option errorMsg controls markup)\n*/\n.pswp__error-msg {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 16px;\n  margin-top: -8px;\n  color: #CCC; }\n\n.pswp__error-msg a {\n  color: #CCC;\n  text-decoration: underline; }\n", ""]);

	// exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/*! PhotoSwipe Default UI CSS by Dmitry Semenov | photoswipe.com | MIT license */\n/*\n\n\tContents:\n\n\t1. Buttons\n\t2. Share modal and links\n\t3. Index indicator (\"1 of X\" counter)\n\t4. Caption\n\t5. Loading indicator\n\t6. Additional styles (root element, top bar, idle state, hidden state, etc.)\n\n*/\n/*\n\t\n\t1. Buttons\n\n */\n/* <button> css reset */\n.pswp__button {\n  width: 44px;\n  height: 44px;\n  position: relative;\n  background: none;\n  cursor: pointer;\n  overflow: visible;\n  -webkit-appearance: none;\n  display: block;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  float: right;\n  opacity: 0.75;\n  -webkit-transition: opacity 0.2s;\n          transition: opacity 0.2s;\n  -webkit-box-shadow: none;\n          box-shadow: none; }\n  .pswp__button:focus, .pswp__button:hover {\n    opacity: 1; }\n  .pswp__button:active {\n    outline: none;\n    opacity: 0.9; }\n  .pswp__button::-moz-focus-inner {\n    padding: 0;\n    border: 0; }\n\n/* pswp__ui--over-close class it added when mouse is over element that should close gallery */\n.pswp__ui--over-close .pswp__button--close {\n  opacity: 1; }\n\n.pswp__button,\n.pswp__button--arrow--left:before,\n.pswp__button--arrow--right:before {\n  background: url(" + __webpack_require__(402) + ") 0 0 no-repeat;\n  background-size: 264px 88px;\n  width: 44px;\n  height: 44px; }\n\n@media (-webkit-min-device-pixel-ratio: 1.1), (-webkit-min-device-pixel-ratio: 1.09375), (min-resolution: 105dpi), (min-resolution: 1.1dppx) {\n  /* Serve SVG sprite if browser supports SVG and resolution is more than 105dpi */\n  .pswp--svg .pswp__button,\n  .pswp--svg .pswp__button--arrow--left:before,\n  .pswp--svg .pswp__button--arrow--right:before {\n    background-image: url(" + __webpack_require__(403) + "); }\n  .pswp--svg .pswp__button--arrow--left,\n  .pswp--svg .pswp__button--arrow--right {\n    background: none; } }\n\n.pswp__button--close {\n  background-position: 0 -44px; }\n\n.pswp__button--share {\n  background-position: -44px -44px; }\n\n.pswp__button--fs {\n  display: none; }\n\n.pswp--supports-fs .pswp__button--fs {\n  display: block; }\n\n.pswp--fs .pswp__button--fs {\n  background-position: -44px 0; }\n\n.pswp__button--zoom {\n  display: none;\n  background-position: -88px 0; }\n\n.pswp--zoom-allowed .pswp__button--zoom {\n  display: block; }\n\n.pswp--zoomed-in .pswp__button--zoom {\n  background-position: -132px 0; }\n\n/* no arrows on touch screens */\n.pswp--touch .pswp__button--arrow--left,\n.pswp--touch .pswp__button--arrow--right {\n  visibility: hidden; }\n\n/*\n\tArrow buttons hit area\n\t(icon is added to :before pseudo-element)\n*/\n.pswp__button--arrow--left,\n.pswp__button--arrow--right {\n  background: none;\n  top: 50%;\n  margin-top: -50px;\n  width: 70px;\n  height: 100px;\n  position: absolute; }\n\n.pswp__button--arrow--left {\n  left: 0; }\n\n.pswp__button--arrow--right {\n  right: 0; }\n\n.pswp__button--arrow--left:before,\n.pswp__button--arrow--right:before {\n  content: '';\n  top: 35px;\n  background-color: rgba(0, 0, 0, 0.3);\n  height: 30px;\n  width: 32px;\n  position: absolute; }\n\n.pswp__button--arrow--left:before {\n  left: 6px;\n  background-position: -138px -44px; }\n\n.pswp__button--arrow--right:before {\n  right: 6px;\n  background-position: -94px -44px; }\n\n/*\n\n\t2. Share modal/popup and links\n\n */\n.pswp__counter,\n.pswp__share-modal {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n      user-select: none; }\n\n.pswp__share-modal {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  padding: 10px;\n  position: absolute;\n  z-index: 1600;\n  opacity: 0;\n  -webkit-transition: opacity 0.25s ease-out;\n          transition: opacity 0.25s ease-out;\n  -webkit-backface-visibility: hidden;\n  will-change: opacity; }\n\n.pswp__share-modal--hidden {\n  display: none; }\n\n.pswp__share-tooltip {\n  z-index: 1620;\n  position: absolute;\n  background: #FFF;\n  top: 56px;\n  border-radius: 2px;\n  display: block;\n  width: auto;\n  right: 44px;\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);\n  -webkit-transform: translateY(6px);\n      -ms-transform: translateY(6px);\n          transform: translateY(6px);\n  -webkit-transition: -webkit-transform 0.25s;\n          transition: transform 0.25s;\n  -webkit-backface-visibility: hidden;\n  will-change: transform; }\n  .pswp__share-tooltip a {\n    display: block;\n    padding: 8px 12px;\n    color: #000;\n    text-decoration: none;\n    font-size: 14px;\n    line-height: 18px; }\n    .pswp__share-tooltip a:hover {\n      text-decoration: none;\n      color: #000; }\n    .pswp__share-tooltip a:first-child {\n      /* round corners on the first/last list item */\n      border-radius: 2px 2px 0 0; }\n    .pswp__share-tooltip a:last-child {\n      border-radius: 0 0 2px 2px; }\n\n.pswp__share-modal--fade-in {\n  opacity: 1; }\n  .pswp__share-modal--fade-in .pswp__share-tooltip {\n    -webkit-transform: translateY(0);\n        -ms-transform: translateY(0);\n            transform: translateY(0); }\n\n/* increase size of share links on touch devices */\n.pswp--touch .pswp__share-tooltip a {\n  padding: 16px 12px; }\n\na.pswp__share--facebook:before {\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: -12px;\n  right: 15px;\n  border: 6px solid transparent;\n  border-bottom-color: #FFF;\n  -webkit-pointer-events: none;\n  -moz-pointer-events: none;\n  pointer-events: none; }\n\na.pswp__share--facebook:hover {\n  background: #3E5C9A;\n  color: #FFF; }\n  a.pswp__share--facebook:hover:before {\n    border-bottom-color: #3E5C9A; }\n\na.pswp__share--twitter:hover {\n  background: #55ACEE;\n  color: #FFF; }\n\na.pswp__share--pinterest:hover {\n  background: #CCC;\n  color: #CE272D; }\n\na.pswp__share--download:hover {\n  background: #DDD; }\n\n/*\n\n\t3. Index indicator (\"1 of X\" counter)\n\n */\n.pswp__counter {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 44px;\n  font-size: 13px;\n  line-height: 44px;\n  color: #FFF;\n  opacity: 0.75;\n  padding: 0 10px; }\n\n/*\n\t\n\t4. Caption\n\n */\n.pswp__caption {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 44px; }\n  .pswp__caption small {\n    font-size: 11px;\n    color: #BBB; }\n\n.pswp__caption__center {\n  text-align: left;\n  max-width: 420px;\n  margin: 0 auto;\n  font-size: 13px;\n  padding: 10px;\n  line-height: 20px;\n  color: #CCC; }\n\n.pswp__caption--empty {\n  display: none; }\n\n/* Fake caption element, used to calculate height of next/prev image */\n.pswp__caption--fake {\n  visibility: hidden; }\n\n/*\n\n\t5. Loading indicator (preloader)\n\n\tYou can play with it here - http://codepen.io/dimsemenov/pen/yyBWoR\n\n */\n.pswp__preloader {\n  width: 44px;\n  height: 44px;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  margin-left: -22px;\n  opacity: 0;\n  -webkit-transition: opacity 0.25s ease-out;\n          transition: opacity 0.25s ease-out;\n  will-change: opacity;\n  direction: ltr; }\n\n.pswp__preloader__icn {\n  width: 20px;\n  height: 20px;\n  margin: 12px; }\n\n.pswp__preloader--active {\n  opacity: 1; }\n  .pswp__preloader--active .pswp__preloader__icn {\n    /* We use .gif in browsers that don't support CSS animation */\n    background: url(" + __webpack_require__(404) + ") 0 0 no-repeat; }\n\n.pswp--css_animation .pswp__preloader--active {\n  opacity: 1; }\n  .pswp--css_animation .pswp__preloader--active .pswp__preloader__icn {\n    -webkit-animation: clockwise 500ms linear infinite;\n            animation: clockwise 500ms linear infinite; }\n  .pswp--css_animation .pswp__preloader--active .pswp__preloader__donut {\n    -webkit-animation: donut-rotate 1000ms cubic-bezier(0.4, 0, 0.22, 1) infinite;\n            animation: donut-rotate 1000ms cubic-bezier(0.4, 0, 0.22, 1) infinite; }\n\n.pswp--css_animation .pswp__preloader__icn {\n  background: none;\n  opacity: 0.75;\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  left: 15px;\n  top: 15px;\n  margin: 0; }\n\n.pswp--css_animation .pswp__preloader__cut {\n  /* \n\t\t\tThe idea of animating inner circle is based on Polymer (\"material\") loading indicator \n\t\t\t by Keanu Lee https://blog.keanulee.com/2014/10/20/the-tale-of-three-spinners.html\n\t\t*/\n  position: relative;\n  width: 7px;\n  height: 14px;\n  overflow: hidden; }\n\n.pswp--css_animation .pswp__preloader__donut {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #FFF;\n  border-radius: 50%;\n  border-left-color: transparent;\n  border-bottom-color: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: none;\n  margin: 0; }\n\n@media screen and (max-width: 1024px) {\n  .pswp__preloader {\n    position: relative;\n    left: auto;\n    top: auto;\n    margin: 0;\n    float: right; } }\n\n@-webkit-keyframes clockwise {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes clockwise {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@-webkit-keyframes donut-rotate {\n  0% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0); }\n  50% {\n    -webkit-transform: rotate(-140deg);\n            transform: rotate(-140deg); }\n  100% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0); } }\n\n@keyframes donut-rotate {\n  0% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0); }\n  50% {\n    -webkit-transform: rotate(-140deg);\n            transform: rotate(-140deg); }\n  100% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0); } }\n\n/*\n\t\n\t6. Additional styles\n\n */\n/* root element of UI */\n.pswp__ui {\n  -webkit-font-smoothing: auto;\n  visibility: visible;\n  opacity: 1;\n  z-index: 1550; }\n\n/* top black bar with buttons and \"1 of X\" indicator */\n.pswp__top-bar {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 44px;\n  width: 100%; }\n\n.pswp__caption,\n.pswp__top-bar,\n.pswp--has_mouse .pswp__button--arrow--left,\n.pswp--has_mouse .pswp__button--arrow--right {\n  -webkit-backface-visibility: hidden;\n  will-change: opacity;\n  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1); }\n\n/* pswp--has_mouse class is added only when two subsequent mousemove events occur */\n.pswp--has_mouse .pswp__button--arrow--left,\n.pswp--has_mouse .pswp__button--arrow--right {\n  visibility: visible; }\n\n.pswp__top-bar,\n.pswp__caption {\n  background-color: rgba(0, 0, 0, 0.5); }\n\n/* pswp__ui--fit class is added when main image \"fits\" between top bar and bottom bar (caption) */\n.pswp__ui--fit .pswp__top-bar,\n.pswp__ui--fit .pswp__caption {\n  background-color: rgba(0, 0, 0, 0.3); }\n\n/* pswp__ui--idle class is added when mouse isn't moving for several seconds (JS option timeToIdle) */\n.pswp__ui--idle .pswp__top-bar {\n  opacity: 0; }\n\n.pswp__ui--idle .pswp__button--arrow--left,\n.pswp__ui--idle .pswp__button--arrow--right {\n  opacity: 0; }\n\n/*\n\tpswp__ui--hidden class is added when controls are hidden\n\te.g. when user taps to toggle visibility of controls\n*/\n.pswp__ui--hidden .pswp__top-bar,\n.pswp__ui--hidden .pswp__caption,\n.pswp__ui--hidden .pswp__button--arrow--left,\n.pswp__ui--hidden .pswp__button--arrow--right {\n  /* Force paint & create composition layer for controls. */\n  opacity: 0.001; }\n\n/* pswp__ui--one-slide class is added when there is just one item in gallery */\n.pswp__ui--one-slide .pswp__button--arrow--left,\n.pswp__ui--one-slide .pswp__button--arrow--right,\n.pswp__ui--one-slide .pswp__counter {\n  display: none; }\n\n.pswp__element--disabled {\n  display: none !important; }\n\n.pswp--minimal--dark .pswp__top-bar {\n  background: none; }\n", ""]);

	// exports


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAABYCAQAAACjBqE3AAAB6klEQVR4Ae3bsWpUQRTG8YkkanwCa7GzVotsI/gEgk9h4Vu4ySLYmMYgbJrc3lrwZbJwC0FMt4j7F6Y4oIZrsXtgxvx/1c0ufEX4cnbmLCmSJEmSJEmSJEmSJP3XCBPvbJU+8doWmDFwyZpLBmYlNJebz0KwzykwsuSYJSNwykEJreV2BaBMaLIQZ2xYcFgqDlmw4ayE/FwL0dDk4Qh4W37DAjgqIT+3HRbigjH+iikVdxgZStgyN0Su2sXIeTwTT+esdpcbIlfNAuZ/TxresG4zV8kYWSZNiKUTokMMSWeIwTNEn4fK2TW3gRNgVkJLuVksROA9G+bEvoATNlBCa7nZXEwdxEZxzpKRKFh+bsv8LmPFmhX1OwfIz81jIRJQ5eeqG9B+riRJkiRJkiRJkiRJkiRJkiRJUkvA/8RQoEpKlJWINFkJ62AlrEP/mNBibnv2yz/A3t7Uq3LcpoxP8COjC1T5vxoAD5VdoEqdDrd5QuW1swtUSaueh3zkiuBiqgtA2OlkeMcP/uDqugsJdbjHF65VdPMKwS0+WQc/MgKvrIOHysB9vgPwk8+85hmPbnQdvHZyDMAFD7L3EOpgMcVdvnHFS0/vlatrXvCVx0U9gt3fxvnA0/hB4nmRJEmSJEmSJEmSJGmHfgFLaDPoMu5xWwAAAABJRU5ErkJggg=="

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhFAAUAPMIAIeHhz8/P1dXVycnJ8/Pz7e3t5+fn29vb////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwAAAAAFAAUAEAEUxDJSatFxtwaggWAdIyHJAhXoRYSQUhDPGx0TbmujahbXGWZWqdDAYEsp5NupLPkdDwE7oXwWVasimzWrAE1tKFHErQRK8eL8mMUlRBJVI307uoiACH5BAUHAAgALAEAAQASABIAAAROEMkpS6E4W5upMdUmEQT2feFIltMJYivbvhnZ3R0A4NMwIDodz+cL7nDEn5CH8DGZh8MtEMBEoxkqlXKVIgQCibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpjaE4W5spANUmFQX2feFIltMJYivbvhnZ3d1x4BNBIDodz+cL7nDEn5CH8DGZAsFtMMBEoxkqlXKVIgIBibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpAaA4W5vpOdUmGQb2feFIltMJYivbvhnZ3Z0g4FNRIDodz+cL7nDEn5CH8DGZgcCNQMBEoxkqlXKVIgYDibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpz6E4W5upENUmAQD2feFIltMJYivbvhnZ3V0Q4JNhIDodz+cL7nDEn5CH8DGZg8GtUMBEoxkqlXKVIggEibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkphaA4W5tpCNUmHQf2feFIltMJYivbvhnZ3d0w4BMAIDodz+cL7nDEn5CH8DGZBMLNYMBEoxkqlXKVIgoFibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpQ6A4W5vpGNUmCQL2feFIltMJYivbvhnZ3R1B4NNxIDodz+cL7nDEn5CH8DGZhcINAMBEoxkqlXKVIgwGibbK9YLBYvLtHH5K0J0IACH5BAUHAAcALAEAAQASABIAAANCeLo6wzA6FxkhbaoQ4L3ZxnXLh0EjWZ4RV71VUcCLIByyTNt2PsO8m452sBGJBsNxkUwuD03lAQBASqnUJ7aq5UYSADs="

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _assign = __webpack_require__(406);

	var _assign2 = _interopRequireDefault(_assign);

	var _photoswipe = __webpack_require__(407);

	var _photoswipe2 = _interopRequireDefault(_photoswipe);

	var _photoswipeUiDefault = __webpack_require__(408);

	var _photoswipeUiDefault2 = _interopRequireDefault(_photoswipeUiDefault);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  methods: {
	    init: function init(index) {
	      var _this = this;

	      var options = (0, _assign2.default)({
	        history: false,
	        shareEl: false,
	        tapToClose: true,
	        index: index
	      }, this.options);
	      this.photoswipe = new _photoswipe2.default(this.$el, _photoswipeUiDefault2.default, this.list, options);
	      this.photoswipe.init();
	      this.photoswipe.listen('close', function () {
	        _this.$emit('on-close');
	      });
	    },
	    show: function show(index) {
	      this.init(index);
	    },
	    close: function close() {
	      this.photoswipe.close();
	    }
	  },
	  props: {
	    list: {
	      type: Array,
	      required: true
	    },
	    index: {
	      type: Number,
	      default: 0
	    },
	    options: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/object/assign");

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	module.exports = require("photoswipe/dist/photoswipe");

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	module.exports = require("photoswipe/dist/photoswipe-ui-default");

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pswp vux-previewer",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "pswp__bg"
	  }), _c('div', {
	    staticClass: "pswp__scroll-wrap"
	  }, [_c('div', {
	    staticClass: "pswp__container"
	  }, [_c('div', {
	    staticClass: "pswp__item"
	  }), _c('div', {
	    staticClass: "pswp__item"
	  }), _c('div', {
	    staticClass: "pswp__item"
	  })]), _c('div', {
	    staticClass: "pswp__ui pswp__ui--hidden"
	  }, [_c('div', {
	    staticClass: "pswp__top-bar"
	  }, [_c('div', {
	    staticClass: "pswp__counter"
	  }), _c('button', {
	    staticClass: "pswp__button pswp__button--close",
	    attrs: {
	      "title": "Close (Esc)"
	    }
	  }), _c('button', {
	    staticClass: "pswp__button pswp__button--share",
	    attrs: {
	      "title": "Share"
	    }
	  }), _c('button', {
	    staticClass: "pswp__button pswp__button--fs",
	    attrs: {
	      "title": "Toggle fullscreen"
	    }
	  }), _c('button', {
	    staticClass: "pswp__button pswp__button--zoom",
	    attrs: {
	      "title": "Zoom in/out"
	    }
	  }), _c('div', {
	    staticClass: "pswp__preloader"
	  }, [_c('div', {
	    staticClass: "pswp__preloader__icn"
	  }, [_c('div', {
	    staticClass: "pswp__preloader__cut"
	  }, [_c('div', {
	    staticClass: "pswp__preloader__donut"
	  })])])])]), _c('div', {
	    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
	  }, [_c('div', {
	    staticClass: "pswp__share-tooltip"
	  })]), _c('button', {
	    staticClass: "pswp__button pswp__button--arrow--left",
	    attrs: {
	      "title": "Previous (arrow left)"
	    }
	  }), _c('button', {
	    staticClass: "pswp__button pswp__button--arrow--right",
	    attrs: {
	      "title": "Next (arrow right)"
	    }
	  }), _c('div', {
	    staticClass: "pswp__caption"
	  }, [_c('div', {
	    staticClass: "pswp__caption__center"
	  })])])])])
	}]}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _numberRoller = __webpack_require__(411);

	var _numberRoller2 = _interopRequireDefault(_numberRoller);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_numberRoller2.default.install = function (Vue) {
	  Vue.component('LxNumberRoller', _numberRoller2.default);
	};

	exports.default = _numberRoller2.default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(412),
	  /* template */
	  __webpack_require__(414),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lib = __webpack_require__(413);

	var _lib2 = _interopRequireDefault(_lib);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    number: Number,
	    width: {
	      type: Number,
	      default: 3
	    }
	  },
	  mounted: function mounted() {
	    this._roller = new _lib2.default({
	      container: this.$el,
	      width: this.width
	    });
	    this._roller.roll(this.number);
	  },

	  watch: {
	    number: function number(newVal, oldVal) {
	      if (newVal.toString().length !== oldVal.toString().length) {
	        this._roller.width = newVal.toString().length;
	        this._roller.setWidth();
	      }
	      this._roller.roll(newVal);
	    }
	  }
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(184);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(185);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var isServer = typeof window === 'undefined';
	var Roller = function () {
	  function Roller(opts) {
	    (0, _classCallCheck3.default)(this, Roller);

	    if (isServer) return;
	    this.container = typeof opts.container === 'string' ? document.querySelector(opts.container) : opts.container;
	    this.width = opts.width || 1;
	    if (!this.container) {
	      throw Error('no container');
	    }
	    this.container.style.overflow = 'hidden';
	    this.rollHeight = parseInt(window.getComputedStyle(this.container).height);

	    if (this.rollHeight < 1) {
	      this.container.style.height = '20px';
	      this.rollHeight = 20;
	    }
	    this.setWidth();
	  }

	  (0, _createClass3.default)(Roller, [{
	    key: 'roll',
	    value: function roll(n) {
	      if (isServer) return;
	      var self = this;
	      this.number = parseInt(n) + '';
	      if (this.number.length < this.width) {
	        this.number = new Array(this.width - this.number.length + 1).join('0') + this.number;
	      } else if (this.number.length > this.width) {
	        this.width = this.number.length;
	        this.setWidth();
	      }
	      Array.prototype.forEach.call(this.container.querySelectorAll('.num'), function (item, i) {
	        if (isServer) return;
	        var currentNum = parseInt(item.querySelector('div:last-child').innerHTML);
	        var goalNum = parseInt(self.number[i]);
	        var gapNum = 0;
	        var gapStr = '';
	        if (currentNum === goalNum) {
	          return;
	        } else if (currentNum < goalNum) {
	          gapNum = goalNum - currentNum;
	          for (var j = currentNum; j < goalNum + 1; j++) {
	            gapStr += '<div>' + j + '</div>';
	          }
	        } else {
	          gapNum = 10 - currentNum + goalNum;
	          for (var _j = currentNum; _j < 10; _j++) {
	            gapStr += '<div>' + _j + '</div>';
	          }
	          for (var _j2 = 0; _j2 < goalNum + 1; _j2++) {
	            gapStr += '<div>' + _j2 + '</div>';
	          }
	        }
	        item.style.cssText += '-webkit-transition-duration:0;s-webkit-transform:translateY(0)';
	        item.innerHTML = gapStr;
	        var time = gapNum * (1 / 9);
	        setTimeout(function () {
	          item.style.cssText += '-webkit-transition-duration:' + time + 's;-webkit-transform:translateY(-' + self.rollHeight * gapNum + 'px)';
	        }, 50);
	      });
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(n) {
	      if (isServer) return;
	      n = n || this.width;
	      var str = '';
	      for (var i = 0; i < n; i++) {
	        str += '<div class="num" style="float:left;height:100%;line-height:' + this.rollHeight + 'px"><div>0</div></div>';
	      }
	      this.container.innerHTML = str;
	    }
	  }]);
	  return Roller;
	}();

	exports.default = Roller;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "height": "100px",
	      "font-size": "100px"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _viewBox = __webpack_require__(416);

	var _viewBox2 = _interopRequireDefault(_viewBox);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_viewBox2.default.install = function (Vue) {
	  Vue.component('LxViewBox', _viewBox2.default);
	};

	exports.default = _viewBox2.default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(417)

	var Component = __webpack_require__(79)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(419),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(418);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1a5d091c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./view-box.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1a5d091c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./view-box.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* @vux Copy weui_tab.less and Remove navbar\n*/\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n.weui_tabbar {\n  display: flex;\n  position: absolute;\n  z-index: 100;\n  bottom: 0;\n  width: 100%;\n  background-color: #f7f7fa;\n}\n.weui_tabbar:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #979797;\n  color: #979797;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_tabbar_item {\n  display: block;\n  flex: 1;\n  padding: 7px 0 0;\n  -webkit-tap-highlight-color: transparent;\n}\n.weui_tabbar_item.weui_bar_item_on .weui_tabbar_label {\n  color: #09BB07;\n}\n.weui_tabbar_icon {\n  margin: 0 auto;\n  width: 24px;\n  height: 24px;\n}\n.weui_tabbar_icon img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.weui_tabbar_icon + .weui_tabbar_label {\n  margin-top: 5px;\n}\n.weui_tabbar_label {\n  text-align: center;\n  color: #888;\n  font-size: 12px;\n}\n.weui_tab {\n  position: relative;\n  height: 100%;\n}\n.weui_tab_bd {\n  box-sizing: border-box;\n  height: 100%;\n  padding-bottom: 55px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.weui_tab_bd_item {\n  display: none;\n}\n.weui_tab_bd_item_active {\n  display: block;\n}\n", ""]);

	// exports


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_tab"
	  }, [_vm._t("header"), _c('div', {
	    staticClass: "weui_tab_bd vux-fix-safari-overflow-scrolling",
	    attrs: {
	      "ref:view-box-body": ""
	    }
	  }, [_vm._t("default")], 2), _vm._t("bottom")], 2)
	},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _verifyCode = __webpack_require__(421);

	var _verifyCode2 = _interopRequireDefault(_verifyCode);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_verifyCode2.default.install = function (Vue) {
	  Vue.component('LxVerifyCode', _verifyCode2.default);
	};

	exports.default = _verifyCode2.default;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(422)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(424),
	  /* template */
	  __webpack_require__(425),
	  /* scopeId */
	  "data-v-132bbb40",
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(423);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-132bbb40&scoped=true!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./verify-code.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-132bbb40&scoped=true!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./verify-code.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_toast[data-v-132bbb40] {\n  position: fixed;\n  z-index: 50000;\n  width: 3.25333333rem;\n  min-height: 3.25333333rem;\n  top: 4.8rem;\n  left: 50%;\n  margin-left: -0.81333333rem;\n  background: rgba(40, 40, 40, 0.75);\n  text-align: center;\n  border-radius: 5px;\n  color: #FFFFFF;\n}\n.weui_icon_toast[data-v-132bbb40] {\n  margin: 0.58666667rem 0 0;\n  display: block;\n}\n.weui_icon_toast[data-v-132bbb40]:before {\n  content: '\\EA08';\n  color: #FFFFFF;\n  font-size: 1.46666667rem;\n}\n.weui_toast_content[data-v-132bbb40] {\n  margin: 0 0 0.4rem;\n}\n.weui_loading_toast .weui_toast_content[data-v-132bbb40] {\n  margin-top: 64%;\n  font-size: 0.37333333rem;\n}\n.weui_loading[data-v-132bbb40] {\n  position: absolute;\n  width: 0px;\n  z-index: 1;\n  left: 50%;\n  top: 38%;\n}\n.weui_loading_leaf[data-v-132bbb40] {\n  position: absolute;\n  top: -1px;\n  opacity: 0.25;\n}\n.weui_loading_leaf[data-v-132bbb40]:before {\n  content: \" \";\n  position: absolute;\n  width: 0.1104rem;\n  height: 0.05546667rem;\n  background: #d1d1d5;\n  box-shadow: rgba(0, 0, 0, 0.0980392) 0px 0px 1px;\n  border-radius: 1px;\n  transform-origin: left 50% 0px;\n}\n.weui_loading_leaf_0[data-v-132bbb40] {\n  animation: opacity-60-25-0-12 1.25s linear infinite;\n}\n.weui_loading_leaf_0[data-v-132bbb40]:before {\n  transform: rotate(0deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_1[data-v-132bbb40] {\n  animation: opacity-60-25-1-12 1.25s linear infinite;\n}\n.weui_loading_leaf_1[data-v-132bbb40]:before {\n  transform: rotate(30deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_2[data-v-132bbb40] {\n  animation: opacity-60-25-2-12 1.25s linear infinite;\n}\n.weui_loading_leaf_2[data-v-132bbb40]:before {\n  transform: rotate(60deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_3[data-v-132bbb40] {\n  animation: opacity-60-25-3-12 1.25s linear infinite;\n}\n.weui_loading_leaf_3[data-v-132bbb40]:before {\n  transform: rotate(90deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_4[data-v-132bbb40] {\n  animation: opacity-60-25-4-12 1.25s linear infinite;\n}\n.weui_loading_leaf_4[data-v-132bbb40]:before {\n  transform: rotate(120deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_5[data-v-132bbb40] {\n  animation: opacity-60-25-5-12 1.25s linear infinite;\n}\n.weui_loading_leaf_5[data-v-132bbb40]:before {\n  transform: rotate(150deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_6[data-v-132bbb40] {\n  animation: opacity-60-25-6-12 1.25s linear infinite;\n}\n.weui_loading_leaf_6[data-v-132bbb40]:before {\n  transform: rotate(180deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_7[data-v-132bbb40] {\n  animation: opacity-60-25-7-12 1.25s linear infinite;\n}\n.weui_loading_leaf_7[data-v-132bbb40]:before {\n  transform: rotate(210deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_8[data-v-132bbb40] {\n  animation: opacity-60-25-8-12 1.25s linear infinite;\n}\n.weui_loading_leaf_8[data-v-132bbb40]:before {\n  transform: rotate(240deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_9[data-v-132bbb40] {\n  animation: opacity-60-25-9-12 1.25s linear infinite;\n}\n.weui_loading_leaf_9[data-v-132bbb40]:before {\n  transform: rotate(270deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_10[data-v-132bbb40] {\n  animation: opacity-60-25-10-12 1.25s linear infinite;\n}\n.weui_loading_leaf_10[data-v-132bbb40]:before {\n  transform: rotate(300deg) translate(0.09333333rem, 0px);\n}\n.weui_loading_leaf_11[data-v-132bbb40] {\n  animation: opacity-60-25-11-12 1.25s linear infinite;\n}\n.weui_loading_leaf_11[data-v-132bbb40]:before {\n  transform: rotate(330deg) translate(0.09333333rem, 0px);\n}\n@-webkit-keyframes opacity-60-25-0-12 {\n0% {\n    opacity: 0.25;\n}\n0.01% {\n    opacity: 0.25;\n}\n0.02% {\n    opacity: 1;\n}\n60.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-0-12 {\n0% {\n    opacity: 0.25;\n}\n0.01% {\n    opacity: 0.25;\n}\n0.02% {\n    opacity: 1;\n}\n60.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-1-12 {\n0% {\n    opacity: 0.25;\n}\n8.34333% {\n    opacity: 0.25;\n}\n8.35333% {\n    opacity: 1;\n}\n68.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-1-12 {\n0% {\n    opacity: 0.25;\n}\n8.34333% {\n    opacity: 0.25;\n}\n8.35333% {\n    opacity: 1;\n}\n68.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-2-12 {\n0% {\n    opacity: 0.25;\n}\n16.6767% {\n    opacity: 0.25;\n}\n16.6867% {\n    opacity: 1;\n}\n76.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-2-12 {\n0% {\n    opacity: 0.25;\n}\n16.6767% {\n    opacity: 0.25;\n}\n16.6867% {\n    opacity: 1;\n}\n76.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-3-12 {\n0% {\n    opacity: 0.25;\n}\n25.01% {\n    opacity: 0.25;\n}\n25.02% {\n    opacity: 1;\n}\n85.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-3-12 {\n0% {\n    opacity: 0.25;\n}\n25.01% {\n    opacity: 0.25;\n}\n25.02% {\n    opacity: 1;\n}\n85.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-4-12 {\n0% {\n    opacity: 0.25;\n}\n33.3433% {\n    opacity: 0.25;\n}\n33.3533% {\n    opacity: 1;\n}\n93.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@keyframes opacity-60-25-4-12 {\n0% {\n    opacity: 0.25;\n}\n33.3433% {\n    opacity: 0.25;\n}\n33.3533% {\n    opacity: 1;\n}\n93.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.25;\n}\n}\n@-webkit-keyframes opacity-60-25-5-12 {\n0% {\n    opacity: 0.270958333333333;\n}\n41.6767% {\n    opacity: 0.25;\n}\n41.6867% {\n    opacity: 1;\n}\n1.67667% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.270958333333333;\n}\n}\n@keyframes opacity-60-25-5-12 {\n0% {\n    opacity: 0.270958333333333;\n}\n41.6767% {\n    opacity: 0.25;\n}\n41.6867% {\n    opacity: 1;\n}\n1.67667% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.270958333333333;\n}\n}\n@-webkit-keyframes opacity-60-25-6-12 {\n0% {\n    opacity: 0.375125;\n}\n50.01% {\n    opacity: 0.25;\n}\n50.02% {\n    opacity: 1;\n}\n10.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.375125;\n}\n}\n@keyframes opacity-60-25-6-12 {\n0% {\n    opacity: 0.375125;\n}\n50.01% {\n    opacity: 0.25;\n}\n50.02% {\n    opacity: 1;\n}\n10.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.375125;\n}\n}\n@-webkit-keyframes opacity-60-25-7-12 {\n0% {\n    opacity: 0.479291666666667;\n}\n58.3433% {\n    opacity: 0.25;\n}\n58.3533% {\n    opacity: 1;\n}\n18.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.479291666666667;\n}\n}\n@keyframes opacity-60-25-7-12 {\n0% {\n    opacity: 0.479291666666667;\n}\n58.3433% {\n    opacity: 0.25;\n}\n58.3533% {\n    opacity: 1;\n}\n18.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.479291666666667;\n}\n}\n@-webkit-keyframes opacity-60-25-8-12 {\n0% {\n    opacity: 0.583458333333333;\n}\n66.6767% {\n    opacity: 0.25;\n}\n66.6867% {\n    opacity: 1;\n}\n26.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.583458333333333;\n}\n}\n@keyframes opacity-60-25-8-12 {\n0% {\n    opacity: 0.583458333333333;\n}\n66.6767% {\n    opacity: 0.25;\n}\n66.6867% {\n    opacity: 1;\n}\n26.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.583458333333333;\n}\n}\n@-webkit-keyframes opacity-60-25-9-12 {\n0% {\n    opacity: 0.687625;\n}\n75.01% {\n    opacity: 0.25;\n}\n75.02% {\n    opacity: 1;\n}\n35.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.687625;\n}\n}\n@keyframes opacity-60-25-9-12 {\n0% {\n    opacity: 0.687625;\n}\n75.01% {\n    opacity: 0.25;\n}\n75.02% {\n    opacity: 1;\n}\n35.01% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.687625;\n}\n}\n@-webkit-keyframes opacity-60-25-10-12 {\n0% {\n    opacity: 0.791791666666667;\n}\n83.3433% {\n    opacity: 0.25;\n}\n83.3533% {\n    opacity: 1;\n}\n43.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.791791666666667;\n}\n}\n@keyframes opacity-60-25-10-12 {\n0% {\n    opacity: 0.791791666666667;\n}\n83.3433% {\n    opacity: 0.25;\n}\n83.3533% {\n    opacity: 1;\n}\n43.3433% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.791791666666667;\n}\n}\n@-webkit-keyframes opacity-60-25-11-12 {\n0% {\n    opacity: 0.895958333333333;\n}\n91.6767% {\n    opacity: 0.25;\n}\n91.6867% {\n    opacity: 1;\n}\n51.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.895958333333333;\n}\n}\n@keyframes opacity-60-25-11-12 {\n0% {\n    opacity: 0.895958333333333;\n}\n91.6767% {\n    opacity: 0.25;\n}\n91.6867% {\n    opacity: 1;\n}\n51.6767% {\n    opacity: 0.25;\n}\n100% {\n    opacity: 0.895958333333333;\n}\n}\n.verifyCode[data-v-132bbb40] {\n  position: absolute;\n  top: 2rem;\n  right: 0.4rem;\n  -webkit-appearance: none;\n  appearance: none;\n  font-size: 0.34666667rem;\n  line-height: 0.70666667rem;\n  padding: 0 0.4rem;\n  text-align: center;\n  background: #fff;\n  color: #5890FF;\n  border: 1px solid #5890FF;\n  border-radius: 0.10666667rem;\n}\n.weui_loading_leaf[data-v-132bbb40] {\n  position: absolute;\n  top: 45%;\n  left: 0.2rem;\n}\n", ""]);

	// exports


/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: Object,
	      default: {
	        show: false,
	        time: 60,
	        start: false,
	        codeText: ''
	      }
	    }
	  },
	  methods: {
	    getCode: function getCode() {
	      if (this.interval !== null) {
	        return false;
	      }
	      this.$emit('on-getCode');
	    },
	    tick: function tick() {
	      var _this = this;

	      var seconds = this.time;
	      this.show = false;
	      this.codeText = '\u5269\u4F59: ' + seconds + ' \u79D2';
	      this.interval = setInterval(function () {
	        if (seconds-- > 0) {
	          _this.codeText = '\u5269\u4F59: ' + seconds + ' \u79D2';
	        } else {
	          _this.stop();
	        }
	      }, 1000);
	    },
	    stop: function stop() {
	      this.codeText = this.text;
	      clearInterval(this.interval);
	      this.interval = null;
	      this.start = false;
	    }
	  },
	  watch: {
	    'value.show': function valueShow(val) {
	      this.show = val;
	    },
	    'value.time': function valueTime(val) {
	      this.time = val;
	    },
	    'value.start': function valueStart(val) {
	      this.start = val;
	    },
	    'value.codeText': function valueCodeText(val) {
	      this.codeText = val;
	    },
	    show: function show(val) {
	      var options = {
	        show: val,
	        time: this.time,
	        start: this.start,
	        codeText: this.codeText
	      };
	      this.$emit('input', options);
	    },
	    codeText: function codeText(val) {
	      var options = {
	        show: this.show,
	        time: this.time,
	        start: this.start,
	        codeText: val
	      };
	      this.$emit('input', options);
	    },
	    time: function time(val) {
	      var options = {
	        show: this.show,
	        time: val,
	        start: this.start,
	        codeText: this.codeText
	      };
	      this.$emit('input', options);
	    },
	    start: function start(newVal, oldVal) {
	      if (newVal === true && oldVal === false && this.time > 0) {
	        this.tick();
	      }
	      if (newVal === false && oldVal === true) {
	        this.stop();
	      }
	      var options = {
	        show: this.show,
	        time: this.time,
	        start: newVal,
	        codeText: this.codeText
	      };
	      this.$emit('input', options);
	    }
	  },
	  created: function created() {
	    this.show = this.value.show;
	    this.time = this.value.time;
	    this.start = this.value.start;
	    this.text = this.codeText = this.value.codeText;
	    if (this.start) {
	      this.tick();
	    }
	  },
	  data: function data() {
	    return {
	      show: false,
	      interval: null,
	      time: 60,
	      start: false,
	      codeText: '',
	      text: ''
	    };
	  }
	};

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "verifyCode",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.getCode($event)
	      }
	    }
	  }, [_vm._l((12), function(i) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.show),
	        expression: "show"
	      }],
	      staticClass: "weui_loading_leaf",
	      class: ['weui_loading_leaf_' + (i - 1)]
	    })
	  }), _c('span', [_vm._v(_vm._s(_vm.codeText))])], 2)
	},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _buttonTab = __webpack_require__(427);

	var _buttonTab2 = _interopRequireDefault(_buttonTab);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_buttonTab2.default.install = function (Vue) {
	  Vue.component('LxButtonTab', _buttonTab2.default);
	};

	exports.default = _buttonTab2.default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(428)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(430),
	  /* template */
	  __webpack_require__(432),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(429);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f026a188!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./button-tab.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f026a188!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./button-tab.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n.vux-button-group {\n  display: flex;\n}\n.vux-button-group > a {\n  display: block;\n  flex: 1;\n  width: 100%;\n  height: 30px;\n  padding: 0;\n  font-size: 14px;\n  line-height: 31px;\n  text-align: center;\n  border: 1px solid #d2d2d2;\n  border-width: 1px 1px 1px 0;\n  color: #999;\n  white-space: nowrap;\n  background: #fdfdfd;\n}\n.vux-button-group > a.vux-button-group-current,\n.vux-button-group > a.hover,\n.vux-button-group > a:active {\n  border-color: #5890ff;\n  color: #FFF;\n  background: #5890ff;\n}\n.vux-button-group > a:first-child {\n  border-width: 1px;\n  background-clip: padding-box;\n}\n.vux-button-group > a:last-child {\n  background-clip: padding-box;\n}\n.vux-button-group > a.vux-button-group-current:disabled,\n.vux-button-group > a:disabled {\n  border-color: #CDCDCD;\n  background: #e5e5e5;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);\n  color: #aaa;\n}\n.vux-button-group .no-border-right {\n  border-right-width: 0!important;\n}\n", ""]);

	// exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _multiItems = __webpack_require__(431);

	exports.default = {
	  mixins: [_multiItems.parentMixin],
	  props: {
	    height: Number
	  }
	};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.childMixin = exports.parentMixin = undefined;

	var _router = __webpack_require__(123);

	var parentMixin = {
	  mounted: function mounted() {
	    if (this.value >= 0) {
	      this.currentIndex = this.value;
	    }
	    this.updateIndex();
	  },

	  methods: {
	    updateIndex: function updateIndex() {
	      if (!this.$children || !this.$children.length) return;
	      this.number = this.$children.length;
	      var children = this.$children;
	      for (var i = 0; i < children.length; i++) {
	        children[i].currentIndex = i;
	        if (children[i].currentSelected) {
	          this.index = i;
	        }
	      }
	    }
	  },
	  props: {
	    value: Number
	  },
	  watch: {
	    currentIndex: function currentIndex(val, oldVal) {
	      oldVal > -1 && this.$children[oldVal] && (this.$children[oldVal].currentSelected = false);
	      val > -1 && this.$children[val] && (this.$children[val].currentSelected = true);
	      this.$emit('input', val);
	      this.$emit('on-index-change', val, oldVal);
	    },
	    index: function index(val) {
	      this.currentIndex = val;
	    },
	    value: function value(val) {
	      this.index = val;
	    }
	  },
	  data: function data() {
	    return {
	      index: -1,
	      currentIndex: this.index,
	      number: this.$children.length
	    };
	  }
	};

	var childMixin = {
	  props: {
	    selected: {
	      type: Boolean,
	      default: false
	    }
	  },
	  mounted: function mounted() {
	    this.$parent.updateIndex();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var $parent = this.$parent;
	    this.$nextTick(function () {
	      $parent.updateIndex();
	    });
	  },

	  methods: {
	    onItemClick: function onItemClick(hasLink) {
	      var _this = this;

	      if (typeof this.disabled === 'undefined' || this.disabled === false) {
	        this.currentSelected = true;
	        this.$parent.currentIndex = this.currentIndex;
	        this.$nextTick(function () {
	          _this.$emit('on-item-click');
	        });
	      }
	      if (hasLink === true) {
	        (0, _router.go)(this.link, this.$router);
	      }
	    }
	  },
	  watch: {
	    currentSelected: function currentSelected(val) {
	      if (val) {
	        this.$parent.index = this.currentIndex;
	      }
	    },
	    selected: function selected(val) {
	      this.currentSelected = val;
	    }
	  },
	  data: function data() {
	    return {
	      currentIndex: -1,
	      currentSelected: this.selected
	    };
	  }
	};

	exports.parentMixin = parentMixin;
	exports.childMixin = childMixin;

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-button-group"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _buttonTabItem = __webpack_require__(434);

	var _buttonTabItem2 = _interopRequireDefault(_buttonTabItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_buttonTabItem2.default.install = function (Vue) {
	  Vue.component('LxButtonTabItem', _buttonTabItem2.default);
	};

	exports.default = _buttonTabItem2.default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(435)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(437),
	  /* template */
	  __webpack_require__(438),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(436);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-21cd85ca!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./button-tab-item.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-21cd85ca!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./button-tab-item.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

	// exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _multiItems = __webpack_require__(431);

	exports.default = {
	  mixins: [_multiItems.childMixin],
	  computed: {
	    classes: function classes() {
	      return {
	        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
	        'no-border-right': this.shouldRemoveBorder
	      };
	    },
	    style: function style() {
	      if (this.$parent.height) {
	        return {
	          height: this.$parent.height + 'px',
	          lineHeight: this.$parent.height + 'px'
	        };
	      }
	    }
	  },
	  data: function data() {
	    return {
	      shouldRemoveBorder: false
	    };
	  }
	};

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "vux-button-tab-item",
	    class: _vm.classes,
	    style: (_vm.style),
	    attrs: {
	      "href": "javascript:"
	    },
	    on: {
	      "click": _vm.onItemClick
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _checker = __webpack_require__(440);

	var _checker2 = _interopRequireDefault(_checker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_checker2.default.install = function (Vue) {
	  Vue.component('LxChecker', _checker2.default);
	};

	exports.default = _checker2.default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(441)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(443),
	  /* template */
	  __webpack_require__(444),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(442);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3f4f69b0!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checker.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3f4f69b0!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-checker-item {\r\n  display: inline-block;\n}\r\n", ""]);

	// exports


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    defaultItemClass: String,
	    selectedItemClass: String,
	    disabledItemClass: String,
	    type: {
	      type: String,
	      default: 'radio'
	    },
	    value: [String, Number, Array, Boolean],
	    max: Number
	  },
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },

	  watch: {
	    currentValue: function currentValue(newValue) {
	      this.$emit('on-change', newValue);
	      this.$emit('input', newValue);
	    },
	    value: function value(newValue) {
	      this.currentValue = newValue;
	    }
	  }
	};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-checker-box"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _checkerItem = __webpack_require__(446);

	var _checkerItem2 = _interopRequireDefault(_checkerItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_checkerItem2.default.install = function (Vue) {
	  Vue.component('LxCheckerItem', _checkerItem2.default);
	};

	exports.default = _checkerItem2.default;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(447)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(449),
	  /* template */
	  __webpack_require__(450),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(448);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-54d329c8!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checker-item.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-54d329c8!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checker-item.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-tap-active {\n  tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.vux-tap-active:active {\n  background-color: #ECECEC;\n}\n", ""]);

	// exports


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: [String, Number, Boolean],
	      required: true
	    },
	    disabled: Boolean
	  },
	  computed: {
	    classNames: function classNames() {
	      var names = {
	        'vux-tap-active': !this.disabled
	      };
	      if (this.$parent.defaultItemClass) {
	        names[this.$parent.defaultItemClass] = true;
	      }
	      if (this.$parent.selectedItemClass) {
	        names[this.$parent.selectedItemClass] = this.$parent.type === 'radio' ? this.$parent.currentValue === this.value : this.$parent.currentValue.indexOf(this.value) > -1;
	      }
	      if (this.$parent.disabledItemClass) {
	        names[this.$parent.disabledItemClass] = this.disabled;
	      }
	      return names;
	    }
	  },
	  methods: {
	    select: function select() {
	      if (this.$parent.type === 'radio') {
	        this.selectRadio();
	      } else {
	        this.selectCheckbox();
	      }
	    },
	    selectRadio: function selectRadio() {
	      if (!this.disabled) {
	        this.$set(this.$parent, 'currentValue', this.value);
	        this.$emit('on-item-click', this.value, this.disabled);
	      }
	    },
	    selectCheckbox: function selectCheckbox() {
	      if (!this.disabled) {
	        var index = this.$parent.currentValue.indexOf(this.value);
	        if (index > -1) {
	          this.$parent.value.splice(index, 1);
	        } else {
	          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue.length < this.$parent.max) {
	            this.$parent.currentValue.push(this.value);
	          }
	        }
	        this.$emit('on-item-click', this.value, this.disabled);
	      }
	    }
	  }
	};

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-checker-item",
	    class: _vm.classNames,
	    on: {
	      "click": _vm.select
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _tabbar = __webpack_require__(452);

	var _tabbar2 = _interopRequireDefault(_tabbar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_tabbar2.default.install = function (Vue) {
	  Vue.component('LxTabbar', _tabbar2.default);
	};

	exports.default = _tabbar2.default;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(453)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(455),
	  /* template */
	  __webpack_require__(456),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(454);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c8032388!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tabbar.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c8032388!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tabbar.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/**\n* @vux Copy weui_tab.less and Remove navbar\n*/\n/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.weui_tabbar {\n  display: flex;\n  position: absolute;\n  z-index: 100;\n  bottom: 0;\n  width: 100%;\n  background-color: #f7f7fa;\n}\n.weui_tabbar:before {\n  content: \" \";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  border-top: 1px solid #979797;\n  color: #979797;\n  transform-origin: 0 0;\n  transform: scaleY(0.5);\n}\n.weui_tabbar_item {\n  display: block;\n  flex: 1;\n  padding: 0.18666667rem 0 0;\n  -webkit-tap-highlight-color: transparent;\n}\n.weui_tabbar_item.weui_bar_item_on .weui_tabbar_label {\n  color: #09BB07;\n}\n.weui_tabbar_icon {\n  margin: 0 auto;\n  width: 0.64rem;\n  height: 0.64rem;\n}\n.weui_tabbar_icon img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.weui_tabbar_icon + .weui_tabbar_label {\n  margin-top: 0.13333333rem;\n}\n.weui_tabbar_label {\n  text-align: center;\n  color: #000;\n  font-size: 0.32rem;\n}\n.weui_tab {\n  position: relative;\n  height: 100%;\n}\n.weui_tab_bd {\n  box-sizing: border-box;\n  height: 100%;\n  padding-bottom: 1.46666667rem;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  font-size: 0.34666667rem;\n}\n.weui_tab_bd_item {\n  display: none;\n}\n.weui_tab_bd_item_active {\n  display: block;\n}\n.weui_tabbar_icon {\n  position: relative;\n}\n.weui_tabbar_icon > sup {\n  position: absolute;\n  top: -0.21333333rem;\n  left: 100%;\n  transform: translateX(-50%);\n  z-index: 101;\n}\n", ""]);

	// exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _multiItems = __webpack_require__(431);

	exports.default = {
	  name: 'Tabbar',
	  mixins: [_multiItems.parentMixin],
	  props: {
	    iconClass: String
	  }
	};

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_tabbar"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _tabbarItem = __webpack_require__(458);

	var _tabbarItem2 = _interopRequireDefault(_tabbarItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_tabbarItem2.default.install = function (Vue) {
	  Vue.component('LxTabbarItem', _tabbarItem2.default);
	};

	exports.default = _tabbarItem2.default;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(459)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(461),
	  /* template */
	  __webpack_require__(462),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(460);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d0a6ecfc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tabbar-item.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d0a6ecfc!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tabbar-item.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

	// exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _multiItems = __webpack_require__(431);

	var _badge = __webpack_require__(384);

	var _badge2 = _interopRequireDefault(_badge);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: 'TabbarItem',
	  components: {
	    Badge: _badge2.default
	  },
	  mixins: [_multiItems.childMixin],
	  props: {
	    showDot: {
	      type: Boolean,
	      default: false
	    },
	    badge: String,
	    link: [String, Object],
	    iconClass: String
	  }
	};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "weui_tabbar_item",
	    class: {
	      'weui_bar_item_on': _vm.$parent.currentIndex === _vm.currentIndex
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.onItemClick(true)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "weui_tabbar_icon",
	    class: [_vm.iconClass || _vm.$parent.iconClass, {
	      'vux-reddot': _vm.showDot
	    }]
	  }, [_vm._t("icon"), _c('sup', [(_vm.badge) ? _c('badge', {
	    attrs: {
	      "text": _vm.badge
	    }
	  }) : _vm._e()], 1)], 2), _c('p', {
	    staticClass: "weui_tabbar_label"
	  }, [_vm._t("label")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _tab = __webpack_require__(464);

	var _tab2 = _interopRequireDefault(_tab);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_tab2.default.install = function (Vue) {
	  Vue.component('LxTab', _tab2.default);
	};

	exports.default = _tab2.default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(465)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(467),
	  /* template */
	  __webpack_require__(468),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(466);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5d53ba30!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tab.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5d53ba30!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tab.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.vux-tab-ink-bar {\n  position: absolute;\n  height: 2px;\n  bottom: 0;\n  left: 0;\n}\n.vux-tab-ink-bar-transition-forward {\n  transition: right 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1) 0.09s;\n}\n.vux-tab-ink-bar-transition-backward {\n  transition: right 0.3s cubic-bezier(0.35, 0, 0.25, 1) 0.09s, left 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n}\n.vux-tab {\n  display: flex;\n  background-color: #fff;\n  height: 44px;\n  position: relative;\n}\n.vux-tab button {\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: 0 0;\n  appearance: none;\n}\n.vux-tab .vux-tab-item {\n  display: block;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  background: linear-gradient(180deg, #e5e5e5, #e5e5e5, rgba(229, 229, 229, 0)) bottom left no-repeat;\n  background-size: 100% 1px;\n  font-size: 14px;\n  text-align: center;\n  line-height: 44px;\n  color: #666;\n}\n.vux-tab .vux-tab-item.vux-tab-selected {\n  color: #04be02;\n  border-bottom: 3px solid #04be02;\n}\n.vux-tab.vux-tab-no-animate .vux-tab-item.vux-tab-selected {\n  background: 0 0;\n}\n", ""]);

	// exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _multiItems = __webpack_require__(431);

	exports.default = {
	  mixins: [_multiItems.parentMixin],
	  ready: function ready() {
	    var _this = this;

	    setTimeout(function () {
	      _this.hasReady = true;
	    }, 0);
	  },

	  props: {
	    lineWidth: {
	      type: Number,
	      default: 3
	    },
	    activeColor: {
	      type: String,
	      default: '#04be02'
	    },
	    defaultColor: {
	      type: String,
	      default: '#666'
	    },
	    disabledColor: {
	      type: String,
	      default: '#ddd'
	    },
	    animate: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    barLeft: function barLeft() {
	      return this.index * (100 / this.number) + '%';
	    },
	    barRight: function barRight() {
	      return (this.number - this.index - 1) * (100 / this.number) + '%';
	    },
	    barStyle: function barStyle() {
	      return {
	        left: this.barLeft,
	        right: this.barRight,
	        display: 'block',
	        backgroundColor: this.activeColor,
	        height: this.lineWidth + 'px',
	        transition: !this.hasReady ? 'none' : null
	      };
	    },
	    barClass: function barClass() {
	      return {
	        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
	        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
	      };
	    }
	  },
	  watch: {
	    index: function index(newIndex, oldIndex) {
	      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
	      this.$emit('on-index-change', newIndex, oldIndex);
	    }
	  },
	  data: function data() {
	    return {
	      direction: 'forward',
	      right: '100%',
	      hasReady: false
	    };
	  }
	};

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-tab",
	    class: {
	      'vux-tab-no-animate': !_vm.animate
	    }
	  }, [_vm._t("default"), (_vm.animate) ? _c('div', {
	    staticClass: "vux-tab-ink-bar",
	    class: _vm.barClass,
	    style: (_vm.barStyle)
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _tabItem = __webpack_require__(470);

	var _tabItem2 = _interopRequireDefault(_tabItem);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_tabItem2.default.install = function (Vue) {
	  Vue.component('LxTabItem', _tabItem2.default);
	};

	exports.default = _tabItem2.default;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(471)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(473),
	  /* template */
	  __webpack_require__(474),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(472);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b3f0b3c8!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tab-item.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b3f0b3c8!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tab-item.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

	// exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _multiItems = __webpack_require__(431);

	exports.default = {
	  mixins: [_multiItems.childMixin],
	  props: {
	    activeClass: String,
	    disabled: Boolean
	  },
	  computed: {
	    style: function style() {
	      return {
	        borderWidth: this.$parent.lineWidth + 'px',
	        borderColor: this.$parent.activeColor,
	        color: this.selected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
	        border: this.$parent.animate ? 'none' : 'auto'
	      };
	    }
	  }
	};

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-tab-item",
	    class: [_vm.selected ? _vm.activeClass : '', {
	      'vux-tab-selected': _vm.selected
	    }],
	    style: (_vm.style),
	    on: {
	      "click": _vm.onItemClick
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _keyboard = __webpack_require__(476);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_keyboard2.default.install = function (Vue) {
	  Vue.component('LxKeyboard', _keyboard2.default);
	};

	exports.default = _keyboard2.default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(477)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(479),
	  /* template */
	  __webpack_require__(483),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(478);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1029f59c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./keyboard.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1029f59c!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./keyboard.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.keyboard-content {\n  padding: 0.26666667rem 0.13333333rem 0.33333333rem;\n  background-color: #d1d6dc;\n}\n.keyboard-content .keyboard-list {\n  display: flex;\n  justify-content: center;\n}\n.keyboard-content .keyboard-list:not(:last-child) {\n  margin-bottom: 0.30666667rem;\n}\n.keyboard-content .keyboard-list li {\n  width: 0.85333333rem;\n  height: 1.2rem;\n  background-color: #ffffff;\n  box-shadow: 0px 0.02666667rem 0.10666667rem 0px rgba(101, 104, 107, 0.5), inset 0px -0.04rem 0px 0px rgba(209, 214, 220, 0.5);\n  border-radius: 0.10666667rem;\n  text-align: center;\n  line-height: 1.2rem;\n  list-style-type: none;\n  font-size: 15px;\n}\n.keyboard-content .keyboard-list li:not(:last-child) {\n  margin-right: 0.13333333rem;\n}\n.keyboard-content .keyboard-list li.end {\n  width: 1.84rem;\n  background-color: #5890ff;\n  color: #ffffff;\n}\n.keyboard-content .keyboard-list li.delete {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.keyboard-content .keyboard-list li .delete-icon {\n  display: block;\n  width: 0.58666667rem;\n  height: 0.53333333rem;\n}\n.keyboard-content .keyboard-list li.touch-start {\n  background-color: #8f969e;\n}\n", ""]);

	// exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _popup = __webpack_require__(235);

	var _popup2 = _interopRequireDefault(_popup);

	var _provinces_abbreviation = __webpack_require__(480);

	var _provinces_abbreviation2 = _interopRequireDefault(_provinces_abbreviation);

	var _alphanumeric = __webpack_require__(481);

	var _alphanumeric2 = _interopRequireDefault(_alphanumeric);

	var _dom = __webpack_require__(482);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    popup: _popup2.default
	  },
	  methods: {
	    clickKey: function clickKey(value, type) {
	      var _this = this;

	      if (type === 'provinces') {
	        this.isShow = false;
	      }
	      if (value === 'delete') {
	        this.$emit('handle-delete', value);
	      } else if (value === 'end') {
	        this.isShow = false;
	      } else {
	        this.$nextTick(function () {
	          _this.$emit('handle-value', value);
	        });
	      }
	    },
	    handleTouchStart: function handleTouchStart(value) {
	      this.currentTouchStart = value;
	    },
	    handleTouchEnd: function handleTouchEnd(value) {
	      this.currentTouchStart = '';
	    },
	    handleProvincesData: function handleProvincesData() {
	      var provincesArr = [];
	      provincesArr.push(_provinces_abbreviation2.default.slice(0, 10));
	      provincesArr.push(_provinces_abbreviation2.default.slice(10, 19));
	      provincesArr.push(_provinces_abbreviation2.default.slice(19, 26));
	      provincesArr.push(_provinces_abbreviation2.default.slice(26));
	      return provincesArr;
	    },
	    handleAlphanumericData: function handleAlphanumericData() {
	      var alphanumericArr = [];
	      alphanumericArr.push(_alphanumeric2.default.slice(0, 10));
	      alphanumericArr.push(_alphanumeric2.default.slice(10, 20));
	      alphanumericArr.push(_alphanumeric2.default.slice(20, 30));
	      alphanumericArr.push(_alphanumeric2.default.slice(30));
	      return alphanumericArr;
	    },
	    showItem: function showItem(value) {
	      if (value === 'delete') {
	        return '';
	      } else if (value === 'end') {
	        return '完成';
	      } else {
	        return value;
	      }
	    },
	    doToggle: function doToggle() {
	      this.isShow = !this.isShow;
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.$refs.reference;
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target)) return;
	      this.isShow = false;
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    var reference = this.$refs.reference;
	    (0, _dom.on)(reference, 'click', this.doToggle);
	    (0, _dom.on)(document, 'click', this.handleDocumentClick);
	  },
	  destroyed: function destroyed() {
	    var reference = this.$refs.reference;
	    (0, _dom.off)(reference, 'click', this.doToggle);
	    (0, _dom.off)(document, 'click', this.handleDocumentClick);
	  },

	  model: {
	    prop: 'show',
	    event: 'change'
	  },
	  props: {
	    type: {
	      type: String,
	      default: function _default() {
	        return 'provinces';
	      }
	    },
	    show: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      provincesData: this.handleProvincesData(),
	      alphanumeric: this.handleAlphanumericData(),
	      isShow: this.show,
	      currentTouchStart: '' };
	  },

	  watch: {
	    show: function show(newValue, oldValue) {
	      this.isShow = newValue;
	    },
	    isShow: function isShow(newValue, oldValue) {
	      if (newValue) {
	        var mask = document.querySelector('.vux-popup-mask');
	        mask.style.background = 'rgba(0,0,0,0)';
	        mask.style.display = 'none';
	        this.$emit('on-show');
	      } else {
	        var _mask = document.querySelector('.vux-popup-mask');
	        _mask.style.background = 'rgba(0, 0, 0, 0.6)';
	        _mask.style.display = 'block';
	        this.$emit('on-hide');
	      }
	      this.$emit('change', newValue);
	    }
	  }
	};

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = [{"code":"110000","value":"京","name":"北京"},{"code":"120000","value":"津","name":"天津市"},{"code":"130000","value":"冀","name":"河北省"},{"code":"140000","value":"晋","name":"山西省"},{"code":"150000","value":"蒙","name":"内蒙古自治区"},{"code":"210000","value":"辽","name":"辽宁省"},{"code":"220000","value":"吉","name":"吉林省"},{"code":"230000","value":"黑","name":"黑龙江省"},{"code":"310000","value":"沪","name":"上海市"},{"code":"320000","value":"苏","name":"江苏省"},{"code":"330000","value":"浙","name":"浙江省"},{"code":"340000","value":"皖","name":"安徽省"},{"code":"350000","value":"闽","name":"福建省"},{"code":"360000","value":"赣","name":"江西省"},{"code":"370000","value":"鲁","name":"山东省"},{"code":"410000","value":"豫","name":"河南省"},{"code":"420000","value":"鄂","name":"湖北省"},{"code":"430000","value":"湘","name":"湖南省"},{"code":"440000","value":"粤","name":"广东省"},{"code":"450000","value":"桂","name":"广西壮族自治区"},{"code":"460000","value":"琼","name":"海南省"},{"code":"500000","value":"渝","name":"重庆市"},{"code":"510000","value":"川","name":"四川省"},{"code":"520000","value":"贵","name":"贵州省"},{"code":"530000","value":"云","name":"云南省"},{"code":"540000","value":"藏","name":"西藏自治区"},{"code":"610000","value":"陕","name":"陕西省"},{"code":"620000","value":"甘","name":"甘肃省"},{"code":"630000","value":"青","name":"青海省"},{"code":"640000","value":"宁","name":"宁夏回族自治区"},{"code":"650000","value":"新","name":"新疆维吾尔自治区"}]

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = [0,1,2,3,4,5,6,7,8,9,"Q","W","E","R","T","Y","U","I","O","P","A","S","D","F","G","H","J","K","L","delete","Z","X","C","V","B","N","M","end"]

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var on = exports.on = function () {
	  if (document.addEventListener) {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	}();

	var off = exports.off = function () {
	  if (document.removeEventListener) {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	}();

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.type === 'provinces') ? _c('popup', {
	    attrs: {
	      "position": "bottom"
	    },
	    model: {
	      value: (_vm.isShow),
	      callback: function($$v) {
	        _vm.isShow = $$v
	      },
	      expression: "isShow"
	    }
	  }, [_c('div', {
	    staticClass: "keyboard-content"
	  }, _vm._l((_vm.provincesData), function(i, index) {
	    return _c('ul', {
	      key: index,
	      staticClass: "keyboard-list"
	    }, _vm._l((i), function(item, itemIndex) {
	      return _c('li', {
	        key: itemIndex,
	        class: {
	          'touch-start': _vm.currentTouchStart === item.value
	        },
	        on: {
	          "click": function($event) {
	            _vm.clickKey(item.value, 'provinces')
	          },
	          "touchstart": function($event) {
	            _vm.handleTouchStart(item.value)
	          },
	          "touchend": function($event) {
	            _vm.handleTouchEnd(item.value)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(item.value) + "\n        ")])
	    }))
	  }))]) : _vm._e(), (_vm.type === 'alphanumeric') ? _c('popup', {
	    attrs: {
	      "position": "bottom"
	    },
	    model: {
	      value: (_vm.isShow),
	      callback: function($$v) {
	        _vm.isShow = $$v
	      },
	      expression: "isShow"
	    }
	  }, [_c('div', {
	    staticClass: "keyboard-content"
	  }, _vm._l((_vm.alphanumeric), function(i, index) {
	    return _c('ul', {
	      key: index,
	      staticClass: "keyboard-list"
	    }, _vm._l((i), function(item, itemIndex) {
	      return _c('li', {
	        key: itemIndex,
	        class: {
	          'delete': item === 'delete',
	            'touch-start': _vm.currentTouchStart === item,
	            'end': item === 'end'
	        },
	        on: {
	          "click": function($event) {
	            _vm.clickKey(item, 'alphanumeric')
	          },
	          "touchstart": function($event) {
	            _vm.handleTouchStart(item)
	          },
	          "touchend": function($event) {
	            _vm.handleTouchEnd(item)
	          }
	        }
	      }, [_vm._v("\n          " + _vm._s(_vm.showItem(item)) + "\n          "), (item === 'delete') ? _c('img', {
	        staticClass: "delete-icon",
	        attrs: {
	          "src": __webpack_require__(484)
	        }
	      }) : _vm._e()])
	    }))
	  }))]) : _vm._e(), _c('div', {
	    ref: "reference"
	  }, [_vm._t("reference")], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAoCAYAAACFFRgXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpkMTRhZmQyMi0yN2IxLTRmMzctYjhjMy1jNGFhY2Y0YWQ0MjUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0IyNkUyRkE0NzcxMTFFOEJDNDRBNUVEREI2RTQ5NEMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0IyNkUyRjk0NzcxMTFFOEJDNDRBNUVEREI2RTQ5NEMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpkYmE2YjQwMS00OTE2LTRiYzAtYmYzZC1hNzRmYmExMjY0NGYiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo5MWZkZjczMy04YjQyLTExN2ItOWE4Yy1lZGIyZGZmYjFiZTAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz55WtZiAAACeUlEQVR42tSZT0gUURzH326oVIe1g3jQk51CRDFIqIupUFjqUUUQFMU6dBAPibcQrEMI4sGCpYtoJGRS4Z9V9CbqQRD/0CkI9qSCCP5BRev7w9/AsMzbZua9+bNf+IDsrMtnZ977zts3kbGJb0IhZeA1eAzyhZ6cgd9gFsTBjvlgVOGDW8EaaNIoS8kB90A32AQfwE1V4Xr+9lnC25BfF/gJst0KV4DPPsiaUwUG3QjTpfoBbgn/8wIUOxEuBAmQJ4LJDdBhVzgGplk6yDy1I0yXfwqUiOBTFLVxGWiCVYpwJPt/wsNcYaFJOuFe8FKELDLhFjAgQpiopKQ/gUgmCFMTTBq3QZd5B26DanCQ5n37fHKohd67ES7gro0pnoR+cAIWQY1Eep+PLYFT8MapMH3Lr5puDA9Nf69bSBuyG6bXHjkRNrq2QtMwmwDlEmkr2QfgixPhHs1dewcsSKStZBNOhiEJd3owmWXSSrKG8F2PGshK2rymTriZ4CR87mFtXjKpuQBXbnv4l0eyVhMsXXvYFo77JEvD4L6qNAmPgO8+yM6BeVXpKI+xZv5nHWmUyMZ4IlpJNzm909GttAEkNQivSGTN7ZEqvexmLUGyteBQUXiABZ9ZyKZKPwG54K3dD49YbFXRCmpGccXm63qYVlnt4G+mCFPGQF8mCRsL8ZFMEqa80tzRngsbHb0cEt8jOzs/J1x3myEQ/mN3b+2QpZMBCy842b1MctHvBSRLwzPudH+YnjfU8TDxOx/Blpsd+FWeiJc+ytLNrNtOS8hCVdfGvxy8zBWf2efGLyOVp0ij4vqx1zjY1Sh5DLbBECgV148KTo2D/wQYAEaPidxpK+a+AAAAAElFTkSuQmCC"

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _selectorList = __webpack_require__(486);

	var _selectorList2 = _interopRequireDefault(_selectorList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_selectorList2.default.install = function (Vue) {
	  Vue.component('LxSelectorList', _selectorList2.default);
	};

	exports.default = _selectorList2.default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(487)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(489),
	  /* template */
	  __webpack_require__(491),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(488);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2e88f816!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./selector-list.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2e88f816!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./selector-list.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "/* mixin */\n/* variable */\n/**\n* Before v1.0, the variable names may change anytime.\n*/\n/**\n* actionsheet\n*/\n/**\n * @color-wechat-green: #04BE02;\n */\n/**\n * @theme-color: #04BE02;\n */\n/**\n* tabbar\n*/\n/**\n* dialog\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* XHeader\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* Popover\n*/\n/* 窗口宽度<640,设计宽度=480 */\n/* 引入flexible.js */\n.selector-parent {\n  position: relative;\n}\n.selector-list {\n  position: absolute;\n  left: 0;\n  top: 0px;\n  bottom: 0;\n  right: 0;\n  background: #eee;\n}\n.selector-list input[type='radio'] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  opacity: 0;\n}\n.selector-list input[type='radio'] + .check_item_input {\n  opacity: 0;\n  position: relative;\n  z-index: 11;\n  width: 0.86rem;\n  height: 0.96rem;\n}\n.selector-list input[type='radio']:checked + .check_item_icon {\n  background: #509eff;\n  border: .08rem solid #fff;\n  box-shadow: 0 0 0 1px #509eff;\n}\n.selector-list .vux-label-desc {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  padding-right: 0.4rem;\n}\n.selector-list .weui_cell_ft {\n  width: 0.8rem;\n}\n.selector-list .check_item_icon {\n  position: absolute;\n  right: .4rem;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  width: .45333333rem;\n  height: .45333333rem;\n  border: 1px solid #e7e7e7;\n  border-radius: 50%;\n  box-sizing: border-box;\n}\n.selector-list .weui_cell_primary {\n  line-height: 24px;\n  overflow: hidden;\n}\n.selector-list .search_input .weui_input {\n  line-height: .66666667rem;\n}\n.selector-list .search_input {\n  background-color: #eee;\n  padding: .26666667rem .4rem;\n  font-size: 15px;\n  border-radius: .05333333rem;\n}\n.selector-list .search_input .weui_cell {\n  padding: .2rem .4rem;\n  background-color: #fff;\n}\n.selector-list .search_input .search_icon {\n  width: .53333333rem;\n  margin-bottom: -0.13333333rem;\n  margin-left: .13333333rem;\n}\n.selector-list .weui_cells_title {\n  padding-top: 0;\n}\n.selector-list .no-record {\n  margin: 0 auto;\n  padding: 3.33333333rem 0 .66666667rem;\n  text-align: center;\n  color: #000;\n  opacity: .4;\n  font-size: .4rem;\n}\n", ""]);

	// exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _toConsumableArray2 = __webpack_require__(490);

	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

	var _popup = __webpack_require__(235);

	var _popup2 = _interopRequireDefault(_popup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  components: {
	    popup: _popup2.default
	  },
	  props: {
	    title: {
	      type: String,
	      default: '请先让行政经理把门店人员添加到系统中'
	    },
	    names: {
	      type: String,
	      default: 'name'
	    },
	    roles: {
	      type: String,
	      default: 'roles'
	    },
	    roleList: {
	      type: Array,
	      required: true
	    }
	  },
	  computed: {},
	  methods: {
	    inputSearch: function inputSearch(value) {
	      if (value === '') {
	        this.roleNew = [].concat((0, _toConsumableArray3.default)(this.roleList));
	      }
	    },
	    valueSearch: function valueSearch(value) {
	      var _this = this;

	      if (!value) return;
	      this.roleNew = [];
	      this.roleList.forEach(function (v, i) {
	        var isExist = v[_this.names].indexOf(value);
	        if (isExist !== -1) {
	          _this.roleNew.push(v);
	        }
	      });
	    },
	    checkItem: function checkItem(item, index) {
	      this.roleList.find(function (v) {
	        v.ischecked = false;
	      });
	      this.roleNew.find(function (v) {
	        if (v.id === item.id) {
	          v.ischecked = true;
	        }
	      });
	      this.$set(this.roleNew, index, item);
	      this.$emit('check-item', item);
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.roleNew = [].concat((0, _toConsumableArray3.default)(this.roleList));
	  },
	  destroyed: function destroyed() {},
	  data: function data() {
	    return {
	      roleNew: [],
	      value: '',
	      ischecked: false
	    };
	  }
	};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/toConsumableArray");

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "selector-list"
	  }, [_c('div', {
	    staticClass: "search_input"
	  }, [_c('div', {
	    staticClass: "vux-x-input weui_cell"
	  }, [_c('div', {
	    staticClass: "weui_cell_hd"
	  }), _c('div', {
	    staticClass: "weui_cell_bd weui_cell_primary"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    staticClass: "weui_input",
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入姓名"
	    },
	    domProps: {
	      "value": (_vm.value)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value
	      }, function($event) {
	        _vm.inputSearch(_vm.value)
	      }]
	    }
	  })]), _c('div', {
	    staticClass: "weui_cell_ft",
	    on: {
	      "click": function($event) {
	        _vm.valueSearch(_vm.value)
	      }
	    }
	  }, [_c('img', {
	    staticClass: "search_icon",
	    attrs: {
	      "src": "data:image/png;base64,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"
	    }
	  })])])]), _c('div', {
	    staticClass: "weui_cells_title"
	  }, [_vm._v(_vm._s(_vm.title))]), (_vm.roleNew.length !== 0) ? _c('div', {
	    staticClass: "weui_cells"
	  }, _vm._l((_vm.roleNew), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "weui_cell vux-tap-active",
	      on: {
	        "click": function($event) {
	          _vm.checkItem(item, index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "weui_cell_hd"
	    }), _c('div', {
	      staticClass: "weui_cell_bd weui_cell_primary"
	    }, [_c('p', [_vm._v(_vm._s(item[_vm.names]))]), _c('span', {
	      staticClass: "vux-label-desc"
	    }, [_vm._v(_vm._s(item[_vm.roles]))]), _c('input', {
	      attrs: {
	        "type": "radio",
	        "name": "selectorradio"
	      },
	      domProps: {
	        "checked": item.ischecked
	      }
	    }), _c('i', {
	      staticClass: "check_item_icon"
	    })])])
	  })) : _c('div', {
	    staticClass: "no-record"
	  }, [_vm._v("\n    没有相关记录\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _steps = __webpack_require__(493);

	var _steps2 = _interopRequireDefault(_steps);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_steps2.default.install = function (Vue) {
	  Vue.component('LxSteps', _steps2.default);
	};

	exports.default = _steps2.default;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(494)

	var Component = __webpack_require__(79)(
	  /* script */
	  __webpack_require__(496),
	  /* template */
	  __webpack_require__(497),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)

	module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(495);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(78)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-953892e8!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./steps.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-953892e8!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./steps.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(68)();
	// imports


	// module
	exports.push([module.id, "\n.steps {\n  padding-bottom: 0.4rem;\n}\n.steps .steps_item {\n  position: relative;\n  padding: 0.4rem;\n}\n.steps .steps_item:before {\n  left: 1.06666667rem;\n}\n.steps .step_status {\n  background-color: #eee;\n  width: 0.48rem;\n  margin-right: 0.32rem;\n}\n.steps .step_status i.status_line {\n  position: absolute;\n  left: 0.64rem;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  transform: translateX(-50%);\n  background-color: #BEBEBE;\n}\n.steps .step_status i.status_line_blue {\n  background-color: #5890FF;\n}\n.steps .step_status i.icon {\n  position: absolute;\n  left: 0.49333333rem;\n  top: 0.49333333rem;\n  width: 0.32rem;\n  height: 0.32rem;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n}\n.steps .step_status i.original {\n  left: 0.56rem;\n  top: 0.56rem;\n  width: 0.16rem;\n  height: 0.16rem;\n  background-color: #BEBEBE;\n}\n.steps .step_status i.status_ok {\n  background-color: #5890FF;\n}\n.steps .step_status i.status_ok:after {\n  content: \" \";\n  position: absolute;\n  left: 0.06666667rem;\n  top: 0.08rem;\n  width: 0.13333333rem;\n  height: 0.08rem;\n  border-left: 0.04rem solid #fff;\n  border-bottom: 0.04rem solid #fff;\n  transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n}\n.steps .step_status i.status_no {\n  box-shadow: 0 0 0 0.08rem #FDB2B2;\n  -webkit-box-shadow: 0 0 0 0.08rem #FDB2B2;\n  background-color: #FB3F3F;\n  transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n}\n.steps .step_status i.status_no:before {\n  content: \" \";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 0.21333333rem;\n  height: 0.05333333rem;\n  background-color: #fff;\n  transform: translate(-50%, -50%);\n}\n.steps .step_status i.status_no:after {\n  content: \" \";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 0.05333333rem;\n  height: 0.21333333rem;\n  background-color: #fff;\n  transform: translate(-50%, -50%);\n}\n.steps .step_status i.status_waiting {\n  box-shadow: 0 0 0 0.08rem #CDDDFF;\n  -webkit-box-shadow: 0 0 0 0.08rem #CDDDFF;\n  background-color: #5890FF;\n}\n.steps .steps_item:first-child i.status_line {\n  top: 0.56rem;\n}\n.steps .steps_item:last-child i.status_line {\n  height: 0.56rem;\n}\n.steps .step_info {\n  font-size: 0.34666667rem;\n  line-height: 0.53333333rem;\n  color: #9a9a9a;\n}\n.steps .step_info .step_title_info {\n  padding-bottom: 0.06666667rem;\n}\n.steps .step_info .step_title {\n  color: #000;\n}\n.steps .step_info .step_frKey {\n  float: right;\n}\n.steps .step_info .i_phone {\n  color: #5890ff;\n}\n", ""]);

	// exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _group = __webpack_require__(151);

	var _group2 = _interopRequireDefault(_group);

	var _cell = __webpack_require__(118);

	var _cell2 = _interopRequireDefault(_cell);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    frKey: {
	      type: String,
	      default: ''
	    },
	    title: {
	      type: String,
	      default: '审核流程'
	    },
	    steps: {
	      type: Array,
	      default: []
	    }
	  },
	  components: {
	    Group: _group2.default,
	    Cell: _cell2.default
	  },
	  data: function data() {
	    return {
	      iconClass: {
	        pending_review: 'status_waiting',
	        approved: 'status_ok',
	        rejected: 'status_no',
	        not_started: 'original'
	      }
	    };
	  }
	};

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('group', {
	    staticClass: "steps",
	    attrs: {
	      "title": _vm.title
	    }
	  }, _vm._l((_vm.steps), function(step, index) {
	    return _c('cell', {
	      key: index,
	      staticClass: "steps_item",
	      attrs: {
	        "bdStart": true
	      }
	    }, [_c('div', {
	      staticClass: "step_status",
	      attrs: {
	        "slot": "icon"
	      },
	      slot: "icon"
	    }, [_c('i', {
	      staticClass: "status_line",
	      class: {
	        'status_line_blue': step.status !== 'not_started'
	      }
	    }), _c('i', {
	      staticClass: "icon",
	      class: _vm.iconClass[step.status]
	    })]), _c('div', {
	      staticClass: "step_info",
	      attrs: {
	        "slot": "after-title"
	      },
	      slot: "after-title"
	    }, [_c('div', {
	      staticClass: "step_title_info"
	    }, [_c('span', {
	      staticClass: "step_title"
	    }, [_vm._v(_vm._s(step.title))]), (_vm.frKey) ? _c('span', {
	      staticClass: "step_frKey"
	    }, [_vm._v(_vm._s(step[_vm.frKey]))]) : _vm._e()]), _vm._t("default", null, {
	      step: step
	    })], 2)])
	  }))
	},staticRenderFns: []}

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/cvux/lib/cvux.common.js
// module id = e55a
// module chunks = 4